(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9993],{

/***/ 17362:
/***/ (function(module) {

const doc = [({"en":({"signInFormDescription":"Please login with the e-mail address you use to communicate with the operator.\n After logging in, you can [Reservation Application|Search]. ", "signInFormPasswordDescription":"Please enter a new password to register or a password you have already registered"})})];
module.exports = doc.length <= 1 ? doc[0] : doc;

/***/ }),

/***/ 8534:
/***/ (function(module) {

const doc = [({"ja":({"signInFormDescription":"オペレーターとやり取りしているメールアドレスでログインしてください。\n ログイン後に [ 予約申込 | 検索 ] ができます。 ", "signInFormPasswordDescription":"新規登録するパスワード、または登録済みのパスワードを入力してください"})})];
module.exports = doc.length <= 1 ? doc[0] : doc;

/***/ }),

/***/ 94085:
/***/ (function(module) {

const doc = [({"en":({"email":"Email", "password":"Password"})})];
module.exports = doc.length <= 1 ? doc[0] : doc;

/***/ }),

/***/ 753:
/***/ (function(module) {

const doc = [({"ja":({"email":"メール", "password":"パスワード"})})];
module.exports = doc.length <= 1 ? doc[0] : doc;

/***/ }),

/***/ 50630:
/***/ (function(module) {

const doc = [({"en":({"errors":({"format":"{{label}} {{message}}", "groupFormat":"{{group}} {{label}}", "messages":({"accepted":"must be accepted", "arrayTooFew":"is more necessary", "blank":"can't be blank", "cannotCancel":"Cannot be canceled", "cannotConfirmed":"Cannot confirm reservation", "cannotMarkConfirmed":"Cannot mark confirmed", "cannotMarkTicketed":"Cannot mark ticketed", "cannotMarkVoid":"Cannot mark VOID", "cannotMarkWaitingForArrangement":"Cannot mark waiting_for_arrangement", "cannotMarkWaitingForConfirmation":"Cannot mark waiting_for_confirmation", "cannotRefund":"Cannot refund", "cannotRefunded":"Cannot be refunded", "cannotRefunding":"Cannot be done while requesting a refund", "cannotTicketed":"Cannot be issued", "check":"must be checked", "confirmation":"doesn't match {{label}}", "empty":"can't be empty", "equalTo":"must be equal to {{count}}", "even":"must be even", "exclusion":"is reserved", "formatInvalid":"is not in the correct format", "greaterThan":"must be greater than {{count}}", "greaterThanOrEqualTo":"must be greater than or equal to {{count}}", "greaterThanOrEqualToMinValue":"must be greater than or equal to min value", "greaterThanToDaysAgo":"Should be greater than the period (up to X days ago)", "inclusion":"is not included in the list", "invalid":"is invalid", "katakana":"must be full-width katakana", "lessThan":"must be less than {{count}}", "lessThanOrEqualTo":"must be less than or equal to {{count}}", "notANumber":"is not a number", "notAPositive":"must be a positive number", "notAnInteger":"must be an integer", "odd":"must be odd", "onlyNumberAlphabetUnderscoreHyphen":"can only be used with alphabet and numbers and _ -", "onlyNumberLowercaseUnderscoreHyphen":"can only be used with lowercase letters and numbers and _ -", "otherThan":"must be other than {{count}}", "present":"must be blank", "recordInvalid":"Validation failed: {{errors}}", "required":"must exist", "restrictDependentDestroy_one":"Cannot delete record because a dependent {{count}} exists", "restrictDependentDestroy_other":"Cannot delete record because dependent {{count}} exists", "taken":"has already been taken", "tooLong_one":"is too long (maximum is 1 character)", "tooLong_other":"is too long (maximum is {{count}} characters)", "tooShort_one":"is too short (minimum is 1 character)", "tooShort_other":"is too short (minimum is {{count}} characters)", "wrongLength_one":"is the wrong length (should be 1 character)", "wrongLength_other":"is the wrong length (should be {{count}} characters)", "infantsNumber":"Number of infants shall not exceed the number of adults"})}), "labels":({"reservation":({"cardCvc":"Security Code", "cardExpireMonth":"Expire Month", "cardExpireYear":"Expire Year", "cardName":"Credit Card Name", "cardNumber":"Credit Card No", "isAcceptance":"Accept the terms"})}), "placeholders":({"common":({"addressPlaceholder":"123 xxx xxx Tokyo", "channelManagerCode":"ABC123", "codePlaceholder":"Enter code", "emailPlaceholder":"Enter email", "imagePlaceholder":"Drop a image here or click to select", "largerNumberPlaceholder":"12345", "max":"Max", "min":"Min", "namePlaceholder":"John Smith", "numberPlaceholder":"1", "passwordPlaceholder":"Enter password", "pdfPlaceholder":"Drop a PDF here or click to select", "phoneNumberPlaceholder":"No hyphen", "websitePlaceholder":"https://"}), "company":({"bankAccountNamePlaceholder":"Enter kana", "bankBranchNamePlaceholder":"XXXXX Branch", "bankNamePlaceholder":"XXXXX Bank", "codePlaceholder":"Only lowercase letters, numbers, and _ are allowed", "namePlaceholder":"XXXXX Ltd."}), "flight":({"originPlaceholder":"City or airport name"}), "hotel":({"Placeholder":"Please describe the items to be notified to the customer at the time of booking (blank is possible)", "channelManagerCode":"ABC123", "codePlaceholder":"Only lowercase letters, numbers, and _ are allowed", "destinationPlaceholder":"Enter destination or hotel name", "notesOnChildrenPlaceholder":"Please indicate these, If there are any precautions regarding children's accommodation(can be left blank)", "notesPlaceholder":"Please describe any initial information that should be provided to the customer (can be left blank)", "noticePlaceholder":"Please describe the notes to be displayed at the time of booking (can be left blank)"}), "hotelCancelPolicy":({"percentPlaceholder":"1 - 100"}), "hotelPlan":({"noticePlaceholder":"Please describe the notes to be displayed at the time of booking (can be left blank)"}), "promotion":({"namePlaceholder":"XXXX Promotion"})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;

/***/ }),

/***/ 83559:
/***/ (function(module) {

const doc = [({"ja":({"labels":({"reservation":({"cardNumber":"カード番号", "cardName":"カード名義", "cardCvc":"セキュリティコード", "cardExpireMonth":"有効期限(月)", "cardExpireYear":"有効期限(年)", "isAcceptance":"規約に同意"})}), "placeholders":({"common":({"emailPlaceholder":"メールアドレスを入力してください", "passwordPlaceholder":"パスワードを入力してください", "codePlaceholder":"コードを入力してください", "namePlaceholder":"山田 太郎", "addressPlaceholder":"東京都港区〇〇町〇〇", "phoneNumberPlaceholder":"ハイフンなし", "websitePlaceholder":"https://", "imagePlaceholder":"画像をドロップもしくはクリックして選択", "pdfPlaceholder":"PDFをドロップもしくはクリックして選択", "numberPlaceholder":"1", "largerNumberPlaceholder":"12345", "channelManagerCode":"ABC123", "max":"最大", "min":"最小"}), "company":({"namePlaceholder":"〇〇株式会社", "codePlaceholder":"半角英数字小文字と_のみ", "bankNamePlaceholder":"〇〇銀行", "bankBranchNamePlaceholder":"〇〇支店", "bankAccountNamePlaceholder":"全角カナで入力してください"}), "flight":({"originPlaceholder":"都市名または空港名"}), "hotel":({"codePlaceholder":"半角英数字小文字と_-のみ", "destinationPlaceholder":"目的地またはホテル名を入力", "noticePlaceholder":"予約時にお客様にお知らせすべき事項がありましたら記載してください(空欄可能)", "notesPlaceholder":"お客様に最初にお知らせすべき事項がありましたら記載してください(空欄可能)", "notesOnChildrenPlaceholder":"お子様の宿泊に関して注意事項がありましたら記載してください(空欄可能)", "Placeholder":"予約時にお客様にお知らせすべき事項を記載してください(空欄可能)", "channelManagerCode":"ABC123"}), "hotelCancelPolicy":({"percentPlaceholder":"1 - 100"}), "hotelPlan":({"noticePlaceholder":"予約時にお客様にお知らせすべき事項がありましたら記載してください(空欄可能)"}), "promotion":({"namePlaceholder":"〇〇プロモーション"})}), "errors":({"format":"{{label}}{{message}}", "groupFormat":"{{group}}の{{label}}", "messages":({"accepted":"を受諾してください", "blank":"を入力してください", "present":"は入力しないでください", "confirmation":"と {{label}}の入力が一致しません", "empty":"を入力してください", "required":"は存在している必要があります", "equalTo":"は {{count}}にしてください", "even":"は偶数にしてください", "exclusion":"は予約されています", "greaterThan":"は {{count}}より大きい値にしてください", "greaterThanOrEqualTo":"は {{count}}以上の値にしてください", "inclusion":"は一覧にありません", "invalid":"は不正な値です", "cannotRefund":"返金するのができません", "cannotMarkVoid":"VOIDにするのができません", "cannotMarkTicketed":"発券ができません", "cannotMarkWaitingForConfirmation":"催行待ちにできません", "cannotMarkWaitingForArrangement":"手配待ちにできません", "cannotMarkConfirmed":"予約確定にできません", "cannotCancel":"キャンセルできません", "cannotTicketed":"発券済みにできません", "cannotConfirmed":"予約確定にできません", "cannotRefunded":"返金済みにできません", "cannotRefunding":"返金依頼中にできません", "lessThan":"は {{count}}より小さい値にしてください", "lessThanOrEqualTo":"は {{count}}以下の値にしてください", "notANumber":"は数値で入力してください", "notAnInteger":"は整数で入力してください", "notAPositive":"は正の数で入力してください", "odd":"は奇数にしてください", "recordInvalid":"バリデーションに失敗しました {{errors}}", "restrictDependentDestroy_one":"{{count}}が存在しているので削除できません", "restrictDependentDestroy_other":"{{count}}が存在しているので削除できません", "taken":"はすでに存在します", "tooLong_one":"は {{count}}文字以内で入力してください", "tooLong_other":"は {{count}}文字以内で入力してください", "tooShort_one":"は {{count}}文字以上で入力してください", "tooShort_other":"は {{count}}文字以上で入力してください", "wrongLength_one":"は {{count}}文字で入力してください", "wrongLength_other":"は {{count}}文字で入力してください", "otherThan":"は {{count}}以外の値にしてください", "formatInvalid":"の形式が正しくありません", "arrayTooFew":"の選択数が不足しています", "onlyNumberLowercaseUnderscoreHyphen":"は英数字小文字と_-のみ使用できます", "onlyNumberAlphabetUnderscoreHyphen":"は英数字と_-のみ使用できます", "greaterThanToDaysAgo":"は 期間(X日前まで)より大きい値にしてください", "check":"をチェックしてください", "katakana":"は全角カタカナで入力してください", "greaterThanOrEqualToMinValue":"は 最小値以上の値にしてください", "infantsNumber":"1歳以下の幼児は大人の数以下にしてください"})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;

/***/ }),

/***/ 35399:
/***/ (function(module) {

const doc = [({"en":({"indexTitle":"Email User Registration"})})];
module.exports = doc.length <= 1 ? doc[0] : doc;

/***/ }),

/***/ 5760:
/***/ (function(module) {

const doc = [({"ja":({"indexTitle":"メールユーザー登録"})})];
module.exports = doc.length <= 1 ? doc[0] : doc;

/***/ }),

/***/ 20531:
/***/ (function(module) {

const doc = [({"en":({"indexTitle":"In-house notice"})})];
module.exports = doc.length <= 1 ? doc[0] : doc;

/***/ }),

/***/ 16461:
/***/ (function(module) {

const doc = [({"ja":({"indexTitle":"社内通知"})})];
module.exports = doc.length <= 1 ? doc[0] : doc;

/***/ }),

/***/ 97287:
/***/ (function(module) {

const doc = [({"en":({"indexTitle":"LP contents list", "newTitle":"Create LP contents", "editTitle":"Edit LP contents"})})];
module.exports = doc.length <= 1 ? doc[0] : doc;

/***/ }),

/***/ 7094:
/***/ (function(module) {

const doc = [({"ja":({"indexTitle":"LPコンテンツ一覧", "newTitle":"LPコンテンツ作成", "editTitle":"LPコンテンツ編集"})})];
module.exports = doc.length <= 1 ? doc[0] : doc;

/***/ }),

/***/ 64495:
/***/ (function(module) {

const doc = [({"en":({"postEmailChatUnit":"Registered email user"})})];
module.exports = doc.length <= 1 ? doc[0] : doc;

/***/ }),

/***/ 56296:
/***/ (function(module) {

const doc = [({"ja":({"postEmailChatUnit":"メールユーザーを登録しました"})})];
module.exports = doc.length <= 1 ? doc[0] : doc;

/***/ }),

/***/ 6737:
/***/ (function(module) {

const doc = [({"en":({"draft":"Draft", "published":"Schedules", "processing":"Processing", "done":"Done"})})];
module.exports = doc.length <= 1 ? doc[0] : doc;

/***/ }),

/***/ 278:
/***/ (function(module) {

const doc = [({"ja":({"draft":"下書き", "published":"配信予定", "processing":"処理中", "done":"完了"})})];
module.exports = doc.length <= 1 ? doc[0] : doc;

/***/ }),

/***/ 90263:
/***/ (function(module) {

const doc = [({"en":({"tpi":"TPI", "trip":"Trip", "his":"HIS", "surprice":"Surprice", "expedia":"Expedia", "arc":"Arc", "kronos":"Kronos", "airline":"Airline HP", "other":"Other"})})];
module.exports = doc.length <= 1 ? doc[0] : doc;

/***/ }),

/***/ 35675:
/***/ (function(module) {

const doc = [({"ja":({"tpi":"TPI", "trip":"Trip", "his":"HIS", "surprice":"Surprice", "expedia":"Expedia", "airline":"航空会社HP", "other":"その他", "arc":"Arc", "kronos":"Kronos"})})];
module.exports = doc.length <= 1 ? doc[0] : doc;

/***/ }),

/***/ 32924:
/***/ (function(module) {

const doc = [({"en":({"paymentNotify":"Aggregate deposits made half a month prior to the base date.", "flightArrangementNotifyFness":"Aggregate payments for the week prior to the base date.", "flightArrangementNotify":"All flight payments based on the date of deposit", "hotelArrangementNotifyRikisha":"Aggregate payments made half a month prior to the base date.", "hotelArrangementNotify":"All hotel payments based on the date of deposit", "optionalTourArrangementNotify":"All optional tour payments based on the date of deposit", "railwayArrangementNotify":"All rail payments based on the date of deposit", "saleAndCostNotifyBeforeReturnDate":"After payment is determined by starting from the base date and before the return date.", "saleAndCostNotify":"Sales/Expenses based on return date", "saleAndCostNotifyAll":"Data with return date for all payments and deposits", "saleAndCostNotifyBasedOnAggregateDate":"Data with return date of payments and deposits for one year from the base date"})})];
module.exports = doc.length <= 1 ? doc[0] : doc;

/***/ }),

/***/ 35999:
/***/ (function(module) {

const doc = [({"ja":({"paymentNotify":"基準日の半月前の入金を集計します", "flightArrangementNotifyFness":"基準日の前週の支払いを集計します", "hotelArrangementNotifyRikisha":"基準日の半月前の支払いを集計します", "saleAndCostNotifyBeforeReturnDate":"基準日を起点に帰国日前で入金後を判定します"})})];
module.exports = doc.length <= 1 ? doc[0] : doc;

/***/ }),

/***/ 99477:
/***/ (function(module) {

const doc = [({"en":({"paymentNotify":"Customer Settlement Amount Based on the Date of Deposit", "flightArrangementNotifyFness":"Amount paid to Gallant (Flight) based on the date of deposit", "flightArrangementNotify":"All flight payments based on the date of deposit", "hotelArrangementNotifyRikisha":"Amount payable to Rikisha (hotel) based on the date of deposit", "hotelArrangementNotify":"All hotel payments based on the date of deposit", "optionalTourArrangementNotify":"All optional tour payments based on the date of deposit", "railwayArrangementNotify":"All rail payments based on the date of deposit", "saleAndCostNotify":"Sales/Expenses based on return date", "saleAndCostNotifyBeforeReturnDate":"Deposit/payment amount before and after return date"})})];
module.exports = doc.length <= 1 ? doc[0] : doc;

/***/ }),

/***/ 50704:
/***/ (function(module) {

const doc = [({"ja":({"paymentNotify":"入金日基準のお客様決済額", "flightArrangementNotifyFness":"入金日基準のギャラン(フライト)への支払い額", "flightArrangementNotify":"入金日基準の全てのフライト支払い額", "hotelArrangementNotifyRikisha":"入金日基準のRikisha(ホテル)への支払い額", "hotelArrangementNotify":"入金日基準の全てのホテル支払い額", "optionalTourArrangementNotify":"入金日基準の全てのオプショナルツアー支払い額", "railwayArrangementNotify":"入金日基準の全ての鉄道支払い額", "saleAndCostNotify":"帰国日基準の売上/費用", "saleAndCostNotifyBeforeReturnDate":"帰国日前、入金後の入金/支払い額", "saleAndCostNotifyAll":"全ての支払い、入金の帰国日つきのデータ", "saleAndCostNotifyBasedOnAggregateDate":"基準日から1年間の支払い、入金の帰国日付きデータ"})})];
module.exports = doc.length <= 1 ? doc[0] : doc;

/***/ }),

/***/ 57503:
/***/ (function(module) {

const doc = [({"en":({"pattern1":"Search form, Main image", "pattern2":"Main image, Search form"})})];
module.exports = doc.length <= 1 ? doc[0] : doc;

/***/ }),

/***/ 73900:
/***/ (function(module) {

const doc = [({"ja":({"pattern1":"検索フォーム, メイン画像", "pattern2":"メイン画像、検索フォーム"})})];
module.exports = doc.length <= 1 ? doc[0] : doc;

/***/ }),

/***/ 59795:
/***/ (function(module) {

const doc = [({"en":({"travel":"Travel", "multiCity":"Multi city"})})];
module.exports = doc.length <= 1 ? doc[0] : doc;

/***/ }),

/***/ 85483:
/***/ (function(module) {

const doc = [({"ja":({"travel":"トラベル", "multiCity":"周遊"})})];
module.exports = doc.length <= 1 ? doc[0] : doc;

/***/ }),

/***/ 93551:
/***/ (function(module) {

const doc = [({"en":({"priceCents":"Payment price", "priceCurrency":"Currency", "paymentDate":"Payment date", "billerType":"Biller", "billerReservationNumber":"Reservation number of Biller", "paymentType":"Payment type", "billerCountryCode":"Biller's country code", "billerName":"Biller company name", "travelerIds":"Travelers", "excludedFromPrice":"Refunds to user", "hotelArrangementPlanIds":"Room", "reservationNumber":"Reservation number", "optionalTourArrangementUserIds":"Travelers", "railwayArrangementUserIds":"Travelers", "deadlineDate":"Deadline", "deadlineHour":"Deadline(Hour)", "deadlineMinute":"Deadline(Minute)", "deadlineSecond":"Deadline(Second)"})})];
module.exports = doc.length <= 1 ? doc[0] : doc;

/***/ }),

/***/ 13029:
/***/ (function(module) {

const doc = [({"ja":({"priceCents":"支払金額", "priceCurrency":"通貨", "billerReservationNumber":"請求元の予約番号", "paymentDate":"支払日", "recordedDate":"計上日", "paymentType":"支払いタイプ", "billerType":"請求元", "billerCountryCode":"請求元の国コード", "billerName":"請求元会社名", "travelerIds":"旅行者", "excludedFromPrice":"ユーザーへの返金", "hotelArrangementPlanIds":"部屋", "reservationNumber":"予約番号", "optionalTourArrangementUserIds":"旅行者", "railwayArrangementUserIds":"旅行者", "deadlineDate":"期限日", "deadlineHour":"期限(時間)", "deadlineMinute":"期限(分)", "deadlineSecond":"期限(秒)"})})];
module.exports = doc.length <= 1 ? doc[0] : doc;

/***/ }),

/***/ 33458:
/***/ (function(module) {

const doc = [({"en":({"refundedAmountCents":"Refund amount from supplier", "refundedAmountCurrency":"Refund amount currency", "refundFeeCents":"Refund fee amount we receive", "refundFeeCurrency":"Refund fee currency", "refundedDate":"Refund receipt date", "cancellationPenaltyCents":"Cancellation charge including ticketing company fee", "cancellationPenaltyCurrency":"Cancellation fee currency", "paymentType":"Refund type", "billerType":"Biller", "billerReservationNumber":"Reservation number of Biller", "billerCountryCode":"Biller's country code", "billerName":"Biller company name", "travelerIds":"Travelers", "hotelArrangementPlanIds":"Room", "optionalTourArrangementUserIds":"Travelers", "railwayArrangementUserIds":"Travelers"})})];
module.exports = doc.length <= 1 ? doc[0] : doc;

/***/ }),

/***/ 26764:
/***/ (function(module) {

const doc = [({"ja":({"refundedAmountCents":"サプライヤーからの返金額", "refundedAmountCurrency":"返金額の通貨", "refundFeeCents":"弊社が受取る返金手数料", "refundFeeCurrency":"返金手数料の通貨", "refundedDate":"返金着金日", "cancellationPenaltyCents":"キャンセル料(発券会社の手数料含む)", "cancellationPenaltyCurrency":"キャンセル料の通貨", "paymentType":"返金方法", "billerType":"請求元", "billerCountryCode":"請求元の国コード", "billerName":"請求元会社名", "billerReservationNumber":"請求元の予約番号", "travelerIds":"旅行者", "hotelArrangementPlanIds":"部屋", "optionalTourArrangementUserIds":"旅行者", "railwayArrangementUserIds":"旅行者"})})];
module.exports = doc.length <= 1 ? doc[0] : doc;

/***/ }),

/***/ 81847:
/***/ (function(module) {

const doc = [({"en":({"image":"Image", "externalImage":"External Image", "pdf":"PDF", "freeText":"Text", "priceCents":"Price", "feeCents":"Fee", "externalPrice":"Price", "externalArrangeFee":"Arrangement fee", "externalArrangementType":"Arrangement type", "externalUrl":"URL", "externalMemo":"Memo", "externalArrangeFeeCurrency":"Currency", "externalPriceCurrency":"Currency"})})];
module.exports = doc.length <= 1 ? doc[0] : doc;

/***/ }),

/***/ 10413:
/***/ (function(module) {

const doc = [({"ja":({"image":"画像", "externalImage":"外部画像", "pdf":"PDF", "freeText":"テキスト", "priceCents":"料金", "feeCents":"手数料", "externalPrice":"料金", "externalArrangeFee":"手数料", "externalArrangementType":"手配タイプ", "externalUrl":"URL", "externalMemo":"メモ", "externalArrangeFeeCurrency":"通貨", "externalPriceCurrency":"通貨"})})];
module.exports = doc.length <= 1 ? doc[0] : doc;

/***/ }),

/***/ 15237:
/***/ (function(module) {

const doc = [({"en":({"platformId":"Platform ID", "name":"Name", "subject":"Subject", "text":"Text"})})];
module.exports = doc.length <= 1 ? doc[0] : doc;

/***/ }),

/***/ 38740:
/***/ (function(module) {

const doc = [({"ja":({"platformId":"プラットフォームID", "name":"氏名", "subject":"件名", "text":"本文"})})];
module.exports = doc.length <= 1 ? doc[0] : doc;

/***/ }),

/***/ 80347:
/***/ (function(module) {

const doc = [({"en":({"errors":({"format":"{{label}} {{message}}", "groupFormat":"{{group}} {{label}}", "messages":({"accepted":"must be accepted", "arrayTooFew":"is more necessary", "blank":"can't be blank", "cannotCancel":"Cannot be canceled", "cannotConfirmed":"Cannot confirm reservation", "cannotMarkConfirmed":"Cannot mark confirmed", "cannotMarkTicketed":"Cannot mark ticketed", "cannotMarkVoid":"Cannot mark VOID", "cannotMarkWaitingForArrangement":"Cannot mark waiting_for_arrangement", "cannotMarkWaitingForConfirmation":"Cannot mark waiting_for_confirmation", "cannotRefund":"Cannot refund", "cannotRefunded":"Cannot be refunded", "cannotRefunding":"Cannot be done while requesting a refund", "cannotTicketed":"Cannot be issued", "check":"must be checked", "confirmation":"doesn't match {{label}}", "empty":"can't be empty", "equalTo":"must be equal to {{count}}", "even":"must be even", "exclusion":"is reserved", "formatInvalid":"is not in the correct format", "greaterThan":"must be greater than {{count}}", "greaterThanOrEqualTo":"must be greater than or equal to {{count}}", "greaterThanOrEqualToMinValue":"must be greater than or equal to min value", "greaterThanToDaysAgo":"Should be greater than the period (up to X days ago)", "inclusion":"is not included in the list", "invalid":"is invalid", "katakana":"must be full-width katakana", "lessThan":"must be less than {{count}}", "lessThanOrEqualTo":"must be less than or equal to {{count}}", "notANumber":"is not a number", "notAPositive":"must be a positive number", "notAnInteger":"must be an integer", "odd":"must be odd", "onlyNumberAlphabetUnderscoreHyphen":"can only be used with alphabet and numbers and _ -", "onlyNumberLowercaseUnderscoreHyphen":"can only be used with lowercase letters and numbers and _ -", "otherThan":"must be other than {{count}}", "present":"must be blank", "recordInvalid":"Validation failed: {{errors}}", "required":"must exist", "restrictDependentDestroy_one":"Cannot delete record because a dependent {{count}} exists", "restrictDependentDestroy_other":"Cannot delete record because dependent {{count}} exists", "taken":"has already been taken", "tooLong_one":"is too long (maximum is 1 character)", "tooLong_other":"is too long (maximum is {{count}} characters)", "tooShort_one":"is too short (minimum is 1 character)", "tooShort_other":"is too short (minimum is {{count}} characters)", "wrongLength_one":"is the wrong length (should be 1 character)", "wrongLength_other":"is the wrong length (should be {{count}} characters)"})}), "labels":({"reservation":({"cardCvc":"Security Code", "cardExpireMonth":"Expire Month", "cardExpireYear":"Expire Year", "cardName":"Credit Card Name", "cardNumber":"Credit Card No", "isAcceptance":"Accept the terms"})}), "placeholders":({"common":({"addressPlaceholder":"123 xxx xxx Tokyo", "channelManagerCode":"ABC123", "codePlaceholder":"Enter code", "emailPlaceholder":"Enter email", "imagePlaceholder":"Drop a image here or click to select", "largerNumberPlaceholder":"12345", "max":"Max", "min":"Min", "namePlaceholder":"John Smith", "numberPlaceholder":"1", "passwordPlaceholder":"Enter password", "pdfPlaceholder":"Drop a PDF here or click to select", "phoneNumberPlaceholder":"No hyphen", "websitePlaceholder":"https://"}), "company":({"bankAccountNamePlaceholder":"Enter kana", "bankBranchNamePlaceholder":"XXXXX Branch", "bankNamePlaceholder":"XXXXX Bank", "codePlaceholder":"Only lowercase letters, numbers, and _ are allowed", "namePlaceholder":"XXXXX Ltd."}), "hotel":({"Placeholder":"Please describe the items to be notified to the customer at the time of booking (blank is possible)", "channelManagerCode":"ABC123", "codePlaceholder":"Only lowercase letters, numbers, and _ are allowed", "notesOnChildrenPlaceholder":"Please indicate these, If there are any precautions regarding children's accommodation(can be left blank)", "notesPlaceholder":"Please describe any initial information that should be provided to the customer (can be left blank)", "noticePlaceholder":"Please describe the notes to be displayed at the time of booking (can be left blank)"}), "hotelCancelPolicy":({"percentPlaceholder":"1 - 100"}), "hotelPlan":({"noticePlaceholder":"Please describe the notes to be displayed at the time of booking (can be left blank)"}), "promotion":({"namePlaceholder":"XXXX Promotion"})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;

/***/ }),

/***/ 64516:
/***/ (function(module) {

const doc = [({"ja":({"labels":({"reservation":({"cardNumber":"カード番号", "cardName":"カード名義", "cardCvc":"セキュリティコード", "cardExpireMonth":"有効期限(月)", "cardExpireYear":"有効期限(年)", "isAcceptance":"規約に同意"})}), "placeholders":({"common":({"emailPlaceholder":"メールアドレスを入力してください", "passwordPlaceholder":"パスワードを入力してください", "codePlaceholder":"コードを入力してください", "namePlaceholder":"山田 太郎", "addressPlaceholder":"東京都港区〇〇町〇〇", "phoneNumberPlaceholder":"ハイフンなし", "websitePlaceholder":"https://", "imagePlaceholder":"画像をドロップもしくはクリックして選択", "pdfPlaceholder":"PDFをドロップもしくはクリックして選択", "numberPlaceholder":"1", "largerNumberPlaceholder":"12345", "channelManagerCode":"ABC123", "max":"最大", "min":"最小"}), "company":({"namePlaceholder":"〇〇株式会社", "codePlaceholder":"半角英数字小文字と_のみ", "bankNamePlaceholder":"〇〇銀行", "bankBranchNamePlaceholder":"〇〇支店", "bankAccountNamePlaceholder":"全角カナで入力してください"}), "hotel":({"codePlaceholder":"半角英数字小文字と_-のみ", "noticePlaceholder":"予約時にお客様にお知らせすべき事項がありましたら記載してください(空欄可能)", "notesPlaceholder":"お客様に最初にお知らせすべき事項がありましたら記載してください(空欄可能)", "notesOnChildrenPlaceholder":"お子様の宿泊に関して注意事項がありましたら記載してください(空欄可能)", "Placeholder":"予約時にお客様にお知らせすべき事項を記載してください(空欄可能)", "channelManagerCode":"ABC123"}), "hotelCancelPolicy":({"percentPlaceholder":"1 - 100"}), "hotelPlan":({"noticePlaceholder":"予約時にお客様にお知らせすべき事項がありましたら記載してください(空欄可能)"}), "promotion":({"namePlaceholder":"〇〇プロモーション"})}), "errors":({"format":"{{label}}{{message}}", "groupFormat":"{{group}}の{{label}}", "messages":({"accepted":"を受諾してください", "blank":"を入力してください", "present":"は入力しないでください", "confirmation":"と {{label}}の入力が一致しません", "empty":"を入力してください", "required":"は存在している必要があります", "equalTo":"は {{count}}にしてください", "even":"は偶数にしてください", "exclusion":"は予約されています", "greaterThan":"は {{count}}より大きい値にしてください", "greaterThanOrEqualTo":"は {{count}}以上の値にしてください", "inclusion":"は一覧にありません", "invalid":"は不正な値です", "cannotRefund":"返金するのができません", "cannotMarkVoid":"VOIDにするのができません", "cannotMarkTicketed":"発券ができません", "cannotMarkWaitingForConfirmation":"催行待ちにできません", "cannotMarkWaitingForArrangement":"手配待ちにできません", "cannotMarkConfirmed":"予約確定にできません", "cannotCancel":"キャンセルできません", "cannotTicketed":"発券済みにできません", "cannotConfirmed":"予約確定にできません", "cannotRefunded":"返金済みにできません", "cannotRefunding":"返金依頼中にできません", "lessThan":"は {{count}}より小さい値にしてください", "lessThanOrEqualTo":"は {{count}}以下の値にしてください", "notANumber":"は数値で入力してください", "notAnInteger":"は整数で入力してください", "notAPositive":"は正の数で入力してください", "odd":"は奇数にしてください", "recordInvalid":"バリデーションに失敗しました {{errors}}", "restrictDependentDestroy_one":"{{count}}が存在しているので削除できません", "restrictDependentDestroy_other":"{{count}}が存在しているので削除できません", "taken":"はすでに存在します", "tooLong_one":"は {{count}}文字以内で入力してください", "tooLong_other":"は {{count}}文字以内で入力してください", "tooShort_one":"は {{count}}文字以上で入力してください", "tooShort_other":"は {{count}}文字以上で入力してください", "wrongLength_one":"は {{count}}文字で入力してください", "wrongLength_other":"は {{count}}文字で入力してください", "otherThan":"は {{count}}以外の値にしてください", "formatInvalid":"の形式が正しくありません", "arrayTooFew":"の選択数が不足しています", "onlyNumberLowercaseUnderscoreHyphen":"は英数字小文字と_-のみ使用できます", "onlyNumberAlphabetUnderscoreHyphen":"は英数字と_-のみ使用できます", "greaterThanToDaysAgo":"は 期間(X日前まで)より大きい値にしてください", "check":"をチェックしてください", "katakana":"は全角カタカナで入力してください", "greaterThanOrEqualToMinValue":"は 最小値以上の値にしてください"})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;

/***/ }),

/***/ 17221:
/***/ (function(module) {

const doc = [({"en":({"task":"Batch name", "aggregateDate":"Reference date", "fromDate":"Aggregation date(from)", "toDate":"Aggregation date(to)"})})];
module.exports = doc.length <= 1 ? doc[0] : doc;

/***/ }),

/***/ 90157:
/***/ (function(module) {

const doc = [({"ja":({"task":"バッチ名", "aggregateDate":"基準日", "fromDate":"集計日(開始)", "toDate":"集計日(終了)"})})];
module.exports = doc.length <= 1 ? doc[0] : doc;

/***/ }),

/***/ 16661:
/***/ (function(module) {

const doc = [({"en":({"lpType":"LP type", "layoutType":"Layout type", "cityPath":"City path", "title":"Title", "description":"Description", "h1Text":"H1 text", "topButtonText":"Top button text", "lpBasicInfos":"Basic info", "lpTours":"Tours", "minimumPriceCents":"Minimum price", "minimumPriceCurrency":"Currency", "topImage":"Top image", "infoType":"Info type", "value":"Value"})})];
module.exports = doc.length <= 1 ? doc[0] : doc;

/***/ }),

/***/ 35936:
/***/ (function(module) {

const doc = [({"ja":({"lpType":"LPタイプ", "layoutType":"レイアウトタイプ", "cityPath":"シティパス", "title":"タイトル", "description":"詳細", "h1Text":"H1テキスト", "topButtonText":"トップボタンテキスト", "lpBasicInfos":"基本情報", "lpTours":"ツアー", "minimumPriceCents":"最低価格", "minimumPriceCurrency":"通貨", "topImage":"トップ画像", "infoType":"項目名", "value":"内容"})})];
module.exports = doc.length <= 1 ? doc[0] : doc;

/***/ }),

/***/ 83387:
/***/ (function(module) {

const doc = [({"en":({"overnightNum":"Overnights"})})];
module.exports = doc.length <= 1 ? doc[0] : doc;

/***/ }),

/***/ 76076:
/***/ (function(module) {

const doc = [({"ja":({"overnightNum":"機内泊"})})];
module.exports = doc.length <= 1 ? doc[0] : doc;

/***/ }),

/***/ 21163:
/***/ (function(module) {

const doc = [({"en":({"firstLineType":"First LINE type"})})];
module.exports = doc.length <= 1 ? doc[0] : doc;

/***/ }),

/***/ 57903:
/***/ (function(module) {

const doc = [({"ja":({"firstLineType":"最初のLINEタイプ"})})];
module.exports = doc.length <= 1 ? doc[0] : doc;

/***/ }),

/***/ 59993:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ i18n; }
});

// EXTERNAL MODULE: ./node_modules/i18next/dist/esm/i18next.js + 2 modules
var i18next = __webpack_require__(85946);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/context.js + 1 modules
var context = __webpack_require__(57715);
;// CONCATENATED MODULE: ./main/javascripts/locales/component/common/ja.ts
var common = {
  total: "合計",
  loading: "読み込み中",
  clickToSelect: "クリックして選択",
  viewLargerMap: "拡大地図を表示",
  others: "その他"
};
;// CONCATENATED MODULE: ./main/javascripts/locales/component/flightReservationNew/ja.ts
var flightReservationNew = {
  confirmButton: "申し込み内容を確認する",
  submitButton: "予約を完了する",
  creditCardTitle: "クレジットカードの情報",
  userInformationTitle: "お客様の情報",
  flightAgreementTitle: "予約に関する注意事項",
  importantNotice: "予約に関する重要なお知らせ",
  // cancelPolicy: '{{roomName}}は{{datetime}}(現地時間) を過ぎてから行われたキャンセルや変更、または不泊の場合は、{{price}}円 の手数料が課金されます。',
  contactNotice: "予約後の連絡について",
  flightConnecting: "乗り継ぎ",
  noCancellationOrNoData: "キャンセル不可または情報がありませんでした。",
  refundableCancellationPolicy: "出発前まで一部返金可能。",
  noCancellation: "キャンセル不可",
  cancellable: "キャンセル可能",
  cancellationFee: "キャンセル料",
  totalRefundAmount: "合計返金額",
  arrangementIndex: "手配 {{index}}：",
  reservationFailureDescription: "複数のフライト手配を行うため、一部の経路の予約に失敗することがあります。",
  backToForm: "戻って内容を修正する",
  flightReservation: "フライトの予約",
  flightReservationConfirmation: "フライト予約内容の確認",
  confirmNotice: 'まだ予約は完了しておりません。内容をご確認の上、画面下部の"予約を完了する"ボタンを押してください。'
};
;// CONCATENATED MODULE: ./main/javascripts/locales/component/flightReservationShow/ja.ts
var flightReservationShow = {
  flightSummary: "フライトの概要",
  travelerInfo: "搭乗者情報",
  flightDetails: "フライト詳細",
  priceSummary: "料金の概要",
  regulation: "規則と制限事項",
  help: "ヘルプ"
};
;// CONCATENATED MODULE: ./main/javascripts/locales/component/flightIndex/ja.ts
var flightIndex = {
  sortBy: "並び替え",
  filterBy: "絞り込み",
  baggageWithItinerary: "経路{{index}}：{{baggageText}}",
  baggageAlertTitle: "預け入れ手荷物をご確認ください",
  baggageAlertDescription: "預け入れ手荷物を追加したフライトとの差額料金を表示しておりますので、無料の預け入れ手荷物がないフライトの場合、追加すると料金は高くなります。",
  detailModalTitle: "フライト詳細"
};
;// CONCATENATED MODULE: ./main/javascripts/locales/component/hotelReservationShow/ja.ts
var hotelReservationShow = {
  hotelOverview: "ホテルの概要",
  cancellationPenalty: "{{fee}}のキャンセルペナルティが発生します",
  noCancellation: "キャンセル不可",
  cancelThisRoom: "この客室をキャンセルする",
  customer: "お客さま",
  roomType: "部屋タイプ",
  planContent: "含まれているプラン内容",
  guestName: "ご予約者名",
  room: "客室",
  hotelRoom: "ホテルの客室",
  hotelPolicy: "ホテルのポリシー",
  priceSummary: "料金の概要",
  regulation: "規則と制限事項",
  help: "ヘルプ"
};
;// CONCATENATED MODULE: ./main/javascripts/locales/component/hotelReservationNew/ja.ts
var hotelReservationNew = {
  confirmButton: "申し込み内容を確認する",
  submitButton: "予約を完了する",
  creditCardTitle: "クレジットカードの情報",
  userInformationTitle: "お客様の情報",
  importantNotice: "予約に関する重要なお知らせ",
  cancelPolicy: "{{roomName}}は{{text}}",
  noCancelPolicy: "{{roomName}}はキャンセル不可です。",
  beddingRequestNotice: "※ ホテルへリクエストいたしますが確約ではございません。ホテルチェックイン時にお客様自身でご確認いただくようお伝えください。",
  specialRequestNotice: "※ 半角英数字（日本語不可）でご記入ください。ホテルにそのまま通知されます。 (Ex) Extra bed 1",
  backToForm: "戻って内容を修正する",
  hotelAgreementTitle: "予約に関する注意事項",
  reservationFailureDescription: "複数のホテル手配を行うため、一部の部屋の予約に失敗することがあります。"
};
;// CONCATENATED MODULE: ./main/javascripts/locales/component/hotelIndex/ja.ts
var hotelIndex = {
  noCreditCard: "クレジットカード不要",
  refundable: "キャンセル無料",
  viewMap: "地図を表示",
  extraFeeNotice: "現地のホテルで支払う税またはサービス料金があります"
};
;// CONCATENATED MODULE: ./main/javascripts/locales/component/hotelShow/ja.ts
var hotelShow = {
  localGuide: "周辺ガイド",
  localInformation: "周辺情報",
  roomNotAvailableMessage: "指定の日程で空きはございませんでした",
  hotelFacilitiesAndServices: "ホテルの設備 / サービス",
  hotelPolicies: "ホテルのポリシー",
  facilitiesAndServices: "設備 / サービス",
  serviceChargesAndOptionalFees: "サービス料/オプションの追加料金"
};
;// CONCATENATED MODULE: ./main/javascripts/locales/component/reservationShow/ja.ts
var reservationShow = {
  title: "予約内容の詳細",
  reservationId: "予約番号",
  reservationDate: "予約日",
  accommodationDate: "宿泊日",
  flightSummary: "フライトの概要",
  travelerInfo: "搭乗者情報",
  flightDetails: "フライト詳細",
  priceSummary: "料金の概要",
  flightPriceSummary: "フライト料金概要",
  hotelPriceSummary: "ホテル料金概要",
  regulation: "規則と制限事項",
  baggageInfo: "手荷物情報",
  baggageInfoDetail: "詳細",
  help: "ヘルプ",
  hotelOverview: "ホテルの概要",
  cancellationPenalty: "{{fee}}のキャンセルペナルティが発生します",
  noCancellation: "キャンセル不可",
  cancelThisRoom: "この客室をキャンセルする",
  customer: "お客さま",
  roomType: "部屋タイプ",
  planContent: "含まれているプラン内容",
  guestName: "ご予約者名",
  room: "客室",
  hotelRoom: "ホテルの客室",
  hotelPolicy: "ホテルのポリシー",
  hotelTitle: "ホテルについて",
  flightTitle: "フライトについて",
  hotel: "ホテル",
  totalPrice: "合計料金",
  hotelSummary: "ホテルの概要",
  showHotelDetails: "ホテルの詳細を表示",
  hotelCancelAndChange: "ホテルのキャンセルおよび変更",
  flightCancelAndChange: "フライトのキャンセルおよび変更",
  roomConfirmation: "客室の確認",
  aboutHotel: "ホテルについて",
  aboutReservation: "予約について"
};
;// CONCATENATED MODULE: ./main/javascripts/locales/component/search/ja.ts
var search = {
  hotel: "ホテル",
  flight: "フライト",
  overseasflight: "海外フライト",
  overseasFlightHotel: "海外フライト\n+ ホテル",
  search: "検 索",
  update: "更新",
  close: "閉じる",
  apply: "適用",
  cancel: "キャンセル",
  searchResults: "{{totalNum}}件ヒット",
  searchResultsPage: "検索結果: {{startNum}} - {{endNum}} 件 / {{totalNum}} 件中",
  filter: "絞り込み",
  map: "地図",
  confirm: "確認する",
  done: "完了",
  selectDate: "{{dateName}}を選択してください",
  calendarMaxDaysMessage: "最大日数を超えたため再選択してください",
  popularDestinations: "人気の旅行先",
  searchingHotels: "ホテルを検索中...",
  searchingFlights: "フライトを検索中..."
};
;// CONCATENATED MODULE: ./main/javascripts/locales/component/form/ja.ts
var ja_form = {
  firstNamePlaceholder: "例) TARO",
  lastNamePlaceholder: "例) YAMADA",
  roomTitle: "旅行者の情報",
  travelerTitle: "旅行者の情報",
  guestTitle: "宿泊者の情報",
  passengerTitle: "搭乗者の情報",
  additionalTitle: "追加情報",
  submitFormError: "フォームでエラーが発生しました",
  submitError: "エラーが発生しました",
  passportNumberPlaceholder: "例) TX1234567",
  edit: "編集する",
  hotelSpecialRequestPlaceholder: "例) Extra bed 1",
  titlePlaceholder: "タイトルを入力してください",
  summaryPlaceholder: "概要を入力してください",
  tagPlaceholder: "タグを選択または入力してください",
  relatedPostsPlaceholder: "タイトルの一部を入力してください",
  lineFooterTextPlaceholder: "イギリス&フランス旅行を相談する"
};
;// CONCATENATED MODULE: ./main/javascripts/locales/component/modal/ja.ts
var modal = {
  searchExpirationTitle: "最新情報をチェック",
  searchExpirationDescription: "最新の情報を表示するため、検索結果を更新する必要があります。",
  searchRefresh: "更新する",
  reservationExpirationTitle: "セッションの有効期限切れ",
  reservationExpirationDescription: "この予約は有効期限切れになりました。再度検索してください。",
  reservationResearch: "再検索する",
  reservationOutOfStockTitle: "商品の在庫切れ",
  reservationOutOfStockDescription: "この商品は完売になりました。再度検索してください。",
  reservationPriceChangedTitle: "料金が変更になりました",
  reservationPriceChangedDescription: "この商品の料金が変更になったため、ページを更新する必要があります。",
  reservationRefresh: "更新する",
  selectionTitle: "{{type}}が選択されました",
  selectionDescription: "内容を確認でき次第、折り返しご連絡させていただきます。しばらくお待ちください。",
  selectionEmailDescription: "後ほど選択された内容がメールで送信されますので、コンシェルジュからの再提案をご希望の場合はご返信ください。",
  selectionWitCostDescription: "合計料金をチャットにお送りいたしました。",
  reservationAllFailedTitle: "予約に失敗しました",
  reservationAllFailedDescription: "予約することができませんでした。再度検索してください。",
  reservationFlightPartiallyFailedTitle: "一部のフライトを予約できませんでした",
  reservationFlightPartialFailedDescription: "複数のフライト予約のうち一部で失敗になりました。" + "予約済みのフライトはキャンセル不可のため、予約に失敗したフライト分の料金が返金されます。",
  reservationCommitFailedTitle: "予約が完了できませんでした",
  reservationCommitFailedDescription: "入力を修正して再度予約を実行してください",
  "continue": "続ける"
};
;// CONCATENATED MODULE: ./main/javascripts/locales/component/consultationNew/ja.ts
var consultationNew = {
  submit: "送信"
};
;// CONCATENATED MODULE: ./main/javascripts/locales/component/dynamicPackage/ja.ts
var dynamicPackage = {
  chooseFlight: "フライトの選択",
  chooseHotel: "ホテルの選択",
  chooseRoom: "部屋プランの選択",
  indicatorFlight: "はじめにフライトを選択してください",
  indicatorHotel: "次にホテルを選択してください",
  indicatorRoom: "部屋プランを選択してください",
  departureDateTime: "{{dateTime}}発",
  arrivalDateTime: "{{dateTime}}着"
};
;// CONCATENATED MODULE: ./main/javascripts/locales/component/dynamicPackageReservationNew/ja.ts
var dynamicPackageReservationNew = {
  reservationTitle: "フライト+ホテルの予約",
  confirmButton: "申し込み内容を確認する",
  submitButton: "予約を完了する",
  creditCardTitle: "■ クレジットカードの情報",
  userInformationTitle: "■ お客様の情報",
  importantNotice: "予約に関する重要なお知らせ",
  cancelPolicy: "{{roomName}}は{{datetime}}(現地時間) を過ぎてから行われたキャンセルや変更、または不泊の場合は、{{price}}円 の手数料が課金されます。",
  contactNotice: "予約後の連絡について",
  flightConnecting: "乗り継ぎ",
  flightPlan: "フライトプラン",
  hotelPlan: "ホテルプラン",
  backToForm: "戻って内容を修正する",
  dynamicPackageAgreementTitle: "予約に関する注意事項",
  reservationFailureDescription: "複数のホテル手配を行うため、一部の部屋の予約に失敗することがあります。" + "複数のフライト手配を行うため、一部の経路の予約に失敗することがあります。"
};
;// CONCATENATED MODULE: ./main/javascripts/locales/component/consultationConditionEdit/ja.ts
var consultationConditionEdit = {
  thankYouTitle: "ご相談ありがとうございました",
  thankYouMessage: "後ほどチャットにて返信させていただきますので\nしばらくお待ちください。",
  additionalConditionFormTitle: "追加のご希望について",
  additionalConditionFormDescription1: "ご希望にマッチしたフライト・ホテルをご案内します。",
  additionalConditionFormDescription2: "特にない場合は、オススメのプランをご提案します。",
  additionalConditionFormSubmitComplete: "送信完了いたしました\nありがとうございました",
  additionalConditionFormSubmit: "希望を送信する",
  regionSelectionNote: "選択しなければ便利な地域が選ばれます"
};
;// CONCATENATED MODULE: ./main/javascripts/locales/component/consultationConditionShow/ja.ts
var consultationConditionShow = {
  pageTitle: "たびチャットご提案内容"
};
;// CONCATENATED MODULE: ./main/javascripts/locales/component/carouselFlight/ja.ts
var carouselFlight = {
  aboutUsingLcc: "LCCご利用について",
  lccNoteForPrice: "\u3010\u4E8B\u524D\u5EA7\u5E2D\u6307\u5B9A\u3011\u304C\u6709\u6599\n  \u3010\u9810\u3051\u8377\u7269\u3011\u304C\u6709\u6599\n  \u6A5F\u5185\u98DF\u306F\u6A5F\u5185\u8CFC\u5165\n  \u4E88\u7D04\u5F8C\u306E\u30AD\u30E3\u30F3\u30BB\u30EB\u4E0D\u53EF\n  \u306A\u3069\u3001\u53B3\u3057\u3044\u6761\u4EF6\u306B\u3088\u308A\u3001\u4FA1\u683C\u8A2D\u5B9A\u304C\u5B89\u304F\u306A\u3063\u3066\u304A\u308A\u307E\u3059",
  lccNoteForPriceChange: "\u307E\u305F\u3001\u6B8B\u5E2D\u72B6\u6CC1\u306E\u5909\u5316\u3001\u30BB\u30FC\u30EB\u671F\u9593\u7D42\u4E86\u306A\u3069\u306E\u7406\u7531\u306B\u3088\u308A\u3001  \u3054\u5165\u91D1\u306E\u30BF\u30A4\u30DF\u30F3\u30B0\u306B\u3088\u3063\u3066\u6599\u91D1\u304C\u5909\u52D5\u3057\u3066\u3057\u307E\u3046\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059\u306E\u3067\u3001\u3042\u3089\u304B\u3058\u3081\u3054\u4E86\u627F\u304F\u3060\u3055\u3044\u3002",
  lccNoteForPayment: "※ その場合、差額をご入金いただくか、全額ご返金させていただきます。",
  aboutShortLayoverRisk: "乗継リスクについて",
  ShortLayoverRisk: "\u7A7A\u6E2F\u3067\u5B9A\u3081\u3089\u308C\u3066\u3044\u308B\u6700\u5C0F\u4E57\u308A\u7D99\u304E\u6642\u9593\u3092\u30AB\u30D0\u30FC\u3057\u3066\u304A\u308A\u307E\u3059\u3002\n\u305D\u306E\u70BA\u3001\u9045\u5EF6\u306A\u3069\u304C\u767A\u751F\u3057\u305F\u5834\u5408\u306B\u306F\u3001\u901A\u5E38\u4FBF\u304C\u5272\u308A\u5F53\u3066\u3089\u308C\u307E\u3059\u304C\u3001\u7A7A\u5E2D\u304C\u306A\u3044\u3068\u7FCC\u65E5\u4EE5\u964D\u306E\u4FBF\u306B\u632F\u66FF\u3089\u308C\u305F\u308A\u3059\u308B\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059\u3002\n\u4FBF\u306E\u632F\u66FF\u306F\u73FE\u5730\u7A7A\u6E2F\u306E\u822A\u7A7A\u4F1A\u793E\u30AB\u30A6\u30F3\u30BF\u30FC\u3067\u3057\u304B\u3001\u5BFE\u5FDC\u3067\u304D\u306A\u3044\u3053\u3068\u304C\u591A\u304F\u3001\u79C1\u5171\u3067\u304A\u624B\u4F1D\u3044\u3067\u304D\u308B\u3053\u3068\u304C\u9650\u3089\u308C\u307E\u3059\u3002\n\u4E57\u7D99\u5730\u306E\u822A\u7A7A\u4F1A\u793E\u30AB\u30A6\u30F3\u30BF\u30FC\u3067\u3084\u308A\u3068\u308A\u304C\u5FC5\u8981\u306A\u305F\u3081\u3001\u4F55\u304B\u3068\u3054\u9762\u5012\u306A\u4E8B\u306B\u306A\u308A\u304B\u306D\u307E\u305B\u3093\u306E\u3067\u3001\u4E57\u7D99\u6642\u9593\u306F2\u6642\u9593\u4EE5\u4E0A\u306F\u7A7A\u3051\u308B\u3053\u3068\u3092\u304A\u3059\u3059\u3081\u81F4\u3057\u307E\u3059",
  airlineNoticeTitle: "{{airline}}の注意点",
  airportNoticeTitle: "{{airport}}の注意点",
  departureArrivalNoticeTitle: "発着時刻に関する注意点",
  earlyDepartureNotice: "早い時間に出発しますので、朝食時間や移動方法などご確認ください",
  lateArrivalNotice: "遅い時間に到着しますので、ホテルチェックインをご確認ください",
  usDomesticFlightsNoticeTitle: "アメリカ国内線の注意点"
};
;// CONCATENATED MODULE: ./main/javascripts/locales/component/error/ja.ts
var error = {
  expiredTitle: "ページの有効期限が切れました",
  errorMessageTitle: "エラーが発生しました",
  hotelNotFoundTitle: "ホテルが見つかりませんでした",
  hotelNotFoundDescription: "検索条件に該当するホテルはありません。他の検索条件で最初からもう一度検索してください。"
};
;// CONCATENATED MODULE: ./main/javascripts/locales/component/lp/ja.ts
var lp = {
  searchFlightByDestinationTitle: "{{destination}}への航空券を検索する",
  flightReferencePriceListTitle: "{{destination}}行きの人気の航空券",
  destinationAbout: "{{destination}}について",
  destinationBestSeason: "{{destination}}のベストシーズン",
  conciergeComment: "コンシェルジュコメント",
  destinationMainAirlines: "{{destination}}行きの主な航空会社",
  accessToCity: "都市部へのアクセス方法",
  searchHotelByDestinationTitle: "{{destination}}のホテルを検索する",
  hotelRecommendedListTitle: "{{destination}}でオススメのホテル",
  surroundingRegions: "近くの地域"
};
;// CONCATENATED MODULE: ./main/javascripts/locales/component/cms/ja.ts
var cms = {
  action: "アクション",
  postList: "記事一覧",
  postEdit: "記事編集",
  postTitle: "タイトル",
  postStatus: "ステータス",
  postSummary: "概要",
  postEditorName: "編集者",
  postCreatedAt: "作成日時",
  postUpdatedAt: "更新日時",
  pageUrl: "ページURL",
  link: "リンク",
  featuredImage: "アイキャッチ画像",
  normalText: "本文テキスト",
  heading1: "見出し 1",
  heading2: "見出し 2",
  heading3: "見出し 3",
  heading4: "見出し 4",
  bulletList: "箇条書きリスト",
  numberedList: "番号付きリスト",
  checkList: "チェックリスト",
  quote: "引用",
  codeBlock: "コードブロック",
  strikethrough: "取り消し線",
  subscript: "下付き文字",
  superscript: "上付き文字",
  clearFormatting: "フォーマットクリア",
  image: "画像",
  table: "表",
  insertImage: "画像の挿入",
  insertTable: "表の挿入",
  numberOfRows: "行数",
  numberOfColumns: "列数",
  file: "ファイル",
  imageUrl: "画像URL",
  imageUpload: "アップロード画像",
  altText: "代替テキスト",
  altTextPlaceholder: "画像の説明など",
  embedTweet: "ツイートの埋め込み",
  embedYouTubeVideo: "YouTube動画の埋め込み",
  embedInstagram: "インスタグラムの埋め込み",
  tweet: "ツイート",
  youTubeVideo: "YouTube動画",
  instagram: "インスタグラム",
  addCaption: "キャプションを追加",
  removeCaption: "キャプションを削除",
  enterCaption: "キャプションを入力してください...",
  createPostSuccess: "記事を作成しました",
  updatePostSuccess: "記事を更新しました",
  errorOccurred: "エラーが発生しました",
  lineLink: "LINEリンク",
  insertLineLink: "LINEリンクの挿入",
  lineUrl: "LINEリンクURL",
  buttonText: "ボタンテキスト",
  buttonTextPlaceholder: "LINEで旅のプロに旅行相談",
  promotionText: "プロモーションテキスト",
  promotionTextPlaceholder: "お得な海外旅行を予約",
  backgroundColor: "背景色",
  insertRowAbove_one: "上に {{count}} 行追加",
  insertRowAbove_other: "上に {{count}} 行追加",
  insertRowBelow_one: "下に {{count}} 行追加",
  insertRowBelow_other: "下に {{count}} 行追加",
  insertColumnLeft_one: "左に {{count}} 列追加",
  insertColumnLeft_other: "左に {{count}} 列追加",
  insertColumnRight_one: "右に {{count}} 列追加",
  insertColumnRight_other: "右に {{count}} 列追加",
  deleteColumn: "列を削除",
  deleteRow: "行を削除",
  deleteTable: "表を削除",
  addRowHeader: "行ヘッダーを追加",
  addColumnHeader: "列ヘッダーを追加",
  removeRowHeader: "行ヘッダーを削除",
  removeColumnHeader: "列ヘッダーを削除",
  deletePostTitle: "記事の削除",
  deletePostDescription: "{{title}} を削除します",
  backToPostList: "記事一覧へ戻る",
  noChangesApplied: "変更を適用しない",
  scheduledOn: "{{date}} 公開予定",
  scheduledPost: "予約記事",
  searchForm: "検索フォーム",
  insertSearchForm: "検索フォームの挿入"
};
;// CONCATENATED MODULE: ./main/javascripts/locales/component/reservation/ja.ts
var reservation = {
  lineLoginBlockTitle: "LINEでログインがおすすめ！",
  lineLoginMerit01: "チャットに予約情報が届きます",
  lineLoginMerit02: "チャットでコンシェルジュに相談できます"
};
;// CONCATENATED MODULE: ./main/javascripts/locales/component/flightRegion/ja.ts
var flightRegion = {
  flightCountryList: "フライトの目的国一覧",
  flightRegionList: "{{country}}のフライトエリア一覧"
};
;// CONCATENATED MODULE: ./main/javascripts/locales/component/hotelRegion/ja.ts
var hotelRegion = {
  hotelCountryList: "ホテルの目的国一覧",
  hotelRegionList: "{{country}}のホテルエリア一覧"
};
;// CONCATENATED MODULE: ./main/javascripts/locales/component/chargeInfoShow/ja.ts
var chargeInfoShow = {
  pageTitle: "請求内容確認",
  summaryPrice: "合計料金"
};
;// CONCATENATED MODULE: ./main/javascripts/locales/component/costItem/ja.ts
var costItem = {
  serviceType_flight: "フライト",
  serviceType_hotel: "ホテル",
  serviceType_optional_tour: "オプショナルツアー",
  serviceType_railway: "鉄道",
  totalPrice: "料金",
  totalFee: "手数料"
};
;// CONCATENATED MODULE: ./main/javascripts/locales/component/post/ja.ts
var post = {
  indexTitle: "目次",
  popularTags: "人気のタグ",
  rankingList: "人気の記事",
  relatedPosts: "関連記事",
  free: "無料",
  allRegion: "全ての地域を表示する",
  hotelSearch: "ホテル検索",
  flightSearch: "フライト検索",
  dynamicPackageSearch: "フライト+ホテル検索",
  bestPriceSearch: "最安検索"
};
;// CONCATENATED MODULE: ./main/javascripts/locales/component/reputation/ja.ts
var reputation = {
  title: "たびチャットでヨーロッパ旅行に行かれた方の口コミ",
  led: "旅行後のアンケートでは\n満足度94%のご評価をいただきました。",
  reference: "引用元",
  voice1: "\u30D1\u30EA\u3001\u30ED\u30FC\u30DE3\u6CCA\u305A\u3064\u3067\u3001\u79FB\u52D5\u3092\u542B\u3081\u30669\u65E5\u9593\u306E\u65C5\u884C\u3092\u3057\u307E\u3057\u305F\u3002\n  \u6700\u521D\u306F\u30D1\u30EA\u3001\u30ED\u30FC\u30DE\u3001\u30B9\u30DA\u30A4\u30F3\u306E3\u30F6\u56FD\u3092\u691C\u8A0E\u3057\u3066\u3044\u307E\u3057\u305F\u304C\u30013\u30F6\u56FD\u306E\u30D1\u30BF\u30FC\u30F3\u30682\u30F6\u56FD\u306E\u30D1\u30BF\u30FC\u30F3\u3092\u8FC5\u901F\u306B\u3054\u63D0\u6848\u3044\u305F\u3060\u304D\u307E\u3057\u305F\u3002\n  \u90FD\u5E02\u3060\u3051\u3067\u306A\u304F\u3001\u4E88\u7B97\u3068\u65E5\u7A0B\u306B\u5408\u308F\u305B\u3066\u822A\u7A7A\u4F1A\u793E\u3084\u30DB\u30C6\u30EB\u306A\u3069\u3082\u4F55\u30D1\u30BF\u30FC\u30F3\u3082\u3054\u63D0\u6848\u3044\u305F\u3060\u3044\u305F\u306E\u3067\u3001\u7D0D\u5F97\u3067\u304D\u308B\u307E\u3067\u6BD4\u8F03\u691C\u8A0E\u3057\u305F\u4E0A\u3067\u30B9\u30E0\u30FC\u30BA\u306B\u6C7A\u3081\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3057\u305F\u3002\n  \uFF08\u4ED6\u306E\u5927\u624B\u65C5\u884C\u4F1A\u793E\u3067\u306F1\u3064\u306E\u8CEA\u554F\u3092\u3057\u305F\u3089\u6B21\u306E\u65E5\u306B\u56DE\u7B54\u304C\u6765\u308B\u30B9\u30D4\u30FC\u30C9\u611F\u3067\u3057\u305F\u304C\u3001\u305F\u3073\u30C1\u30E3\u30C3\u30C8\u306F1\u301C3\u6642\u9593\u3067\u56DE\u7B54\u304C\u6765\u308B\u306E\u3067\u691C\u8A0E\u3092\u30B9\u30D4\u30FC\u30C7\u30A3\u30FC\u9032\u3081\u3089\u308C\u3066\u672C\u5F53\u306B\u30B9\u30C8\u30EC\u30B9\u30D5\u30EA\u30FC\u3067\u3057\u305F\uFF09\n  \u78BA\u5B9A\u5F8C\u3082\u3001\u4E88\u7B97\u3084\u30B7\u30C1\u30E5\u30A8\u30FC\u30B7\u30E7\u30F3\u306B\u5408\u308F\u305B\u305F\u73FE\u5730\u3067\u306E\u30EC\u30B9\u30C8\u30E9\u30F3\u3084Wi-Fi\u306A\u3069\u3092\u6848\u5185\u3057\u3066\u3044\u305F\u3060\u304D\u307E\u3057\u305F\u3002\n  \u65C5\u884C\u4E2D\u3082\u4E88\u60F3\u3088\u308A\u9AD8\u3044\u5BBF\u6CCA\u7A0E\u306B\u9A5A\u304D\u3001\u307C\u3063\u305F\u304F\u3089\u308C\u3066\u3044\u308B\u306E\u304B\u3082\u3068\u4E0D\u5B89\u306B\u601D\u3063\u3066LINE\u3067\u78BA\u8A8D\u3057\u305F\u6642\u3082\u3059\u3050\u306B\u8A73\u7D30\u3092\u8ABF\u3079\u3066\u4F1D\u3048\u3066\u3044\u305F\u3060\u3044\u305F\u306E\u3067\u5B89\u5FC3\u3067\u304D\u307E\u3057\u305F\u3002\n  \u30C4\u30A2\u30FC\u3067\u306F\u306A\u304F\u3042\u308B\u7A0B\u5EA6\u500B\u4EBA\u3067\u30E8\u30FC\u30ED\u30C3\u30D1\u65C5\u884C\u3092\u691C\u8A0E\u3057\u3066\u3044\u308B\u65B9\u306B\u306F\u3001\u662F\u975E\u304A\u3059\u3059\u3081\u3057\u305F\u3044\u3067\u3059\u3002\u5927\u6E80\u8DB3\u306E\u65C5\u884C\u3067\u3057\u305F\uFF01",
  person1: "Kyoko Ichimura",
  voice2: "11\u6708\u306B\u30DD\u30FC\u30C8\u30E9\u30F3\u30C9\u306B\u884C\u3063\u3066\u6765\u307E\u3057\u305F\u3002\u521D\u3081\u3066\u306E\u30A2\u30E1\u30EA\u30AB\u3067\u305F\u304F\u3055\u3093\u4E0D\u5B89\u3082\u3042\u3063\u305F\u306E\u3067\u3059\u304C\u3001\n  \u30C4\u30A2\u30FC\u3084\u30D5\u30E9\u30A4\u30C8\u6642\u9593\u30DB\u30C6\u30EB\u7B49\u3001\u63D0\u6848\u3084\u76F8\u8AC7\u3092\u3068\u3066\u3082\u4E01\u5BE7\u306B\u5BFE\u5FDC\u3057\u3066\u304F\u308C\u307E\u3057\u305F\uFF01\n  \u5F53\u65E5\u3001\u98DB\u884C\u6A5F\u306E\u9045\u5EF6\u3067\u30DB\u30C6\u30EB\u306E\u5230\u7740\u6642\u9593\u304C\u9045\u308C\u305F\u4E8B\u3084\u30DB\u30C6\u30EB\u3067\u306E\u56F0\u308A\u3054\u3068\u306B\u3082\u8FC5\u901F\u306B\u5BFE\u5FDC\u3057\u3066\u9802\u3044\u3066\u672C\u5F53\u306B\u5B09\u3057\u304B\u3063\u305F\u3067\u3059\uFF01\n  \u30CD\u30C3\u30C8\u3067\u306E\u3084\u308A\u3068\u308A\u3067\u3057\u305F\u304C\n  \u4E0D\u5B89\u306B\u306A\u308B\u4E8B\u306A\u304F\u65C5\u306E\u8A08\u753B\u3067\u304D\u307E\u3057\u305F\uFF01\n  \n  \u307E\u305F\u6D77\u5916\u306B\u884C\u304F\u6642\u306F\u305F\u3073\u30C1\u30E3\u30C3\u30C8\u3055\u3093\u306B\u304A\u9858\u3044\u3057\u307E\u3059\uFF01\n  \u30B9\u30BF\u30C3\u30D5\u306E\u307F\u306A\u3055\u3093\u672C\u5F53\u306B\u3042\u308A\u304C\u3068\u3046\u3054\u3056\u3044\u307E\u3057\u305F\uFF01\n  \u304A\u304B\u3051\u3067\u601D\u3044\u51FA\u306B\u6B8B\u308B\u65C5\u884C\u304C\u3067\u304D\u307E\u3057\u305F\uFF01",
  person2: "Ayako Ichiyama",
  voice3: "\u521D\u3081\u3066\u306E\u6D77\u5916\u65C5\u884C\u3001\u4E00\u4EBA\u65C5\u3067\u61A7\u308C\u306E\u30A4\u30AE\u30EA\u30B9\u306B\u884C\u304F\u305F\u3081\u306B\u305F\u3073\u30C1\u30E3\u30C3\u30C8\u3055\u3093\u3092\u5229\u7528\u3055\u305B\u3066\u3044\u305F\u3060\u304D\u307E\u3057\u305F\uD83C\uDDEC\uD83C\uDDE7LINE\u3067\u306E\u3084\u308A\u53D6\u308A\u3060\u3051\u3068\u3044\u3046\u306E\u306B\u4E0D\u5B89\u306F\u3042\u308A\u307E\u3057\u305F\u304C\u6BCE\u56DE\u8FD4\u4FE1\u306F\u65E9\u304F\u3001\u305D\u3057\u3066\u5FEB\u304F\u5BFE\u5FDC\u3057\u3066\u3044\u305F\u3060\u304D\u65C5\u884C\u524D\u304B\u3089\u65C5\u884C\u4E2D\u307E\u3067\u5FC3\u5F37\u304B\u3063\u305F\u3067\u3059\u3002\n  \u6D77\u5916\u65C5\u884C\u3092\u30C4\u30A2\u30FC\u306A\u3069\u3067\u306F\u306A\u304F\u500B\u4EBA\u3067\u884C\u304D\u305F\u3044\u65B9\u306B\u306F\u672C\u5F53\u306B\u305C\u3072\u304A\u3059\u3059\u3081\u3057\u305F\u3044\u3067\u3059\uD83D\uDE0A ",
  person3: "Saki",
  voice4: "\u4ECA\u56DE\u3001\u53F0\u6E7E\u65C5\u884C\u3067\u521D\u3081\u3066\u5229\u7528\u3055\u305B\u3066\u9802\u304D\u307E\u3057\u305F\u3002\n  \u58BE\u4E01\u306F\u60C5\u5831\u304C\u5C11\u306A\u304F\u3001\u8ABF\u3079\u308B\u6642\u9593\u3082\u306A\u304B\u3063\u305F\u306E\u3067\u3068\u3066\u3082\u52A9\u304B\u308A\u307E\u3057\u305F\u3002\n  \u6761\u4EF6\u3092\u3044\u304F\u3064\u3060\u3057\u3001\u5019\u88DC\u3092\u4E0A\u3052\u3066\u3044\u305F\u3060\u304D\u305D\u306E\u4E2D\u3067\u9078\u3093\u3060\u3060\u3051\u3067\u3057\u305F\u304C\u3001\u4E00\u7DD2\u306B\u3044\u3063\u305F\u53CB\u4EBA\u306B\u306F\u5927\u597D\u8A55\u3002\n  LINE\u3067\u3084\u308A\u53D6\u308A\u304C\u51FA\u6765\u305F\u306E\u3067\u3001\u3061\u3087\u3053\u3061\u3087\u3053\u3068\u5909\u66F4\u3057\u305F\u3053\u3068\u3082\u76F4\u3050\u306B\u5BFE\u5FDC\u3057\u3066\u3044\u305F\u3060\u304D\u307E\u3057\u305F\u3002\n  \u300E\u3044\u3064\u3067\u3082\u3001\u76F8\u8AC7\u3067\u304D\u308B\u300F\u300E\u4E01\u5BE7\u300F\u304C\u6700\u5927\u306E\u9B45\u529B\u3067\u3059\u306D\u3002",
  person4: "IZUMI",
  voice5: "\u30DF\u30C3\u30D5\u30A3\u30FC\u306E\u6545\u90F7\u30AA\u30E9\u30F3\u30C0\u3068\u30C1\u30E7\u30B3\u30EC\u30FC\u30C8\u738B\u56FD\u30D9\u30EB\u30AE\u30FC\u306B\u884C\u304D\u307E\u3057\u305F\uD83D\uDC07\uD83C\uDF6B\n\n  \u5927\u624B\u65C5\u884C\u4EE3\u7406\u5E97\u306E\u30C4\u30A2\u30FC\u306F\u9AD8\u984D\u4E14\u3064\u65E5\u7A0B\u3082\u9650\u3089\u308C\u3066\u3044\u305F\u306E\u3067\u3001\u4ED6\u793E\u3092\u63A2\u3057\u3066\u3044\u305F\u3068\u3053\u308D\u305F\u3073\u30C1\u30E3\u30C3\u30C8\u3055\u3093\u3092\u898B\u3064\u3051\u307E\u3057\u305F\uD83D\uDE47\n  \u5E0C\u671B\u65E5\u6642\u3067\u3054\u6848\u5185\u3044\u305F\u3060\u3051\u305F\u4E0A\u306B\u3001\u5927\u624B\u3088\u308A\u3082\u30DB\u30C6\u30EB\u306E\u30B0\u30EC\u30FC\u30C9\u3082\u3088\u304F\u3001\u305D\u3057\u3066\u3068\u3066\u3082\u5B89\u304F\u3066\u6700\u521D\u306F\u30D3\u30C3\u30AF\u30EA\u3057\u3066\u4E0D\u5B89\u306B\u306A\u308A\u307E\u3057\u305F\uD83E\uDD7A\uD83D\uDCA6\n  \u3067\u3059\u304C\u3001\u30E9\u30A4\u30F3\u306E\u3084\u308A\u53D6\u308A\u3082\u4E01\u5BE7\u3067\u3069\u3093\u306A\u8CEA\u554F\u3082\u8FC5\u901F\u306B\u304A\u7B54\u3048\u3044\u305F\u3060\u3051\u305F\u306E\u3067\u3001\u5927\u4E08\u592B\u3068\u601D\u3044\u3053\u3061\u3089\u3067\u4E88\u7D04\u3055\u305B\u3066\u3044\u305F\u3060\u304D\u307E\u3057\u305F\uD83D\uDE06\n  \n  \u7D50\u679C\u3001\u3068\u3066\u3082\u5FEB\u9069\u306A\u65C5\u884C\u304C\u3067\u304D\u5927\u5909\u6E80\u8DB3\u3044\u304F\u3082\u306E\u306B\u306A\u308A\u307E\u3057\u305F\uFF01\uFF01\n  \u307E\u305F\u662F\u975E\u5229\u7528\u3055\u305B\u3066\u3044\u305F\u3060\u304D\u305F\u3044\u3068\u601D\u3044\u307E\u3059\uFF01\u3042\u308A\u304C\u3068\u3046\u3054\u3056\u3044\u307E\u3057\u305F\uD83D\uDE0A",
  person5: "YURI N",
  voice6: "\uFF13\uFF10\u5E74\u6765\u306E\u5922\u3060\u3063\u305F\u30AE\u30EA\u30B7\u30A2\u65C5\u884C\u3092\u63D0\u6848\u3057\u3066\u3082\u3089\u3044\u307E\u3057\u305F\u3002\u5BFE\u5FDC\u3001\u63D0\u6848\u3068\u3082\u306B\u6E80\u8DB3\u3067\u3059\u3002\n\n  \u5E0C\u671B\u5185\u5BB9\u306E\u5909\u66F4\u3082\u3042\u3063\u3066\u4F55\u5EA6\u3082\u63D0\u6848\u3057\u3066\u3082\u3089\u3044\u307E\u3057\u305F\u3002\u9762\u5012\u3060\u3063\u305F\u3067\u3057\u3087\u3046\u304C\u3001\u52A9\u304B\u308A\u307E\u3057\u305F\u3002\n  \n  \u307E\u305F\u5225\u306E\u6A5F\u4F1A\u304C\u3042\u3063\u305F\u3089\u3001\u5229\u7528\u3055\u305B\u3066\u3044\u305F\u3060\u304D\u305F\u3044\u3068\u601D\u3046\u4EE3\u7406\u5E97\u3055\u3093\u3067\u3057\u305F\u3002",
  person6: "小林博",
  voice7: "\u5B9A\u5E74\u9000\u8077\u3057\u305F\u3089\u4EE5\u524D\u884C\u3063\u3066\u305F\u30CB\u30E5\u30FC\u30E8\u30FC\u30AF\u306B1\u30F6\u6708\u7A0B\u884C\u304F\uFF01\u3068\u6C7A\u3081\u3066\u305F\u3089\u3001\u30B3\u30ED\u30CA\u30672\u5E74\u884C\u3051\u305A\u3002\u3084\u3063\u3068\u4ECA\u56DE\u884C\u304F\u3053\u3068\u304C\u3067\u304D\u307E\u3057\u305F\u3002\n  \u304A\u91D1\u3082\u5E95\u3092\u4ED8\u3044\u3066\u304D\u305F\u70BA\u3001\u7121\u7406\u3092\u8A00\u3063\u3066\u4E88\u7B97\u5C11\u3057\u30AA\u30FC\u30D0\u30FC\u304F\u3089\u3044\u3067\u884C\u304F\u3053\u3068\u304C\u51FA\u6765\u307E\u3057\u305F\u3002\n  \u81EA\u5206\u3067\u30DB\u30C6\u30EB\u63A2\u3057\u305F\u6599\u91D1\u3068\u63D0\u6848\u3057\u3066\u9802\u3044\u305F\u6599\u91D1\u304C\u9055\u3046\u7B49\u3001\u30EF\u30AC\u30DE\u30DE\u306A\u8CEA\u554F\u306B\u3082\u4E01\u5BE7\u306B\u7B54\u3048\u3066\u9802\u304D\u3001\u5C0F\u3055\u306A\u8CEA\u554F\u3084ESTA\u3067\u56F0\u3063\u3066\u3044\u3066\u3082\u3001\u5FC5\u305A\u89AA\u5207\u306B\u5BFE\u5FDC\u3057\u3066\u4E0B\u3055\u3044\u307E\u3057\u305F\u3002\n  \u8CEA\u554F\u3057\u3066\u304B\u3089\u56DE\u7B54\u3057\u3066\u3044\u305F\u3060\u304F\u6642\u9593\u3082\u65E9\u304F\u3066\u3001\u6E96\u5099\u304C\u30B9\u30E0\u30FC\u30BA\u306B\u306B\u3067\u304D\u307E\u3057\u305F\u3002\n  \u4E88\u5B9A\u3092\u30A2\u30CA\u30CF\u30A4\u30E0\u3067\u3001\u5927\u8C37\u9078\u624B\u898B\u308B\u3001\u30ED\u30B9\u3067\u30C7\u30A3\u30BA\u30CB\u30FC\u3068\u30E6\u30CB\u30D0\u30FC\u30B5\u30EB\u306B\u884C\u304F\u3001\u30CB\u30E5\u30FC\u30E8\u30FC\u30AF\u306F\u30D6\u30E9\u30D6\u30E9\u3068\u8A08\u753B\u3092\u8A71\u3059\u3068\u3001\u65E5\u7A0B\u3092\u8003\u3048\u3066\u304F\u3060\u3055\u3063\u3066\u3001\u30A2\u30CA\u30CF\u30A4\u30E0\u306F\u30DB\u30C6\u30EB\u3082\u30C7\u30A3\u30BA\u30CB\u30FC\u306B\u306F\u5F92\u6B69\u3067\u884C\u3051\u308B\u6240\u3067\u3057\u305F\u3002\n  \u30B1\u30AC\u3067\u3001\u51FA\u5834\u3057\u306A\u3044\u5927\u8C37\u9078\u624B\u3082\u30D5\u30A1\u30F3\u611F\u8B1D\u30C7\u30FC\u306E\u8868\u5F70\u5F0F\u306B\u306F\u6765\u305F\u306E\u3067\u3001\u898B\u308C\u305F\u3057\u3001\u30ED\u30B9\u306E\u30DB\u30C6\u30EB\u306F\u30C0\u30A6\u30F3\u30BF\u30A6\u30F3\u304B\u3089\u5C11\u3057\u96E2\u308C\u3066\u307E\u3057\u305F\u304C\u3001\u540C\u3058\u30DB\u30C6\u30EB\u306B\u6CCA\u307E\u3063\u3066\u305F\u7D20\u6575\u306A\u65E5\u672C\u4EBA\u306B\u304A\u4F1A\u3044\u3067\u304D\u3066\u3001\u89B3\u5149\u5730\u4E00\u7DD2\u306B\u8ECA\u3067\u56DE\u3063\u3066\u9802\u3051\u305F\u308A\u3001\u30CB\u30E5\u30FC\u30E8\u30FC\u30AF\u3067\u306F\u3001\u30DE\u30F3\u30CF\u30C3\u30BF\u30F3\u304B\u3089\u5730\u4E0B\u9244\u3067\u4E00\u672C\u3067\u884C\u3051\u308B\u6240\u3060\u3063\u305F\u308A\u3001\u672C\u5F53\u306B\u30E9\u30C3\u30AD\u30FC\u306A\u4E8B\u3070\u304B\u308A\u3067\u3057\u305F\u3002\n  \u305F\u3060\u30CB\u30E5\u30FC\u30E8\u30FC\u30AF\u306F\u3001\u30DE\u30F3\u30CF\u30C3\u30BF\u30F3\u304B\u30891\u6642\u9593\u304B\u304B\u308B\u70BA\u3001\u591C\u306E\u30DE\u30F3\u30CF\u30C3\u30BF\u30F3\u3092\u898B\u308B\u306B\u306F\u5730\u4E0B\u9244\u304C\u6016\u3044\u306E\u3067\u3001\u4ECA\u56DE\u306F\u898B\u308B\u3053\u3068\u304C\u3067\u304D\u306A\u304B\u3063\u305F\u306E\u304C\u5FC3\u6B8B\u308A\u3067\u3059\u3002\n  \u683C\u5B89\u3067\u3001\u30A2\u30D1\u30FC\u30C8\u30E1\u30F3\u30C8\u30BF\u30A4\u30D7\u306E\u30DB\u30C6\u30EB\u3092\u304A\u9858\u3044\u3057\u305F\u306E\u3067\u3001\u3082\u3046\u5C11\u3057\u304A\u91D1\u306B\u4F59\u88D5\u3092\u6301\u3063\u3066\u884C\u3051\u305F\u3089\u826F\u304B\u3063\u305F\u3068\u3001\u81EA\u5206\u306B\u53CD\u7701\u3067\u3059\u3002\n  \u305F\u3073\u30C1\u30E3\u30C3\u30C8\u3055\u3093\u306E\u304A\u9670\u3067\u3001\u601D\u3044\u51FA\u3044\u3063\u3071\u3044\u306E\u4E00\u4EBA\u65C5\u304C\u3067\u304D\u307E\u3057\u305F\u3002\u53C8\u6D77\u5916\u306B\u884C\u3051\u308B\u3088\u3046\u306B\u306A\u3063\u305F\u3089\u3001\u305C\u3072\u305F\u3073\u30C1\u30E3\u30C3\u30C8\u3055\u3093\u3092\u5229\u7528\u3057\u305F\u3044\uFF01\u4ED6\u306E\u4EBA\u306B\u3082\u52E7\u3081\u305F\u3044\uFF01\u3068\u601D\u3044\u307E\u3059\u3002\n  \u62C5\u5F53\u306E\u65B9\u3042\u308A\u304C\u3068\u3046\u3054\u3056\u3044\u307E\u3057\u305F\u3002",
  person7: "MAYUMI GOKOH"
};
// EXTERNAL MODULE: ./main/javascripts/locales/component/emailUser/ja.yml
var ja = __webpack_require__(8534);
;// CONCATENATED MODULE: ./main/javascripts/locales/component/ja.ts





























var componentJa = {
  common: common,
  flightReservationNew: flightReservationNew,
  flightReservationShow: flightReservationShow,
  flightIndex: flightIndex,
  hotelReservationShow: hotelReservationShow,
  hotelReservationNew: hotelReservationNew,
  hotelIndex: hotelIndex,
  hotelShow: hotelShow,
  reservationShow: reservationShow,
  search: search,
  form: ja_form,
  modal: modal,
  consultationNew: consultationNew,
  dynamicPackage: dynamicPackage,
  dynamicPackageReservationNew: dynamicPackageReservationNew,
  consultationConditionEdit: consultationConditionEdit,
  consultationConditionShow: consultationConditionShow,
  carouselFlight: carouselFlight,
  error: error,
  lp: lp,
  cms: cms,
  reservation: reservation,
  flightRegion: flightRegion,
  hotelRegion: hotelRegion,
  chargeInfoShow: chargeInfoShow,
  costItem: costItem,
  post: post,
  reputation: reputation,
  emailUser: ja.ja
};
;// CONCATENATED MODULE: ./main/javascripts/locales/component/common/en.ts
var en_common = {
  total: "Total",
  loading: "Loading",
  clickToSelect: "Click to select",
  others: "Others",
  viewLargerMap: "View larger map"
};
;// CONCATENATED MODULE: ./main/javascripts/locales/component/flightReservationNew/en.ts
var en_flightReservationNew = {
  confirmButton: "CONFIRM CONTENTS",
  submitButton: "COMPLETE BOOKING",
  creditCardTitle: "Credit card Information",
  userInformationTitle: "User Information",
  flightAgreementTitle: "Reservation notes",
  importantNotice: "Important information about your booking",
  contactNotice: "Contact information after booking",
  flightConnecting: "Connect",
  noCancellationOrNoData: "It can not be canceled or there was no information.",
  refundableCancellationPolicy: "Partial refundable before departure.",
  noCancellation: "No Cancellations",
  cancellable: "Cancellable",
  cancellationFee: "Cancellation fee",
  totalRefundAmount: "Total refund amount",
  arrangementIndex: "Arrangement {{index}}: ",
  reservationFailureDescription: "Some flights may fail to be booked due to multiple flight arrangements.",
  backToForm: "Back to form",
  flightReservation: "Flight reservation",
  flightReservationConfirmation: "Flight reservation confirmation",
  confirmNotice: "The reservation has not been completed yet. " + 'After confirming the contents, click the "COMPLETE BOOKING" button at the bottom of the screen.'
};
;// CONCATENATED MODULE: ./main/javascripts/locales/component/flightReservationShow/en.ts
var en_flightReservationShow = {
  flightSummary: "Flight Summary",
  travelerInfo: "Travelers Information",
  flightDetails: "Flight Details",
  priceSummary: "Price Summary",
  regulation: "Rules & Restrictions",
  help: "Help"
};
;// CONCATENATED MODULE: ./main/javascripts/locales/component/flightIndex/en.ts
var en_flightIndex = {
  sortBy: "Sort by",
  filterBy: "Filter by",
  baggageWithItinerary: "Itinerary{{index}}: {{baggageText}}",
  baggageAlertTitle: "Please check your checked baggage",
  baggageAlertDescription: "The difference between the price for a flight with checked baggage and the price for a flight without free checked baggage is shown, so if a flight does not have free checked baggage, the price will be higher if you add it.",
  detailModalTitle: "Flight details"
};
;// CONCATENATED MODULE: ./main/javascripts/locales/component/hotelReservationShow/en.ts
var en_hotelReservationShow = {
  hotelOverview: "Hotel Overview",
  cancellationPenalty: "Cancellation penalty of {{fee}} will occur",
  noCancellation: "No Cancellations",
  cancelThisRoom: "Cancel this room",
  customer: "Customers",
  roomType: "Room type",
  planContent: "Plan contents",
  guestName: "Guest name",
  room: "Rooms",
  hotelRoom: "Hotel rooms",
  hotelPolicy: "Hotel policy",
  priceSummary: "Price Summary",
  regulation: "Rules & Restrictions",
  help: "Help"
};
;// CONCATENATED MODULE: ./main/javascripts/locales/component/hotelIndex/en.ts
var en_hotelIndex = {
  noCreditCard: "No Credit Card",
  refundable: "refundable",
  viewMap: "View Map",
  extraFeeNotice: "There is a tax or service charge to be paid at the hotel"
};
;// CONCATENATED MODULE: ./main/javascripts/locales/component/hotelShow/en.ts
var en_hotelShow = {
  localGuide: "Local Guide",
  localInformation: "Local Information",
  roomNotAvailableMessage: "There were no vacancies on the dates specified.",
  hotelFacilitiesAndServices: "Hotel Facilities / Services",
  hotelPolicies: "Hotel Policies",
  facilitiesAndServices: "Facilities / Services",
  serviceChargesAndOptionalFees: "Service Charges / Optional Fees"
};
;// CONCATENATED MODULE: ./main/javascripts/locales/component/search/en.ts
var en_search = {
  hotel: "Hotel",
  flight: "Flight",
  overseasflight: "Overseas Flight",
  overseasFlightHotel: "Overseas Flight\n+ Hotel",
  search: "Search",
  update: "Update",
  close: "Close",
  apply: "Apply",
  cancel: "Cancel",
  searchResults: "{{totalNum}} results",
  searchResultsPage: "{{startNum}} to {{endNum}} of {{totalNum}} results",
  filter: "Filter",
  map: "Map",
  confirm: "Confirm",
  done: "Done",
  selectDate: "Select {{dateName}}",
  calendarMaxDaysMessage: "Please select again because the maximum number of days has been exceeded.",
  popularDestinations: "Popular destinations",
  searchingHotels: "Searching for hotels...",
  searchingFlights: "Searching for flights..."
};
;// CONCATENATED MODULE: ./main/javascripts/locales/component/hotelReservationNew/en.ts
var en_hotelReservationNew = {
  confirmButton: "CONFIRM CONTENTS",
  submitButton: "COMPLETE BOOKING",
  creditCardTitle: "Credit card Information",
  userInformationTitle: "User Information",
  importantNotice: "Important information about your booking",
  cancelPolicy: "{{roomName}} {{text}} " + "or no-shows are subject to a property fee equal to total amount paid for the reservation.",
  noCancelPolicy: "{{roomName}} is no cancellation",
  beddingRequestNotice: "* A request is made to the hotel, but there is no guarantee. " + "Please ask yourself to check it at the hotel check-in.",
  specialRequestNotice: "* Please fill in half-width alphanumeric characters. The hotel will be notified as is. (Ex) Extra bed 1",
  backToForm: "Back to form",
  hotelAgreementTitle: "Reservation notes",
  reservationFailureDescription: "May fail to book some of the rooms when request to book multiple room at the same time"
};
;// CONCATENATED MODULE: ./main/javascripts/locales/component/form/en.ts
var en_form = {
  firstNamePlaceholder: "John",
  lastNamePlaceholder: "Smith",
  roomTitle: "■ Information on travelers",
  travelerTitle: "Information on travelers",
  guestTitle: "Information on guests",
  passengerTitle: "Information on passengers",
  additionalTitle: "Additional information",
  submitFormError: "An error occurred in the input form",
  submitError: "An error occurred",
  passportNumberPlaceholder: "e.g. TX1234567",
  edit: "EDIT",
  hotelSpecialRequestPlaceholder: "e.g. Extra bed 1",
  titlePlaceholder: "Input title...",
  summaryPlaceholder: "Input summary...",
  tagPlaceholder: "Select or input tag...",
  relatedPostsPlaceholder: "Enter part of the title",
  lineFooterTextPlaceholder: "Consult a trip to the UK & France"
};
;// CONCATENATED MODULE: ./main/javascripts/locales/component/modal/en.ts
var en_modal = {
  searchExpirationTitle: "Check the latest information",
  searchExpirationDescription: "In order to display the latest information, you need to update the search results.",
  searchRefresh: "Update",
  reservationExpirationTitle: "Session Expired",
  reservationExpirationDescription: "This reservation session has expired. Please search again.",
  reservationResearch: "Search again",
  reservationOutOfStockTitle: "Out of stock",
  reservationOutOfStockDescription: "This item is sold out. Please search again.",
  reservationPriceChangedTitle: "Price changed",
  reservationPriceChangedDescription: "The price of this item has changed. You need to update this page.",
  reservationRefresh: "Update",
  selectionTitle: "The {{type}} has been selected",
  selectionDescription: "We will contact you shortly after confirmation. Please wait a moment",
  selectionEmailDescription: "You will later receive an email with your selections. Please reply if you would like to receive another proposal from the concierge.",
  selectionWitCostDescription: "The total price has been sent to chat.",
  reservationAllFailedTitle: "Reservation failed",
  reservationAllFailedDescription: "Could not make a reservation. Please search again.",
  reservationFlightPartiallyFailedTitle: "Some flights could not be booked",
  reservationFlightPartialFailedDescription: "Some of the multiple flight bookings failed. " + "The reserved flight is non-cancellable and the fee for the failed flight will be refunded.",
  reservationCommitFailedTitle: "Booking could not be completed.",
  reservationCommitFailedDescription: "Please correct your input and try again to make a reservation.",
  "continue": "Continue"
};
;// CONCATENATED MODULE: ./main/javascripts/locales/component/consultationNew/en.ts
var en_consultationNew = {
  submit: "Submit"
};
;// CONCATENATED MODULE: ./main/javascripts/locales/component/dynamicPackage/en.ts
var en_dynamicPackage = {
  chooseFlight: "Choose your flight",
  chooseHotel: "Choose your hotel",
  chooseRoom: "Choose your room",
  indicatorFlight: "Please choose a flight first",
  indicatorHotel: "Please choose a hotel next",
  indicatorRoom: "Please choose a room plan",
  departureDateTime: "Departure {{dateTime}}",
  arrivalDateTime: "Arrival {{dateTime}}"
};
;// CONCATENATED MODULE: ./main/javascripts/locales/component/dynamicPackageReservationNew/en.ts
var en_dynamicPackageReservationNew = {
  reservationTitle: "Flight and hotel booking",
  confirmButton: "CONFIRM CONTENTS",
  submitButton: "COMPLETE BOOKING",
  creditCardTitle: "■ Creditcard Information",
  userInformationTitle: "■ User Information",
  importantNotice: "Important information about your booking",
  cancelPolicy: "{{roomName}}: Cancellations or changes made after {{datetime}}(Local time) " + "or no-shows are subject to a property fee equal to {{price}}of the total amount paid for the reservation.",
  contactNotice: "Contact information after booking",
  flightConnecting: "Connect",
  flightPlan: "Flight plan",
  hotelPlan: "Hotel plan",
  backToForm: "Back to form",
  dynamicPackageAgreementTitle: "Reservation notes",
  reservationFailureDescription: "May fail to book some of the rooms when request to book multiple room at the same time." + " May fail to book part of the flights whe request to book multiple flight itineraries at the same time."
};
;// CONCATENATED MODULE: ./main/javascripts/locales/component/consultationConditionEdit/en.ts
var en_consultationConditionEdit = {
  thankYouTitle: "Thank you for your inquiry",
  thankYouMessage: "Please wait for a while as we will reply later in chat later.",
  additionalConditionFormTitle: "Additional hope",
  additionalConditionFormDescription1: "If you have any hopes about hotels and flights,",
  additionalConditionFormDescription2: "please check all applicable items and send them.",
  additionalConditionFormSubmitComplete: "Send completed. \nThank you very much.",
  additionalConditionFormSubmit: "Send hopes",
  regionSelectionNote: "If not selected, a convenient region will be selected"
};
;// CONCATENATED MODULE: ./main/javascripts/locales/component/consultationConditionShow/en.ts
var en_consultationConditionShow = {
  pageTitle: "Proposal from たびチャット"
};
;// CONCATENATED MODULE: ./main/javascripts/locales/component/carouselFlight/en.ts
var en_carouselFlight = {
  aboutUsingLcc: "About using LCC",
  lccNoteForPrice: "Pricing is cheap due to tough conditions such as\n    [Advance seat selection] is charged\n    [Deposit Baggage] is charged\n    Purchase in-flight meals\n    No cancellation after reservation",
  lccNoteForPriceChange: "In addition, please understand beforehand that the fee may fluctuate depending   on the timing of payment due to changes in the remaining seat status, the end of the sale period, and so on.",
  lccNoteForPayment: "* In that case, I will refund the full amount, please pay the difference.",
  aboutShortLayoverRisk: "Translation pending",
  ShortLayoverRisk: "Translation pending",
  airlineNoticeTitle: "Notice regarding {{airline}}",
  airportNoticeTitle: "Notice regarding {{airport}}",
  departureArrivalNoticeTitle: "Notice of Departure and Arrival Time",
  earlyDepartureNotice: "Departure time is early.",
  lateArrivalNotice: "Arrival time is late.",
  usDomesticFlightsNoticeTitle: "Notice for Domestic Flights in the U.S."
};
;// CONCATENATED MODULE: ./main/javascripts/locales/component/error/en.ts
var en_error = {
  expiredTitle: "Page expired",
  errorMessageTitle: "An error has occurred",
  hotelNotFoundTitle: "No hotel found",
  hotelNotFoundDescription: "There are no hotels that match your search criteria. Please try again from the beginning with other search criteria."
};
;// CONCATENATED MODULE: ./main/javascripts/locales/component/lp/en.ts
var en_lp = {
  searchFlightByDestinationTitle: "Flight Destinations in {{destination}}",
  flightReferencePriceListTitle: "Popular flights to {{destination}}",
  destinationAbout: "About {{destination}}",
  destinationBestSeason: "Best season for {{destination}}",
  conciergeComment: "Concierge comments",
  destinationMainAirlines: "Main airlines to {{destination}}",
  accessToCity: "Access to the city",
  searchHotelByDestinationTitle: "Search hotels in{{destination}}",
  hotelRecommendedListTitle: "Recommended hotels in {{destination}}",
  surroundingRegions: "Surrounding regions"
};
;// CONCATENATED MODULE: ./main/javascripts/locales/component/cms/en.ts
var en_cms = {
  action: "Action",
  postList: "Post list",
  postEdit: "Edit post",
  postTitle: "Title",
  postStatus: "Status",
  postSummary: "Summary",
  postEditorName: "Editor",
  postCreatedAt: "Created at",
  postUpdatedAt: "Updated at",
  pageUrl: "Page URL",
  link: "Link",
  featuredImage: "Featured image",
  normalText: "Normal",
  heading1: "Heading 1",
  heading2: "Heading 2",
  heading3: "Heading 3",
  heading4: "Heading 4",
  bulletList: "Bullet List",
  numberedList: "Numbered List",
  checkList: "Check List",
  quote: "Quote",
  codeBlock: "Code Block",
  strikethrough: "Strikethrough",
  subscript: "Subscript",
  superscript: "Superscript",
  clearFormatting: "Clear Formatting",
  image: "Image",
  table: "Table",
  insertImage: "Insert Image",
  insertTable: "Insert Table",
  numberOfRows: "No of rows",
  numberOfColumns: "No of columns",
  file: "File",
  imageUrl: "Image URL",
  imageUpload: "Image Upload",
  instagram: "Instagram",
  altText: "Alt Text",
  altTextPlaceholder: "Descriptive alternative text",
  embedTweet: "Embed tweet",
  embedYouTubeVideo: "Embed YouTube video",
  addCaption: "Add Caption",
  removeCaption: "Remove Caption",
  enterCaption: "Enter a caption...",
  createPostSuccess: "The post has been created",
  updatePostSuccess: "The post has been updated",
  errorOccurred: "Error occurred",
  lineLink: "LINE Link",
  insertLineLink: "Insert LINE Link",
  lineUrl: "LINE Link URL",
  buttonText: "Button Text",
  buttonTextPlaceholder: "Consulting with travel experts on LINE",
  promotionText: "Promotion Text",
  promotionTextPlaceholder: "Reserve affordable trips overseas",
  insertRowAbove_one: "Insert row above",
  insertRowAbove_other: "Insert {{count}} rows above",
  insertRowBelow_one: "Insert row below",
  insertRowBelow_other: "Insert {{count}} rows below",
  insertColumnLeft_one: "Insert column left",
  insertColumnLeft_other: "Insert {{count}} columns left",
  insertColumnRight_one: "Insert column right",
  insertColumnRight_other: "Insert {{count}} columns right",
  deleteColumn: "Delete column",
  deleteRow: "Delete row",
  deleteTable: "Delete table",
  addRowHeader: "Add row header",
  addColumnHeader: "Add column header",
  removeRowHeader: "Remove row header",
  removeColumnHeader: "Remove column header",
  deletePostTitle: "Delete the post",
  deletePostDescription: "Delete {{title}}",
  backToPostList: "Back to post list",
  noChangesApplied: "No changes applied",
  scheduledOn: "Scheduled on {{date}}",
  scheduledPost: "Scheduled post",
  searchForm: "Search Form",
  insertSearchForm: "Insert Search Form"
};
;// CONCATENATED MODULE: ./main/javascripts/locales/component/reservationShow/en.ts
var en_reservationShow = {
  title: "Reservation Details",
  reservationId: "Reservation ID",
  reservationDate: "Reservation Date",
  accommodationDate: "Accommodation Date",
  flightSummary: "Flight Summary",
  travelerInfo: "Travelers Information",
  flightDetails: "Flight Details",
  priceSummary: "Price Summary",
  flightPriceSummary: "Flight Price Summary",
  hotelPriceSummary: "Hotel Price Summary",
  regulation: "Rules & Restrictions",
  help: "Help",
  hotelOverview: "Hotel Overview",
  cancellationPenalty: "Cancellation penalty of {{fee}} will occur",
  noCancellation: "No Cancellations",
  cancelThisRoom: "Cancel this room",
  customer: "Customers",
  roomType: "Room type",
  planContent: "Plan contents",
  guestName: "Guest name",
  room: "Rooms",
  hotelRoom: "Hotel rooms",
  hotelPolicy: "Hotel policy",
  hotelTitle: "Hotel",
  flightTitle: "Flight",
  hotel: "Hotel",
  totalPrice: "Total price",
  hotelSummary: "Hotel Summary",
  showHotelDetails: "Show hotel details",
  hotelCancelAndChange: "Hotel cancellations and changes",
  flightCancelAndChange: "Flight cancellations and changes",
  roomConfirmation: "Room confirmation",
  aboutHotel: "About hotel",
  aboutReservation: "About this reservation"
};
;// CONCATENATED MODULE: ./main/javascripts/locales/component/flightRegion/en.ts
var en_flightRegion = {
  flightCountryList: "List of destination countries for flights",
  flightRegionList: "Flight area in {{country}}"
};
;// CONCATENATED MODULE: ./main/javascripts/locales/component/hotelRegion/en.ts
var en_hotelRegion = {
  hotelCountryList: "List of destination countries for hotels",
  hotelRegionList: "Hotel area in {{country}}"
};
;// CONCATENATED MODULE: ./main/javascripts/locales/component/costItem/en.ts
var en_costItem = {
  serviceType_flight: "Flight",
  serviceType_hotel: "Hotel",
  serviceType_optional_tour: "Optional Tour",
  serviceType_railway: "Railway",
  totalPrice: "Price",
  totalFee: "Handling Fee"
};
;// CONCATENATED MODULE: ./main/javascripts/locales/component/post/en.ts
var en_post = {
  indexTitle: "Index",
  popularTags: "Popular Tags",
  rankingList: "Popular Posts",
  relatedPosts: "Related Posts",
  free: "FREE",
  allRegion: "Show all regions",
  hotelSearch: "Hotel Search",
  flightSearch: "Flight Search",
  dynamicPackageSearch: "Flight + Hotel Search",
  bestPriceSearch: "Best Price"
};
;// CONCATENATED MODULE: ./main/javascripts/locales/component/reputation/en.ts
var en_reputation = {
  title: "TabiChat's reputation",
  led: "In the post-trip survey,\n we received a 94% satisfaction rating.",
  reference: "Reference",
  voice1: "voice1",
  person1: "person1",
  voice2: "voice1",
  person2: "person1",
  voice3: "voice1",
  person3: "person1",
  voice4: "voice1",
  person4: "person1",
  voice5: "voice1",
  person5: "person1",
  voice6: "voice1",
  person6: "person1"
};
// EXTERNAL MODULE: ./main/javascripts/locales/component/emailUser/en.yml
var en = __webpack_require__(17362);
;// CONCATENATED MODULE: ./main/javascripts/locales/component/en.ts




























var componentEn = {
  common: en_common,
  flightReservationNew: en_flightReservationNew,
  flightReservationShow: en_flightReservationShow,
  flightIndex: en_flightIndex,
  hotelReservationShow: en_hotelReservationShow,
  hotelReservationNew: en_hotelReservationNew,
  hotelIndex: en_hotelIndex,
  hotelShow: en_hotelShow,
  search: en_search,
  form: en_form,
  modal: en_modal,
  consultationNew: en_consultationNew,
  dynamicPackage: en_dynamicPackage,
  dynamicPackageReservationNew: en_dynamicPackageReservationNew,
  consultationConditionEdit: en_consultationConditionEdit,
  consultationConditionShow: en_consultationConditionShow,
  carouselFlight: en_carouselFlight,
  error: en_error,
  lp: en_lp,
  cms: en_cms,
  reservationShow: en_reservationShow,
  reservation: reservation,
  flightRegion: en_flightRegion,
  hotelRegion: en_hotelRegion,
  costItem: en_costItem,
  post: en_post,
  reputation: en_reputation,
  emailUser: en.en
};
;// CONCATENATED MODULE: ./main/javascripts/locales/model/hotelReservation/en.ts
var hotelReservation = {
  status: {
    arranged: "reserved",
    cancelled: "cancelled"
  }
};
;// CONCATENATED MODULE: ./main/javascripts/locales/model/hotelArrangement/en.ts
var hotelArrangement = {
  stayNum: "{{stayNum}} Night"
};
;// CONCATENATED MODULE: ./main/javascripts/locales/model/hotelArrangementPlanFee/en.ts
var hotelArrangementPlanFee = {
  feeType: {
    mandatoryFee: "Mandatory Fee",
    mandatoryTax: "Mandatory Tax",
    resortFee: "Resort Fee"
  }
};
;// CONCATENATED MODULE: ./main/javascripts/locales/model/hotelArrangementPlan/en.ts
var hotelArrangementPlan = {
  numberOfAdult: "{{number}} Adults",
  numberOfChildren: "{{number}} Children",
  // 1の時はchildのが良い
  status: {
    arranged: "Arranged",
    cancelled: "Cancelled"
  },
  mealType: {
    nothing: "meal nothing",
    breakfast: "breakfast",
    dinner: "dinner",
    both: "both"
  }
};
;// CONCATENATED MODULE: ./main/javascripts/locales/model/hotelArrangementPlanPrice/en.ts
var hotelArrangementPlanPrice = {
  priceType: {
    baseRate: "Room Price",
    taxAndServiceFee: "Taxes & Fees",
    extraPersonFee: "Extra Person Fee",
    compensation: "Compensation",
    propertyFee: "Property Fee"
  }
};
;// CONCATENATED MODULE: ./main/javascripts/locales/model/flightArrangementTravelerPrice/en.ts
var flightArrangementTravelerPrice = {
  priceType: {
    baseFare: "Flight",
    taxAndSurcharge: "Taxes / Fuel Surcharge",
    arrangeFee: "Handling Charge",
    baggage: "Baggage",
    itinerary0Baggage: "Outward baggage",
    itinerary1Baggage: "Return baggage"
  }
};
;// CONCATENATED MODULE: ./main/javascripts/locales/model/flightReservation/en.ts
var flightReservation = {
  status: {
    arranged: "Reserved",
    cancelled: "Cancelled",
    unconfirmed: "Unconfirmed"
  }
};
;// CONCATENATED MODULE: ./main/javascripts/locales/model/flighArrangementPrice/en.ts
var flightArrangementPrice = {
  priceType: {
    taxes: "Taxes",
    bookingDistributionFee: "Booking distribution fee",
    distributionFee: "Distribution fee",
    roundingAdjustment: "Rounding adjustment",
    creditCardSurcharge: "Credit card surcharge",
    luggageSurcharge: "Luggage surcharge",
    comboServiceFee: "Combo service fee",
    bankConversionCharge: "Bank conversion charge",
    bankHandlingCharge: "Bank handling charge",
    reservedSeatsIncludedSurcharge: "Seat reservation surcharge",
    otherTaxes: "Other taxes",
    baggage: "Baggage",
    itinerary0Baggage: "Outward baggage",
    itinerary1Baggage: "Return baggage"
  }
};
;// CONCATENATED MODULE: ./main/javascripts/locales/model/reservation/en.ts
var en_reservation = {
  status: {
    arranged: "Reserved",
    cancelled: "Cancelled",
    unconfirmed: "Unconfirmed",
    created: "Created"
  }
};
;// CONCATENATED MODULE: ./main/javascripts/locales/model/en.ts









var modelEn = {
  hotelReservation: hotelReservation,
  hotelArrangement: hotelArrangement,
  hotelArrangementPlanFee: hotelArrangementPlanFee,
  hotelArrangementPlan: hotelArrangementPlan,
  hotelArrangementPlanPrice: hotelArrangementPlanPrice,
  flightArrangementTravelerPrice: flightArrangementTravelerPrice,
  flightArrangementPrice: flightArrangementPrice,
  flightReservation: flightReservation,
  reservation: en_reservation
};
;// CONCATENATED MODULE: ./main/javascripts/locales/model/hotelReservation/ja.ts
var ja_hotelReservation = {
  status: {
    arranged: "予約済み",
    cancelled: "キャンセル済み"
  }
};
;// CONCATENATED MODULE: ./main/javascripts/locales/model/hotelArrangement/ja.ts
var ja_hotelArrangement = {
  stayNum: "{{stayNum}}泊"
};
;// CONCATENATED MODULE: ./main/javascripts/locales/model/hotelArrangementPlanFee/ja.ts
var ja_hotelArrangementPlanFee = {
  feeType: {
    mandatoryFee: "フィー",
    mandatoryTax: "税",
    resortFee: "リゾートフィー"
  }
};
;// CONCATENATED MODULE: ./main/javascripts/locales/model/hotelArrangementPlan/ja.ts
var ja_hotelArrangementPlan = {
  numberOfAdult: "大人{{number}}人",
  numberOfChildren: "子供{{number}}人",
  status: {
    arranged: "手配済",
    cancelled: "キャンセル済"
  },
  mealType: {
    nothing: "食事なし",
    breakfast: "朝食付き",
    dinner: "夕食付き",
    both: "朝・夕付き",
    breakfast_and_dinner: "朝・夕付き"
  }
};
;// CONCATENATED MODULE: ./main/javascripts/locales/model/hotelArrangementPlanPrice/ja.ts
var ja_hotelArrangementPlanPrice = {
  priceType: {
    baseRate: "客室料金",
    taxAndServiceFee: "税及びサービス料",
    extraPersonFee: "エキストラ料金",
    compensation: "補償",
    propertyFee: "施設料金"
  }
};
;// CONCATENATED MODULE: ./main/javascripts/locales/model/flightArrangementTravelerPrice/ja.ts
var ja_flightArrangementTravelerPrice = {
  priceType: {
    baseFare: "航空券",
    taxAndSurcharge: "税 / 燃油サーチャージなど",
    arrangeFee: "取扱料金",
    baggage: "預け入れ手荷物",
    itinerary0Baggage: "預け入れ手荷物(往路)",
    itinerary1Baggage: "預け入れ手荷物(復路)"
  }
};
;// CONCATENATED MODULE: ./main/javascripts/locales/model/flightReservation/ja.ts
var ja_flightReservation = {
  status: {
    arranged: "予約済み",
    cancelled: "キャンセル済み",
    unconfirmed: "予約処理中・未確認"
  }
};
;// CONCATENATED MODULE: ./main/javascripts/locales/model/flighArrangementPrice/ja.ts
var ja_flightArrangementPrice = {
  priceType: {
    taxes: "税金",
    bookingDistributionFee: "予約販売手数料",
    distributionFee: "販売手数料",
    roundingAdjustment: "調整金額",
    creditCardSurcharge: "クレジットカードサーチャージ",
    luggageSurcharge: "手荷物サーチャージ",
    comboServiceFee: "コンボサービスフィー",
    bankConversionCharge: "通貨換算手数料",
    bankHandlingCharge: "銀行手数料",
    reservedSeatsIncludedSurcharge: "座席予約サーチャージ",
    otherTaxes: "その他",
    baggage: "預け入れ手荷物",
    itinerary0Baggage: "預け入れ手荷物(往路)",
    itinerary1Baggage: "預け入れ手荷物(復路)"
  }
};
;// CONCATENATED MODULE: ./main/javascripts/locales/model/reservation/ja.ts
var ja_reservation = {
  status: {
    arranged: "予約済み",
    cancelled: "キャンセル済み",
    unconfirmed: "予約処理中・未確認",
    created: "予約処理中"
  }
};
;// CONCATENATED MODULE: ./main/javascripts/locales/model/ja.ts









var modelJa = {
  hotelReservation: ja_hotelReservation,
  hotelArrangement: ja_hotelArrangement,
  hotelArrangementPlanFee: ja_hotelArrangementPlanFee,
  hotelArrangementPlan: ja_hotelArrangementPlan,
  hotelArrangementPlanPrice: ja_hotelArrangementPlanPrice,
  flightArrangementPrice: ja_flightArrangementPrice,
  flightArrangementTravelerPrice: ja_flightArrangementTravelerPrice,
  flightReservation: ja_flightReservation,
  reservation: ja_reservation
};
;// CONCATENATED MODULE: ./main/javascripts/locales/payment/gmo/en.ts
var gmo = {
  errors: {
    100: "カード番号が指定されていません",
    101: "カード番号に数字以外の文字が含まれています",
    102: "カード番号が10桁〜16桁の範囲ではありません",
    110: "有効期限が指定されていません",
    111: "有効期限に数字以外の文字以外の文字が含まれています",
    112: "有効期限が4桁または6桁ではありません",
    113: "有効期限の月が正しくありません",
    121: "セキュリティコードの書式が正しくありません",
    122: "セキュリティコードの書式が正しくありません",
    901: "クレジット決済が現在できません。時間を置いて実行してください",
    "default": "Credit card transaction could not be completed. Please check your card and try again."
  }
};
;// CONCATENATED MODULE: ./main/javascripts/locales/payment/en.ts

var paymentEn = {
  gmo: gmo
};
;// CONCATENATED MODULE: ./main/javascripts/locales/payment/gmo/ja.ts
var ja_gmo = {
  errors: {
    100: "カード番号が指定されていません",
    101: "カード番号に数字以外の文字が含まれています",
    102: "カード番号が10桁〜16桁の範囲ではありません",
    110: "有効期限が指定されていません",
    111: "有効期限に数字以外の文字以外の文字が含まれています",
    112: "有効期限が4桁または6桁ではありません",
    113: "有効期限の月が正しくありません",
    121: "セキュリティコードの書式が正しくありません",
    122: "セキュリティコードの書式が正しくありません",
    901: "クレジット決済が現在できません。時間を置いて実行してください",
    "default": "クレジット決済が完了できませんでした。カードをお確かめの上、再度実行してください。"
  }
};
;// CONCATENATED MODULE: ./main/javascripts/locales/payment/ja.ts

var paymentJa = {
  gmo: ja_gmo
};
;// CONCATENATED MODULE: ./main/javascripts/locales/constant/flightType/en.ts
var flightType = {
  roundTrip: "Return",
  oneWay: "Oneway",
  multiCity: "Multi-City"
};
;// CONCATENATED MODULE: ./main/javascripts/locales/constant/flightClass/en.ts
var flightClass = {
  economy: "ECONOMY",
  economyStandard: "ECONOMY",
  economyPremium: "ECONOMY PREMIUM",
  business: "BUSINESS",
  first: "FIRST"
};
;// CONCATENATED MODULE: ./main/javascripts/locales/constant/flightSortType/en.ts
var flightSortTypeForConsultation = {
  recommended: "Recommended",
  duration: "Shortest Duration",
  price: "Lowest Price"
};
;// CONCATENATED MODULE: ./main/javascripts/locales/constant/flightReservedSeatRequestType/en.ts
var flightReservedSeatRequestType = {
  none: "Not request",
  request_only_free: "Request only if it is free",
  request_with_fee: "Request with fee"
};
;// CONCATENATED MODULE: ./main/javascripts/locales/constant/hotelSortType/en.ts
var hotelSortTypeForConsultation = {
  recommended: "Recommended",
  price: "Lowest Price"
};
;// CONCATENATED MODULE: ./main/javascripts/locales/constant/hotelMealType/en.ts
var hotelMealType = {
  none: "None",
  breakfast: "Free breakfast"
};
;// CONCATENATED MODULE: ./main/javascripts/locales/constant/hotelViewType/en.ts
var hotelViewType = {
  oceanFront: "Ocean front",
  oceanView: "Ocean view",
  partialOceanView: "Partial ocean view",
  nothing: "Nothing"
};
;// CONCATENATED MODULE: ./main/javascripts/locales/constant/hotelBedSizeType/en.ts
var hotelBedSizeType = {
  single: "Single",
  "double": "Double",
  queen: "Queen",
  king: "King"
};
;// CONCATENATED MODULE: ./main/javascripts/locales/constant/searchMealType/en.ts
var searchMealType = {
  allMeals: "All meals",
  breakfastAndDinner: "Breakfast and dinner",
  breakfast: "Breakfast",
  lunch: "Lunch",
  dinner: "Dinner",
  nothing: "Nothing"
};
;// CONCATENATED MODULE: ./main/javascripts/locales/constant/companionType/en.ts
var companionType = {
  partner: "Partner",
  family: "Family",
  friend: "Friend",
  single: "Single",
  business: "Business"
};
;// CONCATENATED MODULE: ./main/javascripts/locales/constant/passengerType/en.ts
var passengerType = {
  adult: "Adult",
  child: "Child",
  infant: "Infant(0-1)"
};
;// CONCATENATED MODULE: ./main/javascripts/locales/constant/flightFreeBaggageType/en.ts
var flightFreeBaggageType = {
  all: "全ての経路で含む",
  partial: "一部の経路で含む"
};
;// CONCATENATED MODULE: ./main/javascripts/locales/constant/cityCode/en.ts
var cityCode = {
  PAR: "Paris",
  LON: "London",
  ROM: "Rome",
  BCN: "Barcelona",
  NYC: "New York",
  SFO: "San Francisco",
  TPE: "Taipei",
  SEL: "Seoul",
  SIN: "Singapore",
  HKG: "Hong Kong",
  DPS: "Bali",
  BKK: "Bangkok"
};
;// CONCATENATED MODULE: ./main/javascripts/locales/constant/postStatus/en.ts
var postStatus = {
  draft: "Draft",
  publish: "Published",
  scheduled: "Scheduled"
};
;// CONCATENATED MODULE: ./main/javascripts/locales/constant/searchType/en.ts
var searchType = {
  flight: "Flight",
  hotel: "Hotel",
  dynamicPackage: "Flight+Hotel"
};
;// CONCATENATED MODULE: ./main/javascripts/locales/constant/seo/en.ts
var seo = {
  siteName: "TabiChat",
  title: "Booking of overseas travel tours, hotels, and flights",
  titleConsultationConditionEdit: "Additional conditions for travel consultation",
  titleConsultationNew: "Entering conditions for travel consultation",
  titleHotelIndex: "Hotel Search",
  titleHotelShow: "{{name}} Hotel Reservation",
  titleFlightIndex: "Flight Search",
  titleFlightShow: "Flight Reservation",
  titleEmailUserSignIn: "Email Log in",
  description: "With TabiChat, you can book tours, hotels, and flights for your overseas trip. Chat with us and our concierge will suggest a plan for you.",
  descriptionConsultationConditionEdit: "You can add conditions to your travel consultation.",
  descriptionConsultationNew: "You can enter conditions for travel consultation.",
  descriptionHotelIndex: "TabiChat allows you to book hotels with the best deals and combinations!。",
  descriptionHotelShow: "Information on accommodation and reservations at {{name}}. TabiChat allows you to book hotels with the best deals and combinations.",
  descriptionEmailUserSignIn: "After logging in, you can [Reservation application|Search]."
};
;// CONCATENATED MODULE: ./main/javascripts/locales/constant/en.ts
















var constantEn = {
  flightType: flightType,
  flightClass: flightClass,
  flightSortTypeForConsultation: flightSortTypeForConsultation,
  flightReservedSeatRequestType: flightReservedSeatRequestType,
  hotelSortTypeForConsultation: hotelSortTypeForConsultation,
  hotelMealType: hotelMealType,
  hotelViewType: hotelViewType,
  hotelBedSizeType: hotelBedSizeType,
  searchMealType: searchMealType,
  companionType: companionType,
  passengerType: passengerType,
  flightFreeBaggageType: flightFreeBaggageType,
  cityCode: cityCode,
  postStatus: postStatus,
  searchType: searchType,
  seo: seo
};
;// CONCATENATED MODULE: ./main/javascripts/locales/constant/flightType/ja.ts
var ja_flightType = {
  roundTrip: "往復",
  oneWay: "片道",
  multiCity: "周遊(2都市以上)"
};
;// CONCATENATED MODULE: ./main/javascripts/locales/constant/flightClass/ja.ts
var ja_flightClass = {
  economy: "エコノミー",
  economyStandard: "エコノミー",
  economyPremium: "エコノミープレミアム",
  business: "ビジネス",
  first: "ファースト"
};
;// CONCATENATED MODULE: ./main/javascripts/locales/constant/flightSortType/ja.ts
var ja_flightSortTypeForConsultation = {
  recommended: "プロのおすすめ",
  duration: "移動時間短いフライト",
  price: "料金安いフライト"
};
;// CONCATENATED MODULE: ./main/javascripts/locales/constant/flightReservedSeatRequestType/ja.ts
var ja_flightReservedSeatRequestType = {
  none: "希望しない",
  request_only_free: "無料のときのみ希望",
  request_with_fee: "有料でも希望"
};
;// CONCATENATED MODULE: ./main/javascripts/locales/constant/hotelSortType/ja.ts
var ja_hotelSortTypeForConsultation = {
  recommended: "プロのおすすめ",
  price: "料金安いホテル"
};
;// CONCATENATED MODULE: ./main/javascripts/locales/constant/hotelMealType/ja.ts
var ja_hotelMealType = {
  none: "なし",
  breakfast: "朝食付き"
};
;// CONCATENATED MODULE: ./main/javascripts/locales/constant/hotelViewType/ja.ts
var ja_hotelViewType = {
  oceanFront: "オーシャンフロント",
  oceanView: "オーシャンビュー",
  partialOceanView: "パーシャルオーシャンビュー",
  nothing: "なし"
};
;// CONCATENATED MODULE: ./main/javascripts/locales/constant/hotelBedSizeType/ja.ts
var ja_hotelBedSizeType = {
  single: "シングル",
  "double": "ダブル",
  queen: "クイーン",
  king: "キング"
};
;// CONCATENATED MODULE: ./main/javascripts/locales/constant/searchMealType/ja.ts
var ja_searchMealType = {
  allMeals: "三食付き",
  breakfastAndDinner: "朝・夕付き",
  breakfast: "朝食付き",
  lunch: "昼食付き",
  dinner: "夕食付き",
  nothing: "なし"
};
;// CONCATENATED MODULE: ./main/javascripts/locales/constant/companionType/ja.ts
var ja_companionType = {
  partner: "恋人",
  family: "家族",
  friend: "友達",
  single: "一人",
  business: "仕事"
};
;// CONCATENATED MODULE: ./main/javascripts/locales/constant/passengerType/ja.ts
var ja_passengerType = {
  adult: "大人",
  child: "子供",
  infant: "幼児(0 ~ 1歳)"
};
;// CONCATENATED MODULE: ./main/javascripts/locales/constant/flightFreeBaggageType/ja.ts
var ja_flightFreeBaggageType = {
  all: "全ての経路で含む",
  partial: "一部の経路で含む"
};
;// CONCATENATED MODULE: ./main/javascripts/locales/constant/cityCode/ja.ts
var ja_cityCode = {
  PAR: "パリ",
  LON: "ロンドン",
  ROM: "ローマ",
  BCN: "バルセロナ",
  NYC: "ニューヨーク",
  SFO: "サンフランシスコ",
  TPE: "台北",
  SEL: "ソウル",
  SIN: "シンガポール",
  HKG: "香港",
  DPS: "バリ島",
  BKK: "バンコク"
};
;// CONCATENATED MODULE: ./main/javascripts/locales/constant/postStatus/ja.ts
var ja_postStatus = {
  draft: "下書き",
  publish: "公開済み",
  scheduled: "予約記事"
};
;// CONCATENATED MODULE: ./main/javascripts/locales/constant/searchType/ja.ts
var ja_searchType = {
  flight: "フライト",
  hotel: "ホテル",
  dynamicPackage: "フライト+ホテル"
};
;// CONCATENATED MODULE: ./main/javascripts/locales/constant/seo/ja.ts
var ja_seo = {
  tarip: "TARIP",
  siteName: "たびチャット",
  title: "海外旅行ツアー、ホテル、フライトの予約",
  tariptitle: "海外旅行・国内旅行メディア",
  titleConsultationConditionEdit: "旅行相談の条件追加",
  titleConsultationNew: "旅行相談の条件入力",
  titleHotelIndex: "ホテル検索",
  titleHotelShow: "{{name}} ホテル予約",
  titleFlightIndex: "フライト検索",
  titleFlightShow: "フライト予約",
  titleReputation: "たびチャットの評判",
  titleEmailUserSignIn: "メールログイン",
  description: "たびチャットでは海外旅行のツアー、ホテル、フライトの予約ができます。チャットで相談するとコンシェルジュがプランの提案をいたします。",
  taripdescription: "TARIPは国内旅行、海外旅行の行きたいところが見つかる旅行メディアです",
  descriptionConsultationConditionEdit: "旅行相談の条件追加ができます",
  descriptionConsultationNew: "旅行相談の条件入力ができます",
  descriptionHotelIndex: "たびチャットならお得なプランや組み合わせでホテルが予約できます。",
  descriptionHotelShow: "{{name}}の宿泊、予約情報。たびチャットならお得なプランや組み合わせでホテルが予約できます。",
  descriptionReputation: "たびチャットを実際に使って海外旅行に行った方の評判/口コミをご紹介します。",
  descriptionEmailUserSignIn: "ログイン後に[予約申込|検索]ができます"
};
;// CONCATENATED MODULE: ./main/javascripts/locales/constant/ja.ts
















var constantJa = {
  flightType: ja_flightType,
  flightClass: ja_flightClass,
  flightSortTypeForConsultation: ja_flightSortTypeForConsultation,
  flightReservedSeatRequestType: ja_flightReservedSeatRequestType,
  hotelSortTypeForConsultation: ja_hotelSortTypeForConsultation,
  hotelMealType: ja_hotelMealType,
  hotelViewType: ja_hotelViewType,
  hotelBedSizeType: ja_hotelBedSizeType,
  searchMealType: ja_searchMealType,
  companionType: ja_companionType,
  passengerType: ja_passengerType,
  flightFreeBaggageType: ja_flightFreeBaggageType,
  cityCode: ja_cityCode,
  postStatus: ja_postStatus,
  searchType: ja_searchType,
  seo: ja_seo
};
;// CONCATENATED MODULE: ./main/javascripts/locales/label/reservation/en.ts
var reservation_en_reservation = {
  firstName: "First Name",
  lastName: "Last Name",
  name: "Name",
  numberOfRooms: "{{number}} Room",
  roomIndex: "Room {{index}}",
  otherCharges: "Other charges:",
  totalPrice: "Trip Total",
  hotelFee: "Fee At The Property",
  priceBreakdown: "a breakdown of your price",
  breakdown: "Breakdown",
  email: "Email",
  creditCardNo: "Credit Card No",
  creditCardCvc: "Security Code",
  creditCardExpireMonth: "Expire Month",
  creditCardExpireYear: "Expire Year",
  phoneNumber: "Phone Number",
  address: "Address",
  travelerIndex: "Traveler {{index}}:",
  passenterIndex: "Passenger {{index}}:",
  primaryTraveler: "primary person",
  namePassportNotice: "Enter the names exactly as they appear on the passport.",
  nameOrderNotice: "Please note that you will not be able to board when entering your last and first name in reverse.",
  passportCountry: "Passport issuing country",
  dateOfBirth: "Date of birth",
  gender: "Gender",
  male: "Male",
  female: "Female",
  passportExpirationDate: "Passport date of expiry",
  passportNumber: "Passport number",
  nationalityCountryCode: "nationalityCountryCode",
  smokingRequest: "Smoking request",
  beddingRequest: "Bedding request",
  specialRequest: "Special request",
  agreement: "I agree to the above",
  numberOfGuests: "Number of Guests",
  roomAmenities: "Room Amenities",
  confirmNotice: "The reservation has not been completed yet. " + 'After confirming the contents, click the "COMPLETE BOOKING" button at the bottom of the screen.'
};
;// CONCATENATED MODULE: ./main/javascripts/locales/label/common/en.ts
var common_en_common = {
  checkin: "Checkin",
  checkout: "Checkout",
  checkinDate: "Checkin date",
  checkoutDate: "Checkout date",
  departureDate: "Departing",
  returnDate: "Returning",
  bookingClass: "Preferred class",
  destination: "Going to",
  origin: "Flying from",
  flightNumberOfAdult: "Adults(12+)",
  flightNumberOfChildren: "Children(0-11)",
  flightAgesOfChildren: "Age Of Children {{index}}",
  stopCount: "Stop count",
  departureTime: "Departure time",
  arrivalTime: "Arrival time",
  totalPrice: "Total price",
  airport: "Airport",
  unspecified: "Unspecified",
  flightNonstop: "Nonstop",
  flightStopUpTo: "Up to {{count}} stops",
  outboundCity: "Outbound",
  returnCity: "Return",
  departureCity: "City {{index}}",
  lastArrivalCity: "Last arrival city",
  price: "¥{{price}}",
  minMaxRange: "{{min}} ~ {{max}}",
  airportCity: "City {{index}}",
  cheapestFirst: "Cheapest",
  fastestFirst: "Fastest",
  recommended: "Recommended",
  addItinerary: "+ Add flight",
  removeItinerary: "- Remove flight",
  itinerary: "Itinerary",
  date: "Date",
  traveler: "Traveler",
  adultNum_one: "{{count}} adult",
  adultNum_other: "{{count}} adults",
  childNum_one: "{{count}} child",
  childNum_other: "{{count}} children",
  selectionCriteria: "Selection Criteria",
  none: "None",
  hotelRank: "Hotel grade",
  people: "Number of people",
  fromTotalPrice: "From the total price",
  flight: "Flight",
  flightEmail: "Flight",
  hotel: "Hotel",
  hotelEmail: "Hotel",
  request: "Request",
  recommendedPoints: "Recommended points",
  planContents: "Plan contents",
  rating: "Rating",
  pricePerPerson: "Price per person",
  common: "Common",
  hours: "hour",
  hours_other: "hours",
  useThis: "Use this",
  select: "Select",
  selectThisFlight: "Select this flight",
  or: "or",
  region: "Region",
  roomsLeft_one: "{{count}} room left",
  roomsLeft_other: "{{count}} rooms left",
  cancelFree: "There is no cancellation charge",
  book: "Book",
  detail: "Detail",
  showDetail: "Show detail",
  optional: "Optional",
  arrangementFee: "Arrangement fee",
  lteStayNum: "{{stayNum}} night or less",
  unselected: "Unselected",
  home: "home",
  orMore: "or more",
  evaluation: "Evaluation"
};
;// CONCATENATED MODULE: ./main/javascripts/locales/label/consultationCondition/en.ts
var consultationCondition = {
  withWhom: "Who are you going with?",
  hopeForHotel: "Hope for hotel",
  hopeForFlight: "Hope for flight"
};
;// CONCATENATED MODULE: ./main/javascripts/locales/label/flight/en.ts
var flight = {
  operatingAirline: "Operating Airline: {{name}}",
  toAirport: "To {{name}} ",
  departingFlight: "Depart",
  returningFlight: "Return",
  roundTripFlight: "Round trip",
  useLcc: "Use LCC",
  notUseLcc: "Do not use LCC",
  codeshare: "Codeshare",
  excludeCodeshare: "Exclude codeshare",
  reservedSeat: "Reserved seat",
  firstDepartureTime: "Departure time",
  lastArrivalTime: "Return time",
  baggageDisplay: "{{bags}} bag(s): {{weight}} ({{price}})",
  additionalBaggage: "Additional baggage",
  addBaggage: "Add baggage",
  quantityFreeBaggagePerPerson: "Free baggage allowance: up to {{quantity}} piece(s)/person",
  weightFreeBaggagePerPerson: "Free baggage allowance: up to {{weight}}kg(s)/person",
  quantityWeightFreeBaggagePerPerson: "Free baggage allowance: up to {{quantity}} ({{weight}}{{weightUnit}}(s)) piece(s)/person",
  noFreeBaggage: "No free baggage included",
  noFreeBaggageInformation: "Please Ask Because No information",
  itineraryNumber: "Itinerary {{index}}",
  baggageWithItinerary: "Itinerary{{index}}: {{baggageText}}",
  baggageAllowance: "【Free】Baggage Allowance",
  additionalBaggageAllowance: "【Paid】Baggage Allowance",
  bookingClass: "Booking class",
  departFrom: "From {{name}}",
  flightDetails: "Flight details",
  checkpoint: "Checkpoints",
  departureAirport: "Departure airport",
  arrivalAirport: "Arrival airport",
  transitAirport: "Transit airport",
  airline: "Airline",
  layover: "Stop hour",
  maxLayover: "Max stop hour",
  departureHour1: "Departure hour 1",
  departureHour2: "Departure hour 2",
  departureHour3: "Departure hour 3",
  departureHour4: "Departure hour 4",
  departureHour5: "Departure hour 5",
  lastDepartureHour: "Last departure hour",
  lastArrivalHour: "Last arrival hour",
  freeBaggageType: "Free baggage",
  agreement: "I agree to the above",
  outbound: "outbound",
  inbound: "inbound",
  selectedAdditionalBaggage: "【Added】Baggage Allowance",
  destination: "Going to",
  origin: "Leaving from",
  departureDate: "Departing",
  returnDate: "Returning",
  age: "Age",
  stopCount: "Stop count",
  sortBy: "Sort by"
};
;// CONCATENATED MODULE: ./main/javascripts/locales/label/hotel/en.ts
var hotel = {
  age: "Age",
  checkin: "Checkin",
  checkout: "Checkout",
  checkinDate: "Checkin date",
  checkoutDate: "Checkout date",
  destination: "Going to",
  hopeSeparateBed: "Separate beds",
  separateBeds: "One bed per person",
  mealRequest: "Hotel meal",
  nothing: "None",
  breakfast: "Breakfast",
  dinner: "Dinner",
  both: "Breakfast & Dinner",
  viewType: "View type",
  bedType: "Bed type",
  roomAmenity: "Room amenities",
  agreement: "I agree to the above",
  minRating: "Review rating"
};
;// CONCATENATED MODULE: ./main/javascripts/locales/label/formError/en.ts
var formError = {
  flightReservationTravelers: "Traveler {{index}}",
  roomIndex: "Room {{index}}",
  firstName: "First Name",
  lastName: "Last Name",
  name: "Name",
  email: "Email",
  cardNo: "Credit Card No",
  cvc: "Security Code",
  expireMonth: "Card Expire Month",
  expireYear: "Card Expire Year",
  phoneNumber: "Phone Number",
  address: "Address",
  passportCountry: "Passport issuing country",
  dateOfBirth: "Date of birth",
  birthday: "Date of birth",
  birthdayYear: "Date of birth(Year)",
  birthdayMonth: "Date of birth(Month)",
  birthdayDay: "Date of birth(Day)",
  sex: "Gender",
  passportExpirationDate: "Passport date of expiry",
  passportExpirationYear: "Passport date of expiry(Year)",
  passportExpirationMonth: "Passport date of expiry(Month",
  passportExpirationDay: "Passport date of expiry(Day)",
  passportNumber: "Passport number",
  nationality: "Nationality",
  flightReservationFailureAgreement: "Agree to the notes",
  reservationTravelers: "Traveler {{index}}",
  guests: "Room {{index}}"
};
;// CONCATENATED MODULE: ./main/javascripts/locales/label/cms/en.ts
var cms_en_cms = {
  title: "Title",
  summary: "Summary",
  tagList: "Tag list",
  lineFooterText: "Fixed LINE button text",
  relatedPostIds: "Related posts",
  scheduledApplyAt: "Scheduled apply at",
  searchTypes: "Search display type"
};
// EXTERNAL MODULE: ./main/javascripts/locales/label/form/en.yml
var form_en = __webpack_require__(50630);
// EXTERNAL MODULE: ./main/javascripts/locales/label/emailUser/en.yml
var emailUser_en = __webpack_require__(94085);
;// CONCATENATED MODULE: ./main/javascripts/locales/label/en.ts









var labelEn = {
  reservation: reservation_en_reservation,
  common: common_en_common,
  consultationCondition: consultationCondition,
  flight: flight,
  hotel: hotel,
  formError: formError,
  cms: cms_en_cms,
  form: form_en.en,
  emailUser: emailUser_en.en
};
;// CONCATENATED MODULE: ./main/javascripts/locales/label/reservation/ja.ts
var reservation_ja_reservation = {
  numberOfRooms: "客室数 {{number}}室",
  roomIndex: "客室 {{index}}",
  firstName: "名(英字)",
  lastName: "姓(英字)",
  name: "氏名(英字)",
  otherCharges: "その他の諸経費：",
  totalPrice: "合計料金",
  priceBreakdown: "料金内訳",
  breakdown: "内訳",
  hotelFee: "施設で支払う料金",
  email: "メールアドレス(半角英数字)",
  creditCardNo: "カード番号",
  creditCardCvc: "セキュリティコード",
  creditCardExpireMonth: "有効期限(月)",
  creditCardExpireYear: "有効期限(年)",
  phoneNumber: "電話番号(半角数字)",
  address: "住所",
  travelerIndex: "旅行者 {{index}} :",
  passengerIndex: "搭乗者 {{index}} :",
  primaryTraveler: "代表者",
  namePassportNotice: "パスポートに記載されているとおりに名前を入力してください",
  nameOrderNotice: "姓名を逆に入力されるとご搭乗いただけないためご注意ください",
  passportCountry: "パスポート発行国",
  dateOfBirth: "生年月日",
  gender: "性別",
  male: "男性",
  female: "女性",
  passportExpirationDate: "パスポート有効期間満了日",
  passportNumber: "パスポート番号",
  nationalityCountryCode: "国籍",
  smokingRequest: "禁煙/喫煙 リクエスト",
  beddingRequest: "ベッドタイプ リクエスト",
  specialRequest: "特別リクエスト",
  agreement: "上記の内容に同意する",
  numberOfGuests: "宿泊者内訳",
  roomAmenities: "部屋設備",
  confirmNotice: 'まだ予約は完了しておりません。内容をご確認の上、画面下部の"予約を完了する"ボタンを押してください。'
};
;// CONCATENATED MODULE: ./main/javascripts/locales/label/common/ja.ts
var ja_common = {
  checkin: "チェックイン",
  checkout: "チェックアウト",
  checkinDate: "チェックイン日",
  checkoutDate: "チェックアウト日",
  departureDate: "出発日",
  returnDate: "現地出発日",
  bookingClass: "座席の種類",
  destination: "目的地",
  origin: "出発地",
  flightNumberOfAdult: "大人(12歳以上)",
  flightNumberOfChildren: "子供(0～11歳)",
  flightAgesOfChildren: "お子様 {{index}}の年齢",
  durationOver1Hour: "{{hour}}時間{{minute}}分",
  durationUnder1Hour: "{{minute}}分",
  numberOfConnections_one: "直行便",
  numberOfConnections_other: "乗換{{count}}回",
  stopCount: "経由回数",
  departureTime: "出発時刻",
  arrivalTime: "到着時刻",
  totalPrice: "合計価格",
  airport: "空港",
  unspecified: "指定なし",
  flightNonstop: "直行便",
  flightStopUpTo: "{{count}} 回以下",
  outboundCity: "出発地",
  returnCity: "現地出発地",
  departureCity: "出発地 {{index}}",
  lastArrivalCity: "最終到着地",
  price: "{{price}}円",
  minMaxRange: "{{min}} ~ {{max}}",
  airportCity: "都市 {{index}}",
  cheapestFirst: "価格が低い順",
  fastestFirst: "時間が短い順",
  recommended: "おすすめ順",
  addItinerary: "+ 区間を追加",
  removeItinerary: "- 区間を削除",
  itinerary: "区間",
  date: "日付",
  traveler: "旅行者",
  adultNum_one: "大人 {{count}}名",
  adultNum_other: "大人 {{count}}名",
  childNum_one: "お子様 {{count}}名",
  childNum_other: "お子様 {{count}}名",
  selectionCriteria: "選択基準",
  none: "無し",
  hotelRank: "ホテルグレード",
  people: "人数",
  fromTotalPrice: "合計料金から",
  flight: "フライト",
  flightEmail: "フライト",
  hotel: "ホテル",
  hotelEmail: "ホテル",
  request: "希望内容",
  recommendedPoints: "おすすめポイント",
  planContents: "プラン内容",
  rating: "評価",
  pricePerPerson: "一人当たりの料金",
  common: "共通",
  hours: "時間",
  hours_other: "時間",
  useThis: "利用する",
  select: "選択する",
  selectThisFlight: "このフライトを選択する",
  or: "または",
  region: "地域",
  roomsLeft_one: "残り {{count}}部屋",
  roomsLeft_other: "残り {{count}}部屋",
  cancelFree: "キャンセル料無料",
  book: "予約する",
  detail: "詳細",
  showDetail: "詳細を見る",
  optional: "オプション",
  arrangementFee: "手配手数料",
  lteStayNum: "{{stayNum}}泊以下",
  unselected: "未選択",
  home: "ホーム",
  serviceType: "タイプ",
  breakdown: "内訳",
  orMore: "以上",
  evaluation: "評価"
};
;// CONCATENATED MODULE: ./main/javascripts/locales/label/consultationCondition/ja.ts
var ja_consultationCondition = {
  withWhom: "誰と行きますか？",
  hopeForHotel: "ホテルの希望",
  hopeForFlight: "フライトの希望"
};
;// CONCATENATED MODULE: ./main/javascripts/locales/label/flight/ja.ts
var ja_flight = {
  operatingAirline: "運行会社: {{name}}",
  toAirport: "{{name}}まで",
  departingFlight: "往路",
  returningFlight: "復路",
  roundTripFlight: "往復",
  useLcc: "LCCの利用",
  notUseLcc: "LCCを利用しない",
  codeshare: "コードシェア便",
  excludeCodeshare: "コードシェア便を除外する",
  reservedSeat: "座席指定",
  firstDepartureTime: "出国時刻",
  lastArrivalTime: "帰国時刻",
  baggageDisplay: "{{bags}}個: {{weight}}まで ({{price}})",
  additionalBaggage: "追加預け入れ手荷物",
  addBaggage: "預け入れ手荷物を追加",
  quantityFreeBaggagePerPerson: "預け入れ手荷物1名あたり{{quantity}}個まで無料",
  quantityWeightFreeBaggagePerPerson: "預け入れ手荷物1名あたり{{quantity}}個/{{weight}}{{weightUnit}}まで無料",
  weightFreeBaggagePerPerson: "預け入れ手荷物1名あたり{{weight}}{{weightUnit}}まで無料",
  noFreeBaggage: "預け入れ手荷物なし",
  noFreeBaggageInformation: "情報なしのためお問い合わせ",
  itineraryNumber: "経路 {{index}}",
  baggageWithItinerary: "経路{{index}}：{{baggageText}}",
  baggageAllowance: "【無料】預け入れ手荷物について",
  additionalBaggageAllowance: "【有料】預け入れ手荷物について",
  bookingClass: "予約クラス",
  departFrom: "{{name}}出発",
  flightDetails: "フライト詳細",
  checkpoint: "チェックポイント",
  departureAirport: "出発空港",
  arrivalAirport: "到着空港",
  transitAirport: "乗継空港",
  airline: "航空会社",
  layover: "乗継時間",
  maxLayover: "最大乗継時間",
  departureHour1: "出発時刻1",
  departureHour2: "出発時刻2",
  departureHour3: "出発時刻3",
  departureHour4: "出発時刻4",
  departureHour5: "出発時刻5",
  lastDepartureHour: "最終出発時刻",
  lastArrivalHour: "最終到着時刻",
  freeBaggageType: "無料預け入れ手荷物",
  agreement: "上記の内容に同意する",
  outbound: "往路",
  inbound: "復路",
  selectedAdditionalBaggage: "【追加済み】預け入れ手荷物について",
  destination: "目的地",
  origin: "出発地",
  departureDate: "出発日",
  returnDate: "現地出発日",
  age: "年齢",
  stopCount: "経由回数",
  sortBy: "並び替え"
};
;// CONCATENATED MODULE: ./main/javascripts/locales/label/hotel/ja.ts
var ja_hotel = {
  age: "年齢",
  checkin: "チェックイン",
  checkout: "チェックアウト",
  checkinDate: "チェックイン日",
  checkoutDate: "チェックアウト日",
  destination: "目的地",
  hopeSeparateBed: "同一ベッド(ダブルベッド等)不可",
  separateBeds: "一人一台のベッド",
  mealRequest: "食事希望",
  nothing: "食事なし",
  breakfast: "朝食付き",
  dinner: "夕食付き",
  both: "朝・夕付き",
  viewType: "客室からの眺望",
  bedType: "ベッドタイプ",
  roomAmenity: "部屋の設備・備品",
  agreement: "上記の内容に同意する",
  minRating: "レビュー評価"
};
;// CONCATENATED MODULE: ./main/javascripts/locales/label/formError/ja.ts
var ja_formError = {
  flightReservationTravelers: "旅行者 {{index}}",
  roomIndex: "客室 {{index}}",
  firstName: "名",
  lastName: "姓",
  name: "氏名",
  email: "メールアドレス",
  cardNo: "カード番号",
  cvc: "セキュリティコード",
  expireMonth: "カード有効期限(月)",
  expireYear: "カード有効期限(年)",
  phoneNumber: "電話番号",
  address: "住所",
  passportCountry: "パスポート発行国",
  dateOfBirth: "生年月日",
  birthday: "生年月日",
  birthdayYear: "生年月日(年)",
  birthdayMonth: "生年月日(月)",
  birthdayDay: "生年月日(日)",
  sex: "性別",
  passportExpirationDate: "パスポート有効期間満了日",
  passportExpirationYear: "パスポート有効期間(年)",
  passportExpirationMonth: "パスポート有効期間(月)",
  passportExpirationDay: "パスポート有効期間(日)",
  passportNumber: "パスポート番号",
  nationality: "国籍",
  flightReservationFailureAgreement: "注意事項への同意",
  reservationTravelers: "搭乗者 {{index}}",
  guests: "客室 {{index}}"
};
;// CONCATENATED MODULE: ./main/javascripts/locales/label/cms/ja.ts
var ja_cms = {
  title: "タイトル",
  summary: "概要",
  tagList: "タグ",
  lineFooterText: "固定LINEボタンテキスト",
  relatedPostIds: "関連記事",
  scheduledApplyAt: "公開予定日時",
  searchTypes: "検索表示タイプ"
};
// EXTERNAL MODULE: ./main/javascripts/locales/label/form/ja.yml
var form_ja = __webpack_require__(83559);
// EXTERNAL MODULE: ./main/javascripts/locales/label/emailUser/ja.yml
var emailUser_ja = __webpack_require__(753);
;// CONCATENATED MODULE: ./main/javascripts/locales/label/ja.ts









var labelJa = {
  reservation: reservation_ja_reservation,
  common: ja_common,
  consultationCondition: ja_consultationCondition,
  flight: ja_flight,
  hotel: ja_hotel,
  formError: ja_formError,
  cms: ja_cms,
  form: form_ja.ja,
  emailUser: emailUser_ja.ja
};
;// CONCATENATED MODULE: ./main/javascripts/locales/unit/en.ts
var unitEn = {
  durationOver1Hour: "{{hour}}:{{minute}}",
  durationUnder1Hour: "{{minute}}minutes",
  numberOfConnections_zero: "Direct",
  numberOfConnections_one: "{{count}} Transfer",
  numberOfConnections_other: "{{count}} Transfers",
  days: "{{count}}day",
  grade1: "one star",
  grade2: "two stars",
  grade3: "three stars",
  grade4: "four stars",
  grade5: "five stars",
  people: "{{num}} people",
  person_one: "{{count}} person",
  person_other: "{{count}} people",
  yearsOld: "{{num}} years old",
  rooms: "{{num}} rooms",
  bed_one: "{{count}} {{type}} bed",
  bed_other: "{{count}} {{type}} beds",
  sofaBed_one: "{{count}} {{type}} sofa bed",
  sofaBed_other: "{{count}} {{type}} sofa beds",
  futon_one: "{{count}} {{type}} futon",
  futon_other: "{{count}} {{type}} futons"
};
;// CONCATENATED MODULE: ./main/javascripts/locales/unit/ja.ts
var unitJa = {
  durationOver1Hour: "{{hour}}時間{{minute}}分",
  durationUnder1Hour: "{{minute}}分",
  numberOfConnections_zero: "直行便",
  numberOfConnections_one: "乗換{{count}}回",
  numberOfConnections_other: "乗換{{count}}回",
  days: "{{count}}日",
  grade1: "一ツ星",
  grade2: "二ツ星",
  grade3: "三ツ星",
  grade4: "四ツ星",
  grade5: "五ツ星",
  people: "{{num}}人",
  person_one: "{{count}}名",
  person_other: "{{count}}名",
  yearsOld: "{{num}}歳",
  rooms: "{{num}}室",
  bed_one: "{{type}}ベッド {{count}}台",
  bed_other: "{{type}}ベッド {{count}}台",
  sofaBed_one: "{{type}}ソファベッド {{count}}台",
  sofaBed_other: "{{type}}ソファベッド {{count}}台",
  futon_one: "{{type}}布団 {{count}}組",
  futon_other: "{{type}}布団 {{count}}組"
};
;// CONCATENATED MODULE: ./main/javascripts/locales/validation/en.ts
var validationEn = {
  infantsNumberMessage: "Number of infants mustn't be greater than number of adults",
  requiredInputMessage: "Required field",
  requiredDateMessage: "Enter a valid date",
  requiredSelectionMessage: "Select an option"
};
;// CONCATENATED MODULE: ./main/javascripts/locales/validation/ja.ts
var validationJa = {
  infantsNumberMessage: "1歳以下の幼児は大人の数以下にしてください",
  requiredInputMessage: "入力してください",
  requiredDateMessage: "日付を入力してください",
  requiredSelectionMessage: "選択してください"
};
;// CONCATENATED MODULE: ./main/javascripts/locales/button/common/en.ts
var button_common_en_common = {
  update: "UPDATE",
  create: "CREATE",
  createNew: "CREATE NEW",
  publish: "PUBLISH",
  saveDraft: "SAVE DRAFT",
  changeToDraft: "CHANGE TO DRAFT",
  add: "ADD",
  "delete": "DELETE",
  clear: "CLEAR",
  embed: "EMBED",
  dismiss: "DISMISS",
  showMore: "SHOW MORE",
  research: "SEARCH AGAIN",
  closeMore: "CLOSE",
  cancel: "CANCEL",
  reset: "RESET",
  reserve: "BOOK",
  detail: "DETAIL",
  schedule: "SCHEDULE",
  showAll: "Show all",
  showLess: "Show less",
  logIn: "LOG IN"
};
;// CONCATENATED MODULE: ./main/javascripts/locales/button/en.ts

var buttonEn = {
  common: button_common_en_common
};
;// CONCATENATED MODULE: ./main/javascripts/locales/button/common/ja.ts
var common_ja_common = {
  update: "更新する",
  create: "作成する",
  createNew: "新規作成",
  publish: "公開する",
  saveDraft: "下書き保存",
  changeToDraft: "下書きに変更",
  add: "追加",
  "delete": "削除",
  clear: "クリア",
  embed: "埋め込む",
  dismiss: "閉じる",
  showMore: "もっと見る",
  research: "再検索する",
  closeMore: "閉じる",
  cancel: "キャンセル",
  reset: "リセット",
  reserve: "予約する",
  detail: "詳細",
  schedule: "予約する",
  showAll: "すべて表示",
  showLess: "一部のみ表示",
  logIn: "ログイン"
};
;// CONCATENATED MODULE: ./main/javascripts/locales/button/ja.ts

var buttonJa = {
  common: common_ja_common
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/label/common/en.js
var label_common_en_common = {
  checkinDate: "Checkin date",
  checkoutDate: "Checkout date",
  departureDate: "Departing date",
  arrivalDate: "Arrival date",
  createdDate: "Created date",
  returnDate: "Returning date",
  cabinClass: "Preferred class",
  destination: "Going to",
  query: "Keyword for query",
  origin: "Flying from",
  date: "Date",
  schedule: "schedule",
  people: "Number of people",
  flightAgesOfChildren: "Child {{index}} age",
  agesOfChild: "Child {{index}} age",
  stopCount: "Stop count",
  departureTime: "Departure time",
  arrivalTime: "Arrival time",
  totalPrice: "Total price",
  priceIncludingOption: "Price inncluding option",
  airport: "Airport",
  unspecified: "Unspecified",
  flightNonstop: "Nonstop",
  flightStopUpTo: "Up to {{count}} stops",
  flightOverNightUpTo: "Up to {{count}} nights",
  outboundCity: "Outbound",
  returnCity: "Return",
  departureCity: "City {{index}}",
  lastArrivalCity: "Last arrival city",
  price: "Price",
  additionalPrice: "Additional price",
  airportCity: "City {{index}}",
  recommendedFirst: "Recommended first",
  cheapestFirst: "Cheapest first",
  highRankFirst: "High rank first",
  fastestFirst: "Fastest first",
  addItinerary: "+ Add flight",
  removeItinerary: "- Remove flight",
  numberOfRooms: "Rooms",
  room: "Room",
  hotelNumberOfAdult: "Adults(18+)",
  hotelNumberOfChildren: "Children(0-17)",
  flightNumberOfAdult: "Adults(12+)",
  flightNumberOfChildren: "Children(0-11)",
  chatUnitName: "Chat User Name",
  userId: "User Id",
  adult: "Adult",
  child: "Child",
  infant: "Infant",
  common: "Common",
  authorOnly: "Author Only",
  bot: "Bot",
  createNew: "New",
  list: "List",
  text: "Text",
  image: "Image",
  quickReply: "Quick Reply",
  arrangementType: "Arrangement type",
  tourTitle: "Tour title",
  tourId: "Tour ID",
  startDateTime: "Start date/time",
  endDateTime: "End date/time",
  startDate: "Start date",
  endDate: "End date",
  memo: "Memo",
  description: "Description",
  cancelPolicy: "Cancel policy",
  participant: "Participant",
  arrangementDone: "Done",
  totalFee: "Total fee",
  totalArrangementFee: "Total arrangement fee",
  reservationNumber: "Reservation number",
  passwordNumber: "Password Number",
  lastName: "Last name",
  firstName: "First name",
  address: "Address",
  phoneNumber: "Phone number",
  fee: "Fee",
  arrangementFee: "Arrangement fee",
  arrangementFeeShort: "Fee",
  cancellationCharge: "Cancellation charge",
  cancellationChargeIncludingFee: "Cancellation charge including ticketing company fee",
  name: "Name",
  status: "Status",
  gender: "Gender",
  birthday: "Date of birth",
  birthdayAmadeusFormat: "Date of birth (Amadeus notation)",
  rentalCarTitle: "Rental car title",
  rentalCarId: "Rental car ID",
  wifiTitle: "WiFi title",
  wifiId: "WiFi ID",
  railwayTitle: "Railway title",
  railwayId: "Railway ID",
  cruiseTitle: "Cruise title",
  cruiseId: "Cruise ID",
  insuranceTitle: "Insurance title",
  insuranceId: "Insurance ID",
  editingPreview: "▶︎ Editing Preview",
  sortBy: "Sort by",
  priority: "Priority",
  dealingStep: "Dealing Step",
  userMemo: "User Memo",
  shortIntroductionSentences: "Short Introduction Sentences",
  introductionSentences: "Introduction Sentences",
  recommendedSentencesList: "Recommended Sentences List",
  hotelSummaryReviews: "Hotel Summary Reviews",
  roomsLeft: "{{num}} rooms left",
  cancelFree: "There is no cancellation charge",
  tags: "Tags",
  enabling: "Enabling",
  priceRange: "Price range",
  hotelRank: "Hotel Rank",
  review: "Review",
  orMore: "or more",
  exist: "Exist",
  notExist: "Not exist",
  pricePerPersonPerNight: "Price per person, per night",
  flightIntroduction: "Flight Introduction",
  flightReservation: "Flight Reservation",
  tripPlans: "Trip Plans",
  hotelReservation: "Hotel Reservation",
  dynamicPackageReservation: "DP Reservation",
  editReservation: "Edit Reservation",
  hotelArrangementContents: "Hotel Arrangement Contents",
  flightArrangementContents: "Flight Arrangement Contents",
  optionalTourArrangementContents: "Optional Tour Arrangement Contents",
  rentalCarArrangementContents: "Rental Car Arrangement Contents",
  wifiArrangementContents: "WiFi Arrangement Contents",
  railwayArrangementContents: "Railway Arrangement Contents",
  cruiseArrangementContents: "Cruise Arrangement Contents",
  insuranceArrangementContents: "Insurance Arrangement Contents",
  otherArrangementContents: "Other Arrangement Contents",
  discountContents: "Discount Contents",
  userInformation: "User Information",
  paymentDetails: "Payment Details",
  chargeInformation: "Charge Information",
  passenger: "Passenger",
  guest: "Guest",
  companion: "Companion",
  hotelId: "Hotel ID",
  hotelName: "Hotel",
  roomName: "Room name",
  mealType: "Meal type",
  paymentType: "Payment type",
  numberOfPeopleToStay: "Number of people to stay",
  noCancellations: "No cancellations",
  itineraryNumber: "Itinerary number",
  theTimeWhenARateOccurs: "The time when a rate occurs",
  thisReservationIsManagedByBookingCom: "This reservation is managed by Booking.com.",
  thisReservationIsManagedByTaap: "This reservation is managed by Taap.",
  thisReservationIsManagedByJetstar: "This reservation is managed by Jetstar.",
  wholesaler: "Wholesaler",
  plan: "Plan",
  paymentName: "Payment name",
  creditCardUrl: "Credit card URL",
  bankTransferUrl: "Bank transfer URL",
  paymentMethod: "Payment method",
  paymentInformation: "Payment Information",
  paymentPrice: "Payment price",
  arrangement: "Arrangement",
  route: "Route",
  flight: "Flight",
  airline: "Airline",
  marketingAirline: "Marketing airline",
  operatingAirline: "Operating airline",
  operatingAirlineShort: "Operating",
  excludeAirline: "Airline to exclude",
  flightNumber: "Flight number",
  departureAirport: "Departure airport",
  arrivalAirport: "Arrival airport",
  transitAirport: "Transit airport",
  transfer: "Transfer",
  airlineID: "Airline ID",
  airportID: "Airport ID",
  numberOfAdults: "Number of adults",
  tripType: "Trip type",
  hotel: "hotel",
  overseasFlight: "Overseas flight",
  domesticFlight: "Domestic flight",
  overseasDynamicPackage: "Overseas DP",
  domesticDynamicPackage: "Domestic DP",
  totalPeople: "Number of people includes children",
  evaluation: "Evaluation",
  toAirport: "To {{name}} ",
  remainingPrice: "Remaining price",
  refundAmount: "Refund amount",
  refundAmountFromSupplier: "Refund amount from supplier",
  refundedDate: "Refunded date",
  refundedFeeAmount: "Refund fee amount we recieve",
  refundedAmountToUser: "Refund amount to customer",
  refundPaymentType: "Refund type",
  autoReply: "Auto Reply",
  reminder: "Reminder",
  scheduledSending: "Scheduled Sending",
  paymentDate: "Payment date",
  displayedPrice: "Displayed price",
  difference: "difference",
  commissionBackPrice: "Commission back price",
  commissionBackDate: "Commission back date",
  multiCity: "multi city",
  itineraries: "itineraries",
  category: "category",
  flightType: "flight type",
  section: "section",
  request: "request",
  maxPricePerPerson: "max price per person",
  minPricePerPerson: "min price per person",
  partner: "partner",
  family: "family",
  friend: "friend",
  single: "single",
  business: "business",
  hopeTravel: "Hope of the travel",
  selectionCriteria: "Selection Criteria",
  traveler: "Traveler",
  none: "None",
  reminderDate: "Date",
  hour: "h",
  minute: "m",
  hearingMode: "Hearing mode",
  notes: "Notes",
  checkpoint: "Important points",
  recommendedPoints: "Recommended points",
  planContents: "Plan contents",
  rating: "Rating",
  flightDetails: "Flight details",
  age: "Age",
  referenceNumber: "Airline reference number",
  hotelReservationId: "Hotel reservation number",
  hopeForHotel: "Hope for hotel",
  hopeForFlight: "Hope for flight",
  quickReplyActionData: "Action data",
  quickReplyLabel: "Label",
  quickReplyDisplayText: "Display text",
  baggage: "Baggage",
  itinerary0Baggage: "Outward baggage",
  itinerary1Baggage: "Return baggage",
  otherPerFlightFees: "Other fees (per flight)",
  arrangementInvoicedPrice: "Only invoiced price",
  arrangementPriceAndFeeSummary: "Arrangement+Fee",
  paymentPriceSummary: "Payment summary",
  revenue: "Revenue",
  layover: "Stop hour",
  minLayover: "Min stop hour",
  maxLayover: "Max stop hour",
  useThis: "Use this",
  departureHour1: "Departure hour 1",
  departureHour2: "Departure hour 2",
  departureHour3: "Departure hour 3",
  departureHour4: "Departure hour 4",
  departureHour5: "Departure hour 5",
  lastDepartureHour: "Last departure hour",
  lastArrivalHour: "Last arrival hour",
  minPrice: "Min price",
  maxPrice: "Max price",
  lowestPrice: "Lowest price",
  arrangementDate: "Arrangement Date",
  discountType: "Discount type",
  priceCurrency: "Currency",
  region: "Regions",
  recordedDate: "Date Recorded",
  or: "or",
  username: "Username",
  chatId: "Chat ID",
  amenity: "Amenities",
  stayDuration: "Stay duration",
  addPeriod: "+ Add period",
  message: "Message",
  scheduledAt: "Scheduled at",
  meal: "Meal",
  cleanliness: "Cleanliness",
  comfort: "Comfort",
  service: "Service",
  guestRoom: "Guest room",
  internet: "Internet",
  onsen: "Hot spring",
  kosupa: "Cost performance",
  location: "Location",
  landscape: "Landscape",
  quality: "Quality",
  transactionCompleteDate: "Transaction complete date",
  billingDate: "Billing date",
  totalRefundedAmount: "Total refunded amount",
  totalRefundFee: "Total refund fee",
  billerType: "Biller",
  billerName: "Biller company name",
  billerCountryCode: "Biller's country code",
  billerReservationNumber: "Reservation number of Biller",
  serviceType: "Service type",
  hotelPrice: "Hotel price",
  flightPrice: "Flight price",
  optionalTourPrice: "Optional tour price",
  railwayPrice: "Railway price",
  additionalBaggagePrice: "Additional baggage price",
  deadlineDate: "Deadline",
  optionType: "Option type",
  content: "Content",
  autoInputTraveler: "Automatic input of traveler name",
  updatedDesc: "Updated at (DESC)",
  updatedAsc: "Updated at (ASC)",
  lastMessageCreatedDesc: "MSG Created at (DESC)",
  lastMessageCreatedAsc: "MSG Created at (ASC)",
  showAllFilter: "Show all filters",
  showLessFilters: "Show less filters",
  optional: "Optional",
  smoking: "Smoking",
  noSmoking: "No smoking",
  billingPrice: "Billing price",
  transferFee: "Transfer fee",
  paymentFee: "Payment fee",
  members: "Members",
  type: "Type",
  executeDateTime: "Execute Date",
  remarks: "Remarks",
  targetDate: "Target Date",
  daysToShift: "Days To Shift",
  label: "Label",
  displayText: "Display text",
  button: "Button",
  carousel: "Carousel",
  chatUnitStatus: "Chat status",
  title: "Title",
  underage: "Underage",
  "true": "YES",
  "false": "NO",
  period: "Period",
  planId: "Plan ID",
  refundsToUser: "Refunds to users",
  noRefundsToUser: "No refunds to users",
  noRefundsForUser: "No refunds for users",
  edit: "Edit",
  externalImage: "External Image",
  transferDate: "Transfer Date",
  required: "Required",
  checkpoints: "Checkpoints",
  deadline: "Deadline",
  relayEmail: "Forwarded email",
  operatorOnlyEmail: "OP only email",
  relayToEmail: "Forwarding email",
  priceDifferenceDisplayable: "Price difference display",
  showPriceDifference: "Show price difference",
  uri: "URL",
  action: "Action",
  noData: "No Data"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/label/input/en.js
var input = {
  title: "Title：",
  image: "Image：",
  address: "Address：",
  introductionSentences: "Introduction Sentences：",
  freeWords: "Free Words",
  carouselSet: "Carousel Set",
  action: "Action",
  flight: "Flight",
  price: "Price: ",
  arrangeFee: "Fee: ",
  priceDisplay: "Price Display: ",
  yen: "YEN",
  placeholderSearchUser: "Search user by name or ID",
  placeholderImageUrl: "Input image url...",
  placeholderText: "Input text...",
  placeholderMemo: "Input memo...",
  placeholderRecommended: "Input recommended sentence...",
  placeholderInput: "Please input...",
  placeholderDestination: "Please input any destinations...",
  placeholderQuery: "Please input a keyword...",
  placeholderFlightCityOrAirport: "City name  or  Airport name",
  placeholderDate: "years / months / days",
  placeholderNameOrAddressOrUrl: "Please input any names or address or URL...",
  placeholderHope: "Input hope...",
  placeholderQuickReplyActionData: "action=action_data&action_id=1",
  placeholderQuickReplyActionLabel: "Label",
  placeholderQuickReplyActionDisplayText: "Display Text",
  placeholderHotelSelection: "Input hotel name...",
  placeholderAirlineSelection: "Input airline name...",
  placeholderSpecialRequest: "e.g. Extra bed 1",
  placeholderEmail: "Input email address...",
  placeholderScheduleName: "Input schedule name...",
  placeholderLineType: "Input LINE type..."
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/label/reservation/en.js
var label_reservation_en_reservation = {
  firstName: "First Name",
  lastName: "Last Name",
  numberOfRooms: "{{number}} Room",
  roomIndex: "Room {{index}}",
  totalPrice: "Trip Total",
  otherTaxesIncl: "other taxes incl",
  hotelFee: "Fee At The Property",
  priceBreakdown: "a breakdown of your price",
  email: "Email",
  creditCardNo: "Credit Card No",
  creditCardCvc: "Security Code",
  creditCardExpireMonth: "Expire Month",
  creditCardExpireYear: "Expire Year",
  phoneNumber: "Phone Number",
  address: "Address",
  travelerIndex: "Traveler {{index}}",
  primaryTraveler: "primary person",
  namePassportNotice: "Enter the names exactly as they appear on the passport.",
  passportCountry: "Passport issuing country",
  dateOfBirth: "Date of birth",
  gender: "Gender",
  male: "Male",
  female: "Female",
  breakdown: "Breakdown",
  book: "Book",
  additionalInformation: "Additional information",
  otherCharges: "Other charges",
  passportExpirationDate: "Passport date of expiry",
  passportNumber: "Passport number",
  nationalityCountryCode: "nationalityCountryCode",
  smokingRequest: "Smoking request",
  beddingRequest: "Bedding request",
  specialRequest: "Special request",
  cancellationPolicy: "Cancellation Policy",
  confirmationDeadLine: "Confirmation dead line",
  reservationDate: "Reservation date",
  travelStartDate: "Travel start date",
  travelEndDate: "Travel end date",
  flightDepartureDate: "Flight departure date",
  flightArrivalDate: "Flight arrival date",
  flightExternalServiceReservationId: "GDS reservation number",
  flightAirlineReservationId: "Airline reservation number",
  hotelCheckInDate: "Hotel check-in date",
  hotelCheckOutDate: "Hotel check-out date",
  hotelExternalServiceReservationId: "Hotel reservation ID (external)",
  hotelArrangementId: "Hotel arrangement ID (internal)",
  chatUser: "Chat user",
  chatUserId: "Chat user ID",
  chatUserName: "Chat user name",
  minRangeDate: "Min date",
  maxRangeDate: "Max date",
  reservationSearch: "Reservation search",
  paymentRelated: "Payment related",
  hasPayment: "Payment",
  hasAuthorizedPayment: "Authorized Payment",
  hasCharge: "Charge"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/label/masterMessage/en.js
var masterMessage = {
  botMessageList: "Bot Master Message List",
  platformTypeSelect: "Target:",
  groupTypeSelect: "Group type:",
  editMessage: "Edit Message",
  messageList: "Message List"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/label/hotel/en.js
var en_hotel = {
  hopeSeparateBed: "Separate beds",
  separateBeds: "One bed per person",
  mealRequest: "Hotel meal",
  rankSelection: "Hotel rank",
  recommendedGenre: "Recommended genre",
  viewType: "View type",
  bedSizeType: "Room type",
  bedSizeTypes: "Bed type",
  bedCount: "Number of beds",
  specificHotel: "Specific hotel",
  selectedHotel: "Selected hotel",
  amenity: "Amenities",
  smokingTypes: "Smoking type",
  roomAmenities: "Room Amenities",
  hotelAmenities: "Hotel Amenities",
  categories: "Hotel Category",
  spokenLanguages: "Hotel Languages",
  rank: "Hotel Rank",
  minRating: "Review",
  existIntroduction: "Introduction Sentences",
  mealType: "Meal type",
  region: "Regions",
  hotelId: "Selected hotel"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/label/flight/en.js
var en_flight = {
  operatingAirline: "Operating Airline: {{name}}",
  toAirport: "To {{name}} ",
  departingFlight: "Depart",
  returningFlight: "Return",
  maxDeparture1OvernightNum: "Depart overnight",
  maxLastOvernightNum: "Return overnight",
  useLcc: "Use LCC",
  notUseLcc: "Do not use LCC",
  reservedSeat: "Reserved seat",
  firstDepartureTime: "Departure time",
  lastArrivalTime: "Return time",
  baggageDisplay: "{{bags}} bag(s): {{weight}} ({{price}})",
  additionalBaggage: "Additional baggage",
  addBaggage: "Add baggage",
  freeBaggageType: "Free baggage",
  arrangementType: "Arrangement type",
  specificFlight: "Specific flight",
  overnight: "Overnight",
  overnightOutbound: "Overnight(Outbound)",
  overnightInbound: "Overnight(Inbound)",
  outbound: "Outbound",
  inbound: "Inbound",
  itinerary: "Itinerary{{index}}",
  codeshare: "Code sharing",
  excludeCodeshare: "Exclude code sharing",
  selectedAirline: "Selected airline",
  alliance: "Alliance",
  alliances: "Alliances",
  excludeAirlineCountry: "Exclude specific country airlines",
  excludeAirlineCountries: "Exclude specific country airlines",
  excludeTransitAirport: "Exclude specific transit airports",
  transit: "Transit",
  notChangeAirportWhenTransit: "Exclude flights with airport transfers when connecting",
  flightType: "Flight type",
  cabinClass: "Preferred class",
  flightNumberOfAdult: "Adults(12+)",
  flightNumberOfChildren: "Children(0-11)",
  maxStop: "Stop count",
  age: "Age"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/label/optionalTour/en.js
var optionalTour = {
  optionalTourCategory: "Categories",
  category: "Categories",
  query: "Keyword",
  region: "Destination"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/label/scenario/en.js
var scenario = {
  scenarioList: "Scenario List",
  messageGroup: "Message group",
  scenarioName: "Scenario name",
  keyword: "Keywords",
  keywordIndex: "Keyword {{index}}",
  addMessages: "Add messages",
  operation: "Operation",
  triggerCondition: "Trigger conditions",
  action: "Action",
  carousel: "Carousel",
  actionData: "Action data"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/label/chatNotification/en.js
var chatNotification = {
  admin: "ADMIN",
  regular_and_admin: "REGULAR",
  current_user: "YOU",
  "new": "NEW",
  confirmed: "CONFIRMED"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/label/crmMessageSchedule/en.js
var crmMessageSchedule = {
  crmMessageScheduleList: "CRM Message Schedule List",
  crmMessageSchedule: "CRM Message Schedule",
  crmMessageScheduleEdit: "Schedule edit",
  messageGroup: "Message group",
  scheduleName: "Schedule name",
  addMessages: "Add messages",
  operation: "Operation",
  triggerCondition: "Trigger conditions",
  action: "Action",
  carousel: "Carousel",
  actionData: "Action data",
  sendScheduleAt: "Send schedule at",
  sentAt: "Sent at",
  sendNow: "Send now",
  exclusionCondition: "Exclusion conditions",
  inclusionCondition: "Inclusion conditions",
  addConditions: "Adding conditions",
  minRangeDate: "Min date",
  maxRangeDate: "Max date",
  lineType: "LINE type",
  status: "Status",
  recipientsCount: "Number of recipients",
  chatUnitId: "Chat ID"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/label/masterMessageGroup/ja.js
var masterMessageGroup = {
  masterMessageGroupList: "メッセージグループ一覧",
  masterMessageGroupName: "メッセージグループ名",
  messageGroup: "メッセージグループ",
  groupType: "グループタイプ",
  addMessages: "メッセージを追加する",
  operation: "操作",
  action: "アクション",
  carousel: "カルーセル",
  actionData: "アクションデータ",
  messagePreview: "メッセージプレビュー"
};
// EXTERNAL MODULE: ./manager/javascripts/locales/label/form/en.yml
var label_form_en = __webpack_require__(80347);
// EXTERNAL MODULE: ./manager/javascripts/locales/label/arrangementPayment/en.yml
var arrangementPayment_en = __webpack_require__(93551);
// EXTERNAL MODULE: ./manager/javascripts/locales/label/arrangementRefund/en.yml
var arrangementRefund_en = __webpack_require__(33458);
// EXTERNAL MODULE: ./manager/javascripts/locales/label/chat/en.yml
var chat_en = __webpack_require__(81847);
// EXTERNAL MODULE: ./manager/javascripts/locales/label/user/en.yml
var user_en = __webpack_require__(21163);
// EXTERNAL MODULE: ./manager/javascripts/locales/label/question/en.yml
var question_en = __webpack_require__(83387);
// EXTERNAL MODULE: ./manager/javascripts/locales/label/inHouseNotice/en.yml
var inHouseNotice_en = __webpack_require__(17221);
// EXTERNAL MODULE: ./manager/javascripts/locales/label/lp/en.yml
var lp_en = __webpack_require__(16661);
// EXTERNAL MODULE: ./manager/javascripts/locales/label/emailChatUnit/en.yml
var emailChatUnit_en = __webpack_require__(15237);
;// CONCATENATED MODULE: ./manager/javascripts/locales/label/en.js




















var en_labelEn = {
  common: label_common_en_common,
  input: input,
  reservation: label_reservation_en_reservation,
  masterMessage: masterMessage,
  hotel: en_hotel,
  flight: en_flight,
  optionalTour: optionalTour,
  scenario: scenario,
  chatNotification: chatNotification,
  crmMessageSchedule: crmMessageSchedule,
  masterMessageGroup: masterMessageGroup,
  form: label_form_en.en,
  arrangementPayment: arrangementPayment_en.en,
  arrangementRefund: arrangementRefund_en.en,
  chat: chat_en.en,
  user: user_en.en,
  question: question_en.en,
  inHouseNotice: inHouseNotice_en.en,
  lp: lp_en.en,
  emailChatUnit: emailChatUnit_en.en
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/label/common/ja.js
var label_common_ja_common = {
  checkinDate: "チェックイン日時",
  checkoutDate: "チェックアウト日時",
  checkin: "チェックイン",
  checkout: "チェックアウト",
  departureDate: "出発日",
  arrivalDate: "到着日",
  createdDate: "作成日",
  returnDate: "現地出発日",
  cabinClass: "座席クラス",
  destination: "目的地",
  query: "キーワード",
  origin: "出発地",
  date: "日程",
  schedule: "日程",
  people: "人数",
  numberOfRooms: "客室数",
  room: "部屋",
  hotelNumberOfAdult: "大人(18歳以上)",
  hotelNumberOfChildren: "子供(0～17歳)",
  flightNumberOfAdult: "大人(12歳以上)",
  flightNumberOfChildren: "子供(0～11歳)",
  agesOfChild: "お子様 {{index}}の年齢",
  stopCount: "経由回数",
  departureTime: "出発時刻",
  arrivalTime: "到着時刻",
  totalPrice: "合計価格",
  priceIncludingOption: "オプションも含む料金",
  airport: "空港",
  unspecified: "指定なし",
  flightNonstop: "直行便",
  flightStopUpTo: "{{count}} 回以下",
  flightOverNightUpTo: "{{count}} 泊以下",
  outboundCity: "出発地",
  returnCity: "現地出発地",
  departureCity: "出発地 {{index}}",
  lastArrivalCity: "最終到着地",
  price: "料金",
  additionalPrice: "追加料金",
  minMaxRange: "{{min}} ~ {{max}}",
  airportCity: "都市 {{index}}",
  recommendedFirst: "おすすめ順",
  cheapestFirst: "価格が低い順",
  highRankFirst: "評価が高い順",
  fastestFirst: "時間が短い順",
  addItinerary: "+ 区間を追加",
  removeItinerary: "- 区間を削除",
  chatUnitName: "チャット名",
  userId: "User Id",
  adult: "大人",
  child: "子供",
  infant: "幼児",
  common: "共通",
  authorOnly: "作成者のみ",
  bot: "ボット",
  createNew: "新規作成",
  list: "一覧",
  text: "テキスト",
  image: "画像",
  quickReply: "クイック返信",
  arrangementType: "手配タイプ",
  tourTitle: "ツアー名",
  tourId: "ツアーID",
  startDateTime: "開始日時",
  endDateTime: "終了日時",
  startDate: "開始日",
  endDate: "終了日",
  memo: "メモ",
  description: "詳細",
  cancelPolicy: "キャンセルポリシー",
  participant: "参加者",
  arrangementDone: "手配完了",
  totalFee: "合計料金",
  totalArrangementFee: "合計手配料金",
  reservationNumber: "予約番号",
  passwordNumber: "暗証番号",
  lastName: "姓",
  firstName: "名",
  address: "住所",
  phoneNumber: "電話番号",
  fee: "料金",
  arrangementFee: "手配手数料",
  arrangementFeeShort: "手数料",
  cancellationCharge: "キャンセル料",
  cancellationChargeIncludingFee: "キャンセル料(発券会社の手数料含む)",
  name: "氏名",
  status: "ステータス",
  gender: "性別",
  birthday: "生年月日",
  birthdayAmadeusFormat: "生年月日(Amadeus表記)",
  rentalCarTitle: "レンタカー名",
  rentalCarId: "レンタカーID",
  wifiTitle: "WiFi名",
  wifiId: "WiFi ID",
  railwayTitle: "鉄道名",
  railwayId: "鉄道ID",
  cruiseTitle: "クルーズ名",
  cruiseId: "クルーズID",
  insuranceTitle: "保険名",
  insuranceId: "保険ID",
  editingPreview: "▶︎ 編集内容のプレビュー",
  sortBy: "並び替え",
  priority: "優先度",
  dealingStep: "工程",
  userMemo: "ユーザーメモ",
  shortIntroductionSentences: "ショート紹介文",
  introductionSentences: "紹介文",
  recommendedSentencesList: "おすすめ一覧",
  hotelSummaryReviews: "口コミ要約",
  roomsLeft: "残り {{num}}部屋",
  cancelFree: "キャンセル料無料",
  tags: "タグ",
  enabling: "有効",
  priceRange: "予算",
  hotelRank: "ホテルランク",
  review: "レビュー",
  orMore: "以上",
  exist: "あり",
  notExist: "なし",
  pricePerPersonPerNight: "1名1泊あたりの価格",
  flightIntroduction: "フライト案内",
  flightReservation: "フライト予約",
  reservation: "予約",
  tripPlans: "旅行プラン",
  hotelReservation: "ホテル予約",
  dynamicPackageReservation: "DP予約",
  editReservation: "予約編集",
  hotelArrangementContents: "ホテル手配内容",
  flightArrangementContents: "フライト手配内容",
  optionalTourArrangementContents: "オプショナルツアー手配内容",
  rentalCarArrangementContents: "レンタカー手配内容",
  wifiArrangementContents: "WiFi手配内容",
  railwayArrangementContents: "鉄道手配内容",
  cruiseArrangementContents: "クルーズ手配内容",
  insuranceArrangementContents: "保険手配内容",
  otherArrangementContents: "その他手配内容",
  discountContents: "割引内容",
  userInformation: "ユーザー情報",
  paymentDetails: "支払い内容",
  chargeInformation: "請求情報",
  passenger: "搭乗者",
  guest: "お客様",
  companion: "お連れ様",
  hotelId: "ホテルID",
  hotelName: "ホテル",
  roomName: "部屋名",
  mealType: "食事タイプ",
  paymentType: "支払いタイプ",
  numberOfPeopleToStay: "宿泊者数",
  noCancellations: "キャンセル不可",
  itineraryNumber: "旅程番号",
  theTimeWhenARateOccurs: "料金が発生する時間",
  thisReservationIsManagedByBookingCom: "Booking.comで予約管理",
  thisReservationIsManagedByTaap: "Taapで予約管理",
  thisReservationIsManagedByJetstar: "Jetstarで予約管理",
  wholesaler: "ホールセラー",
  plan: "プラン",
  paymentName: "支払い名目",
  creditCardUrl: "クレジットURL",
  bankTransferUrl: "銀行振込URL",
  paymentMethod: "決済方法",
  paymentInformation: "支払情報",
  refundInformation: "返金情報",
  paymentPrice: "支払金額",
  refundPrice: "返金金額",
  refundPaymentType: "返金方法",
  arrangement: "手配",
  route: "経路",
  flight: "フライト",
  airline: "航空会社",
  marketingAirline: "マーケティング航空会社",
  operatingAirline: "オペレーティング航空会社",
  operatingAirlineShort: "運航会社",
  excludeAirline: "除外する航空会社",
  flightNumber: "便",
  departureAirport: "出発空港",
  arrivalAirport: "到着空港",
  transitAirport: "乗継空港",
  transfer: "乗継",
  airlineID: "航空会社ID",
  airportID: "空港ID",
  numberOfAdults: "大人の人数",
  tripType: "旅行タイプ",
  hotel: "ホテル",
  overseasFlight: "海外航空",
  domesticFlight: "国内航空",
  overseasDynamicPackage: "海外DP",
  domesticDynamicPackage: "国内DP",
  totalPeople: "人数(子供含む)",
  evaluation: "評価",
  toAirport: "{{name}}まで",
  remainingPrice: "残金",
  refundAmount: "返金額",
  refundAmountFromSupplier: "サプライヤーからの返金額",
  refundedDate: "返金日",
  refundedFeeAmount: "弊社が受取る返金手数料",
  refundedAmountToUser: "お客さんへの返金額",
  autoReply: "自動応答設定",
  reminder: "リマインダー",
  scheduledSending: "時間指定送信",
  paymentDate: "支払日",
  displayedPrice: "表示料金",
  difference: "差額",
  commissionBackPrice: "コミッションバック金額",
  commissionBackDate: "コミッションバック日",
  multiCity: "周遊",
  itineraries: "周遊",
  category: "カテゴリー",
  flightType: "フライトタイプ",
  section: "区間",
  request: "希望",
  maxPricePerPerson: "一人当たりの最大料金",
  minPricePerPerson: "一人当たりの最小料金",
  pricePerPerson: "一人当たりの料金",
  partner: "恋人",
  family: "家族",
  friend: "友達",
  single: "一人",
  business: "仕事",
  hopeTravel: "旅の希望",
  selectionCriteria: "選択基準",
  traveler: "旅行者",
  none: "無し",
  reminderDate: "日付",
  hour: "時",
  hours: "時間",
  minute: "分",
  hearingMode: "ヒアリングモード",
  notes: "備考",
  checkpoint: "チェックポイント",
  recommendedPoints: "おすすめポイント",
  planContents: "プラン内容",
  rating: "評価",
  flightDetails: "フライト詳細",
  age: "年齢",
  referenceNumber: "航空会社の予約番号",
  hotelReservationId: "ホテルの予約番号",
  hopeForHotel: "ホテルの希望",
  hopeForFlight: "フライトの希望",
  quickReplyActionData: "アクションデータ",
  quickReplyLabel: "ラベル",
  quickReplyDisplayText: "表示テキスト",
  freeBaggage: "無料預け入れ手荷物",
  additionalBaggage: "有料預け入れ手荷物",
  baggage: "預け入れ手荷物",
  itinerary0Baggage: "預け入れ手荷物 (往路)",
  itinerary1Baggage: "預け入れ手荷物 (復路)",
  otherPerFlightFees: "フライトごとのフィー",
  arrangementInvoicedPrice: "請求中のみ合計",
  arrangementPriceAndFeeSummary: "手配+手数料合計",
  paymentPriceSummary: "入金額合計",
  revenue: "収益",
  layover: "乗継時間",
  minLayover: "最小乗継時間",
  maxLayover: "最大乗継時間",
  useThis: "利用する",
  departureHour1: "出発時刻1",
  departureHour2: "出発時刻2",
  departureHour3: "出発時刻3",
  departureHour4: "出発時刻4",
  departureHour5: "出発時刻5",
  lastDepartureHour: "最終出発時刻",
  lastArrivalHour: "最終到着時刻",
  minPrice: "最低価格",
  maxPrice: "最高価格",
  lowestPrice: "最安価格",
  arrangementDate: "手配日",
  discountType: "割引タイプ",
  priceCurrency: "通貨",
  region: "地域",
  recordedDate: "計上日",
  or: "または",
  username: "ユーザー名",
  chatId: "チャットID",
  amenity: "部屋の設備",
  stayDuration: "旅行日数",
  addPeriod: "+ 期間を追加",
  message: "メッセージ",
  scheduledAt: "予定日時",
  meal: "食事",
  cleanliness: "清潔さ",
  comfort: "快適さ",
  service: "サービス",
  guestRoom: "客室",
  internet: "インターネット",
  onsen: "風呂・温泉",
  kosupa: "価格",
  location: "ロケーション",
  landscape: "眺望",
  quality: "クオリティ",
  transactionCompleteDate: "決済完了日",
  billingDate: "請求日",
  totalRefundedAmount: "合計返金額",
  totalRefundFee: "合計返金手数料",
  billerType: "請求元",
  billerName: "請求元会社名",
  billerCountryCode: "請求元の国コード",
  billerReservationNumber: "請求元の予約番号",
  serviceType: "サービスタイプ",
  hotelPrice: "ホテル費用",
  flightPrice: "フライト費用",
  optionalTourPrice: "オプショナルツアー費用",
  railwayPrice: "鉄道費用",
  additionalBaggagePrice: "預け入れ手荷物費用",
  deadlineDate: "期限",
  optionType: "オプションタイプ",
  content: "内容",
  autoInputTraveler: "旅行者姓名の自動入力",
  updatedDesc: "更新順 (新→古)",
  updatedAsc: "更新順 (古→新)",
  lastMessageCreatedDesc: "メッセージ作成順 (新→古)",
  lastMessageCreatedAsc: "メッセージ作成順 (古→新)",
  showAllFilters: "すべてのフィルタを表示",
  showLessFilters: "フィルタ表示を減らす",
  optional: "オプション",
  smoking: "喫煙",
  noSmoking: "禁煙",
  billingPrice: "請求料金",
  transferFee: "振込手数料",
  paymentFee: "決済手数料",
  members: "関連ユーザー",
  type: "タイプ",
  executeDateTime: "実施日時",
  remarks: "備考",
  targetDate: "指定日",
  daysToShift: "ずらす日数",
  label: "ラベル",
  displayText: "表示テキスト",
  button: "ボタン",
  carousel: "カルーセル",
  chatUnitStatus: "ヒアリングステータス",
  title: "タイトル",
  underage: "未成年",
  "true": "はい",
  "false": "いいえ",
  period: "期間",
  planId: "プランID",
  refundsToUser: "ユーザーへの返金",
  noRefundsToUser: "ユーザーに返金しない",
  noRefundsForUser: "ユーザーへの返金なし",
  edit: "編集",
  externalImage: "外部画像",
  transferDate: "振込日",
  required: "必須",
  checkpoints: "チェックポイント",
  deadline: "期限",
  relayEmail: "転送メール",
  operatorOnlyEmail: "OPのみ転送メール",
  relayToEmail: "転送先メール",
  priceDifferenceDisplayable: "差額の表示",
  showPriceDifference: "差額を表示する",
  uri: "URL",
  action: "アクション",
  noData: "データなし"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/label/input/ja.js
var ja_input = {
  title: "タイトル：",
  image: "画像：",
  address: "住所：",
  introductionSentences: "紹介文：",
  freeWords: "フリーワード：",
  carouselSet: "カルーセルセット",
  action: "アクション",
  flight: "フライト",
  price: "料金：",
  arrangeFee: "手数料：",
  priceDisplay: "料金表示：",
  yen: "円",
  placeholderSearchUser: "ユーザーを名前やIDで検索",
  placeholderImageUrl: "画像URLを入力...",
  placeholderText: "テキストを入力...",
  placeholderMemo: "メモを入力...",
  placeholderRecommended: "おすすめを入力...",
  placeholderInput: "入力してください...",
  placeholderDestination: "行き先を入力してください...",
  placeholderQuery: "キーワードを入力してください...",
  placeholderFlightCityOrAirport: "都市名 または 空港名",
  placeholderDate: "年 / 月 / 日",
  placeholderNameOrAddressOrUrl: "名前か住所かURLを入力してください...",
  placeholderHope: "旅の希望を入力...",
  placeholderQuickReplyActionData: "action=action_data&action_id=1",
  placeholderQuickReplyActionLabel: "ラベル",
  placeholderQuickReplyActionDisplayText: "表示テキスト",
  placeholderHotelSelection: "ホテル名を入力してください...",
  placeholderAirlineSelection: "航空会社名を入力してください...",
  placeholderSpecialRequest: "例) Extra bed 1",
  placeholderEmail: "メールアドレスを入力...",
  placeholderScheduleName: "スケジュール名を入力してください...",
  placeholderLineType: "LINEタイプを入力してください..."
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/label/reservation/ja.js
var label_reservation_ja_reservation = {
  numberOfRooms: "客室数 {{number}}室",
  roomIndex: "客室 {{index}}",
  firstName: "名(英字)",
  lastName: "姓(英字)",
  totalPrice: "合計料金",
  otherTaxesIncl: "含む税金",
  priceBreakdown: "料金内訳",
  hotelFee: "施設で支払う料金",
  email: "メールアドレス(半角英数字)",
  creditCardNo: "カード番号",
  creditCardCvc: "セキュリティコード",
  creditCardExpireMonth: "有効期限(月)",
  creditCardExpireYear: "有効期限(年)",
  phoneNumber: "電話番号(半角数字)",
  address: "住所",
  travelerIndex: "旅行者 {{index}}",
  primaryTraveler: "代表者",
  namePassportNotice: "パスポートに記載されているとおりに名前を入力してください",
  passportCountry: "パスポート発行国",
  dateOfBirth: "生年月日",
  gender: "性別",
  male: "男性",
  female: "女性",
  breakdown: "内訳",
  book: "予約する",
  additionalInformation: "追加情報",
  otherCharges: "その他の諸経費",
  passportExpirationDate: "パスポート有効期間満了日",
  passportNumber: "パスポート番号",
  nationalityCountryCode: "国籍",
  smokingRequest: "禁煙/喫煙 リクエスト",
  beddingRequest: "ベッドタイプ リクエスト",
  specialRequest: "特別リクエスト",
  cancellationPolicy: "キャンセル規定",
  confirmationDeadLine: "予約確定期限",
  reservationDate: "予約日",
  travelStartDate: "旅行開始日",
  travelEndDate: "旅行終了日",
  flightDepartureDate: "フライト出発日",
  flightArrivalDate: "フライト到着日",
  flightExternalServiceReservationId: "GDS予約番号",
  flightAirlineReservationId: "航空会社予約番号",
  hotelCheckInDate: "ホテルチェックイン日",
  hotelCheckOutDate: "ホテルチェックアウト日",
  hotelExternalServiceReservationId: "ホテルの旅程番号(外部)",
  hotelArrangementId: "ホテルの手配番号(内部)",
  chatUser: "チャットユーザー",
  chatUserId: "チャットユーザーID",
  chatUserName: "チャットユーザー名",
  minRangeDate: "最小の日付",
  maxRangeDate: "最大の日付",
  reservationSearch: "予約検索",
  paymentRelated: "入金関連",
  lastChargeDate: "最終請求日",
  lastPaymentDate: "最終入金日",
  hasPayment: "入金",
  hasAuthorizedPayment: "オーソリ中の入金",
  hasCharge: "請求"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/label/masterMessage/ja.js
var ja_masterMessage = {
  botMessageList: "ボットメッセージ一覧",
  platformTypeSelect: "対象:",
  groupTypeSelect: "グループタイプ:",
  editMessage: "メッセージ編集",
  messageList: "メッセージ一覧"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/label/hotel/ja.js
var hotel_ja_hotel = {
  hopeSeparateBed: "同一ベッド(ダブルベッド等)不可",
  separateBeds: "一人一台のベッド",
  mealRequest: "食事希望",
  rankSelection: "グレード指定",
  recommendedGenre: "おすすめジャンル",
  viewType: "眺望タイプ",
  bedSizeType: "部屋タイプ",
  bedSizeTypes: "ベッドタイプ",
  bedCount: "ベッド数",
  specificHotel: "特定のホテル",
  selectedHotel: "指定ホテル",
  amenity: "アメニティ",
  smokingTypes: "喫煙 / 禁煙",
  roomAmenities: "部屋の設備",
  hotelAmenities: "ホテル設備",
  categories: "ホテルタイプ",
  spokenLanguages: "ホテル対応言語",
  rank: "ホテルランク",
  minRating: "レビュー",
  existIntroduction: "紹介文",
  mealType: "食事タイプ",
  region: "地域",
  hotelId: "指定ホテル"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/label/flight/ja.js
var flight_ja_flight = {
  operatingAirline: "運行会社: {{name}}",
  toAirport: "{{name}}まで",
  departingFlight: "往路",
  returningFlight: "復路",
  maxDeparture1OvernightNum: "往路の機内泊",
  maxLastOvernightNum: "復路の機内泊",
  useLcc: "LCCの利用",
  notUseLcc: "LCCを利用しない",
  reservedSeat: "座席指定",
  firstDepartureTime: "出国時刻",
  lastArrivalTime: "帰国時刻",
  baggageDisplay: "{{bags}}個: {{weight}}まで ({{price}})",
  additionalBaggage: "追加預け入れ手荷物",
  addBaggage: "預け入れ手荷物を追加",
  freeBaggageType: "無料預け入れ手荷物",
  arrangementType: "手配タイプ",
  specificFlight: "特定のフライト",
  overnight: "機内泊",
  overnightOutbound: "機内泊(OUT)",
  overnightInbound: "機内泊(IN)",
  outbound: "往路",
  inbound: "復路",
  codeshare: "コードシェア便",
  itinerary: "経路{{index}}",
  excludeCodeshare: "コードシェア便を除外する",
  selectedAirline: "指定航空会社",
  alliance: "アライアンス",
  alliances: "アライアンス",
  excludeAirlineCountry: "特定国の航空会社の除外",
  excludeAirlineCountries: "特定国の航空会社の除外",
  excludeTransitAirport: "特定乗継空港の除外",
  transit: "乗り継ぎ",
  notChangeAirportWhenTransit: "乗り継ぎ時に空港移動があるフライトを除外する",
  flightType: "フライトタイプ",
  departureDate: "出発日",
  returnDate: "現地出発日",
  cabinClass: "座席クラス",
  flightNumberOfAdult: "大人(12歳以上)",
  flightNumberOfChildren: "子供(0～11歳)",
  maxStop: "経由回数",
  age: "年齢"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/label/optionalTour/ja.js
var ja_optionalTour = {
  optionalTourCategory: "テーマ",
  category: "テーマ",
  query: "キーワード",
  region: "目的地"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/label/scenario/ja.js
var ja_scenario = {
  scenarioList: "シナリオ一覧",
  messageGroup: "メッセージグループ",
  scenarioName: "シナリオ名",
  keyword: "キーワード",
  keywordIndex: "キーワード {{index}}",
  addMessages: "メッセージを追加する",
  operation: "操作",
  triggerCondition: "発動条件",
  action: "アクション",
  carousel: "カルーセル",
  actionData: "アクションデータ"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/label/chatNotification/ja.js
var ja_chatNotification = {
  admin: "ADMIN",
  regular_and_admin: "REGULAR",
  current_user: "YOU",
  "new": "新規",
  confirmed: "確認済み"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/label/crmMessageSchedule/ja.js
var ja_crmMessageSchedule = {
  crmMessageScheduleList: "CRMメッセージスケジュール一覧",
  crmMessageSchedule: "CRMメッセージスケジュール",
  crmMessageScheduleEdit: "スケジュール編集",
  messageGroup: "メッセージグループ",
  scheduleName: "スケジュール名",
  addMessages: "メッセージを追加する",
  operation: "操作",
  triggerCondition: "発動条件",
  action: "アクション",
  carousel: "カルーセル",
  actionData: "アクションデータ",
  sendScheduleAt: "配信予定日時",
  sentAt: "配信日時",
  sendNow: "すぐに配信する",
  exclusionCondition: "除外条件",
  inclusionCondition: "フィルタ条件",
  addConditions: "条件の追加",
  minRangeDate: "最小の日付",
  maxRangeDate: "最大の日付",
  lineType: "LINEタイプ",
  status: "ステータス",
  recipientsCount: "対象人数",
  chatUnitId: "チャットID"
};
// EXTERNAL MODULE: ./manager/javascripts/locales/label/form/ja.yml
var label_form_ja = __webpack_require__(64516);
// EXTERNAL MODULE: ./manager/javascripts/locales/label/arrangementPayment/ja.yml
var arrangementPayment_ja = __webpack_require__(13029);
// EXTERNAL MODULE: ./manager/javascripts/locales/label/arrangementRefund/ja.yml
var arrangementRefund_ja = __webpack_require__(26764);
// EXTERNAL MODULE: ./manager/javascripts/locales/label/chat/ja.yml
var chat_ja = __webpack_require__(10413);
// EXTERNAL MODULE: ./manager/javascripts/locales/label/user/ja.yml
var user_ja = __webpack_require__(57903);
// EXTERNAL MODULE: ./manager/javascripts/locales/label/question/ja.yml
var question_ja = __webpack_require__(76076);
// EXTERNAL MODULE: ./manager/javascripts/locales/label/inHouseNotice/ja.yml
var inHouseNotice_ja = __webpack_require__(90157);
// EXTERNAL MODULE: ./manager/javascripts/locales/label/lp/ja.yml
var lp_ja = __webpack_require__(35936);
// EXTERNAL MODULE: ./manager/javascripts/locales/label/emailChatUnit/ja.yml
var emailChatUnit_ja = __webpack_require__(38740);
;// CONCATENATED MODULE: ./manager/javascripts/locales/label/ja.js




















var ja_labelJa = {
  common: label_common_ja_common,
  input: ja_input,
  reservation: label_reservation_ja_reservation,
  masterMessage: ja_masterMessage,
  hotel: hotel_ja_hotel,
  flight: flight_ja_flight,
  optionalTour: ja_optionalTour,
  scenario: ja_scenario,
  chatNotification: ja_chatNotification,
  crmMessageSchedule: ja_crmMessageSchedule,
  masterMessageGroup: masterMessageGroup,
  form: label_form_ja.ja,
  arrangementPayment: arrangementPayment_ja.ja,
  arrangementRefund: arrangementRefund_ja.ja,
  chat: chat_ja.ja,
  user: user_ja.ja,
  question: question_ja.ja,
  inHouseNotice: inHouseNotice_ja.ja,
  lp: lp_ja.ja,
  emailChatUnit: emailChatUnit_ja.ja
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/constant/flightType/en.js
var en_flightType = {
  roundTrip: "Return",
  oneWay: "Oneway",
  multiCity: "Multi-City"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/constant/flightClass/en.js
var en_flightClass = {
  economy: "ECONOMY",
  economyStandard: "ECONOMY",
  economyPremium: "ECONOMY PREMIUM",
  business: "BUSINESS",
  first: "FIRST"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/constant/priceDisplayType/en.js
var priceDisplayType = {
  display: "display",
  hide: "hide"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/constant/utilityType/en.js
var utilityType = {
  search: "SEARCH",
  user: "USER",
  reservation: "RESERVATION",
  template: "TEMPLATE",
  notification: "NOTIFICATION"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/constant/chatTabTypes/en.js
var chatTabTypes = {
  text: "Text",
  file: "File",
  search: "Search",
  cost: "Cost"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/constant/searchType/en.js
var en_searchType = {
  activity: "ACTIVITY",
  restaurant: "RESTAURANT",
  hotel: "HOTEL",
  flight: "FLIGHT",
  dynamicPackage: "FLIGHT+HOTEL",
  optionalTour: "TOUR"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/constant/masterMessageTabTypes/en.js
var masterMessageTabTypes = {
  templates: "Chat",
  bots: "BOT"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/constant/reservationTypes/en.js
var reservationTypes = {
  hotel: "HOTEL",
  flight: "FLIGHT",
  dynamicPackage: "DP"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/constant/searchColumnType/en.js
var searchColumnType = {
  id: "id",
  name: "name.raw",
  places: "places",
  address: "address",
  tags: "tags",
  tripadvisorUrl: "tripadvisor_url",
  tabelogUrl: "tabelog_url",
  introductions: "introductions",
  genres: "genres",
  tripadvisorRating: "tripadvisor_rating",
  totalTravelkoNum: "total_travelkos_num",
  totalExpediaNum: "total_expedia_num",
  totalBookingComNum: "total_booking_com_num",
  enabledTravelkoNum: "enabled_travelkos_num",
  disabledTravelkoNum: "disabled_travelkos_num",
  disabledIntroductionNum: "disabled_introduction_num",
  introductionNum: "introduction_num",
  disabledTagNum: "disabled_tag_num",
  tagNum: "tag_num"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/constant/hotelTabTypes/en.js
var hotelTabTypes = {
  main: "MAIN",
  recommended: "RECOMMENDED"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/constant/hotelSortType/en.js
var hotelSortType = {
  recommended: "Recommended",
  price: "Lowest Price"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/constant/hotelMealType/en.js
var en_hotelMealType = {
  none: "None",
  breakfast: "Free breakfast"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/constant/hotelBedSizeType/en.js
var en_hotelBedSizeType = {
  single: "Single",
  "double": "Double",
  queen: "Queen",
  king: "King"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/constant/flightSortType/en.js
var flightSortType = {
  recommended: "Recommended",
  duration: "Shortest Duration",
  price: "Lowest Price"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/constant/flightReservedSeatRequestType/en.js
var en_flightReservedSeatRequestType = {
  none: "Not request",
  request_only_free: "Request only if it is free",
  request_with_fee: "Request with fee"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/constant/optionalTourCategories/en.js
var optionalTourCategories = {
  sightseeing: "Sightseeing",
  airportPickup: "Airport pickup",
  restaurantReservation: "Restaurant reservation",
  themepark: "Theme park",
  musium: "Museum",
  shopping: "Shopping",
  showEntertainment: "Show entertainment",
  expediences: "Expediences",
  spaEsthetic: "Spa esthetic",
  worldHeritage: "World heritage",
  skydiving: "Skydiving",
  golf: "Golf",
  waterSports: "Water sports",
  scubaDiving: "Scuba diving",
  cruise: "Cruise",
  dayCruise: "Day cruise",
  mobileWifiRental: "Mobile wifi rental",
  wedding: "Wedding",
  activity: "Activity",
  rentACar: "Rent a car"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/constant/searchMealType/en.js
var en_searchMealType = {
  allMeals: "All meals",
  breakfastAndDinner: "Breakfast and dinner",
  breakfast: "Breakfast",
  lunch: "Lunch",
  dinner: "Dinner",
  nothing: "Nothing"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/constant/hotelViewType/en.js
var en_hotelViewType = {
  oceanFront: "Ocean front",
  oceanView: "Ocean view",
  partialOceanView: "Partial ocean view",
  nothing: "Nothing"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/constant/hotelSmokingTypes/en.js
var hotelSmokingTypes = {
  noSmoking: "No smoking",
  smoking: "Smoking"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/constant/hotelRoomAmenities/en.js
var hotelRoomAmenities = {
  bathtub: "Bathtub"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/constant/hotelAmenities/en.js
var hotelAmenities = {
  pool: "Pool"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/constant/hotelCategories/en.js
var hotelCategories = {
  resort: "Resort",
  allInclusive: "All-inclusive property",
  villa: "Villa",
  ryokan: "Ryokan"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/constant/hotelSpokenLanguages/en.js
var hotelSpokenLanguages = {
  ja: "Japanese"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/constant/flightFreeBaggageType/en.js
var en_flightFreeBaggageType = {
  all: "Include in all itineraries",
  partial: "Include in some itineraries"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/constant/flightArrangementType/en.js
var flightArrangementType = {
  amadeus: "AMADEUS",
  travelfusion: "Travelfusion",
  infini_lcc: "INFINI LCC",
  gotogate: "Gotogate"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/constant/passengerType/en.js
var en_passengerType = {
  adult: "Adult",
  child: "Child",
  infant: "Infant(0-1)"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/constant/serviceType/en.js
var serviceType = {
  hotel: "Hotel",
  flight: "Flight",
  optionalTour: "Optional tour",
  railway: "Railway",
  additionalBaggage: "Additional baggage"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/constant/flightOptionType/en.js
var flightOptionType = {
  baggage: "Baggage",
  itinerary0Baggage: "Outward baggage",
  itinerary1Baggage: "Return baggage",
  baggageWithText: "Add checked baggage",
  seatSelectionWithText: "Seat selection",
  mealWithText: "Meal request",
  upgradeWithText: "Upgrade"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/constant/alllianceType/en.js
var allianceType = {
  skyteam: "SkyTeam",
  oneworld: "oneworld",
  value: "Value",
  star: "Star"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/constant/country/en.js
var country = {
  china: "China",
  korea: "Korea",
  russia: "Russia"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/constant/countryCode/en.js
var countryCode = {
  CN: "China",
  KR: "Korea",
  RU: "Russia"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/constant/contractTypes/en.js
var contractTypes = {
  arrangementTrip: "Arrangement Trip"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/constant/airportCode/en.js
var airportCode = {
  PVG: "Shanghai (PVG-Shanghai Pudong International Airport)",
  PEK: "Beijing (PEK-Beijing Capital International Airport)",
  SZX: "Shenzhen (SZX-Shenzhen Bao'an International Airport)",
  HKG: "Hong Kong (HKG-Hong Kong International Airport)",
  FOC: "Fuzhou (FOC-Fuzhou Changle International Airport)",
  SHA: "Shanghai (SHA-Shanghai Hongqiao International Airport)",
  CTU: "Chengdu (CTU-Chengdu Shuangliu International Airport)",
  DLC: "Dalian (DLC-Dalian Zhoushuizi International Airport)",
  XMN: "Xiamen (XMN-Xiamen Gaoqi International Airport)",
  WUH: "Wuhan (WUH-Wuhan Tianhe International Airport)",
  CAN: "Guangzhou (CAN-Guangzhou Baiyun International Airport)"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/constant/masterMessageGroupType/en.js
var masterMessageGroupType = {
  crm: "CRM Message",
  template: "Template"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/constant/crmMessageScheduleConditionType/en.js
var crmMessageScheduleConditionType = {
  lastReservationCreatedAt: "Last reservation created at",
  lastReservationEndDate: "Return date",
  lastQuestionConditionCreatedAt: "Last question condition created at",
  lastMessageCreatedAt: "Last message created at",
  createdAt: "Add friend date",
  lineType: "LINE type"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/constant/seo/en.js
var en_seo = {
  siteName: "TabiChat",
  titleChat: "Chat",
  titleChatUnit: "User Registration",
  titleMasterMessage: "Message Template Registration",
  titleMasterMessageGroups: "Message Groups",
  titleCrmMessageSchedules: "CRM Message Schedules",
  titleHotels: "Hotels",
  titleActivities: "Activities",
  titleRestaurants: "Restaurants",
  titleReservations: "Reservations",
  titleScenarios: "Scenarios",
  titleInHouseNotice: "In-house Notice",
  titleLpsIndex: "LP Contents List",
  titleLpsNew: "Create LP Contents",
  titleLpsEdit: "Edit LP Contents",
  titleEmailChatUnit: "Email User Registration"
};
// EXTERNAL MODULE: ./manager/javascripts/locales/constant/crmMessageScheduleStatus/en.yml
var crmMessageScheduleStatus_en = __webpack_require__(6737);
// EXTERNAL MODULE: ./manager/javascripts/locales/constant/inHouseNoticeTaskType/en.yml
var inHouseNoticeTaskType_en = __webpack_require__(99477);
// EXTERNAL MODULE: ./manager/javascripts/locales/constant/inHouseNoticeTaskDescription/en.yml
var inHouseNoticeTaskDescription_en = __webpack_require__(32924);
// EXTERNAL MODULE: ./manager/javascripts/locales/constant/lpType/en.yml
var lpType_en = __webpack_require__(59795);
// EXTERNAL MODULE: ./manager/javascripts/locales/constant/lpLayoutType/en.yml
var lpLayoutType_en = __webpack_require__(57503);
// EXTERNAL MODULE: ./manager/javascripts/locales/constant/externalArrangementType/en.yml
var externalArrangementType_en = __webpack_require__(90263);
;// CONCATENATED MODULE: ./manager/javascripts/locales/constant/en.js










































var en_constantEn = {
  flightType: en_flightType,
  flightClass: en_flightClass,
  priceDisplayType: priceDisplayType,
  utilityType: utilityType,
  chatTabTypes: chatTabTypes,
  searchType: en_searchType,
  masterMessageTabTypes: masterMessageTabTypes,
  reservationTypes: reservationTypes,
  searchColumnType: searchColumnType,
  hotelTabTypes: hotelTabTypes,
  hotelSortType: hotelSortType,
  hotelMealType: en_hotelMealType,
  hotelBedSizeType: en_hotelBedSizeType,
  flightSortType: flightSortType,
  flightReservedSeatRequestType: en_flightReservedSeatRequestType,
  optionalTourCategories: optionalTourCategories,
  searchMealType: en_searchMealType,
  hotelViewType: en_hotelViewType,
  hotelSmokingTypes: hotelSmokingTypes,
  hotelRoomAmenities: hotelRoomAmenities,
  hotelAmenities: hotelAmenities,
  hotelCategories: hotelCategories,
  hotelSpokenLanguages: hotelSpokenLanguages,
  flightFreeBaggageType: en_flightFreeBaggageType,
  flightArrangementType: flightArrangementType,
  passengerType: en_passengerType,
  serviceType: serviceType,
  flightOptionType: flightOptionType,
  allianceType: allianceType,
  country: country,
  countryCode: countryCode,
  contractTypes: contractTypes,
  airportCode: airportCode,
  masterMessageGroupType: masterMessageGroupType,
  crmMessageScheduleConditionType: crmMessageScheduleConditionType,
  seo: en_seo,
  crmMessageScheduleStatus: crmMessageScheduleStatus_en.en,
  inHouseNoticeTaskType: inHouseNoticeTaskType_en.en,
  inHouseNoticeTaskDescription: inHouseNoticeTaskDescription_en.en,
  lpType: lpType_en.en,
  lpLayoutType: lpLayoutType_en.en,
  externalArrangementType: externalArrangementType_en.en
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/constant/flightType/ja.js
var flightType_ja_flightType = {
  roundTrip: "往復",
  oneWay: "片道",
  multiCity: "周遊(2都市以上の滞在)"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/constant/flightClass/ja.js
var flightClass_ja_flightClass = {
  economy: "エコノミー",
  economyStandard: "エコノミー",
  economyPremium: "エコノミープレミアム",
  business: "ビジネス",
  first: "ファースト"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/constant/priceDisplayType/ja.js
var ja_priceDisplayType = {
  display: "表示",
  hide: "非表示"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/constant/utilityType/ja.js
var ja_utilityType = {
  search: "検索",
  user: "ユーザー",
  reservation: "予約情報",
  template: "テンプレ",
  notification: "通知"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/constant/chatTabTypes/ja.js
var ja_chatTabTypes = {
  text: "テキスト",
  file: "ファイル",
  search: "検索",
  cost: "費用"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/constant/searchType/ja.js
var searchType_ja_searchType = {
  activity: "観光",
  restaurant: "レストラン",
  hotel: "ホテル",
  flight: "フライト",
  dynamicPackage: "フライト+ホテル",
  optionalTour: "現地ツアー"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/constant/masterMessageTabTypes/ja.js
var ja_masterMessageTabTypes = {
  templates: "チャットテンプレ",
  bots: "ボットテンプレ"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/constant/reservationTypes/ja.js
var ja_reservationTypes = {
  hotel: "ホテル",
  flight: "航空",
  dynamicPackage: "DP"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/constant/searchColumnType/ja.js
var ja_searchColumnType = {
  id: "id",
  name: "名称",
  places: "地名",
  address: "住所",
  tags: "タグ",
  tripadvisorUrl: "TripAdvisor",
  tabelogUrl: "食べログ",
  introductions: "紹介文",
  genres: "ジャンル",
  tripadvisorRating: "評価",
  totalTravelkoNum: "合計トラベルコ紐付け数",
  totalExpediaNum: "合計expedia紐付け数",
  totalBookingComNum: "合計booking.com紐付け数",
  enabledTravelkoNum: "有効なトラベルコ紐付け数",
  disabledTravelkoNum: "無効なトラベルコ紐付け数",
  disabledIntroductionNum: "未承認紹介文数",
  introductionNum: "合計紹介文数",
  disabledTagNum: "未承認タグ数",
  tagNum: "合計タグ数"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/constant/hotelTabTypes/ja.js
var ja_hotelTabTypes = {
  main: "メイン",
  recommended: "おすすめ"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/constant/hotelSortType/ja.js
var ja_hotelSortType = {
  recommended: "プロのおすすめ",
  price: "料金安いホテル"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/constant/hotelMealType/ja.js
var hotelMealType_ja_hotelMealType = {
  none: "なし",
  breakfast: "朝食付き"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/constant/hotelBedSizeType/ja.js
var hotelBedSizeType_ja_hotelBedSizeType = {
  single: "シングル",
  "double": "ダブル",
  queen: "クイーン",
  king: "キング"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/constant/flightSortType/ja.js
var ja_flightSortType = {
  recommended: "プロのおすすめ",
  duration: "移動時間短いフライト",
  price: "料金安いフライト"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/constant/flightReservedSeatRequestType/ja.js
var flightReservedSeatRequestType_ja_flightReservedSeatRequestType = {
  none: "希望しない",
  request_only_free: "無料のときのみ希望",
  request_with_fee: "有料でも希望"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/constant/optionalTourCategories/ja.js
var ja_optionalTourCategories = {
  sightseeing: "観光ツアー",
  airportPickup: "空港送迎サービス",
  restaurantReservation: "レストラン予約",
  themepark: "テーマパーク",
  musium: "美術館／博物館",
  shopping: "ショッピング",
  showEntertainment: "ショー・エンターテイメント",
  expediences: "文化体験・学習",
  spaEsthetic: "スパ／エステ／マッサージ",
  worldHeritage: "世界遺産",
  skydiving: "スカイダイビング",
  golf: "ゴルフ",
  waterSports: "ウォータースポーツ",
  scubaDiving: "スキューバダイビング",
  cruise: "クルーズ",
  dayCruise: "デイクルーズ",
  mobileWifiRental: "携帯電話　WiFiレンタル",
  wedding: "ウェディング",
  activity: "アクティビティ",
  rentACar: "レンタカー"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/constant/searchMealType/ja.js
var searchMealType_ja_searchMealType = {
  allMeals: "三食付き",
  breakfastAndDinner: "朝・夕付き",
  breakfast: "朝食付き",
  lunch: "昼食付き",
  dinner: "夕食付き",
  nothing: "なし"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/constant/hotelViewType/ja.js
var hotelViewType_ja_hotelViewType = {
  oceanFront: "オーシャンフロント",
  oceanView: "オーシャンビュー",
  partialOceanView: "パーシャルオーシャンビュー",
  nothing: "なし"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/constant/hotelSmokingTypes/ja.js
var ja_hotelSmokingTypes = {
  noSmoking: "禁煙",
  smoking: "喫煙"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/constant/hotelRoomAmenities/ja.js
var ja_hotelRoomAmenities = {
  bathtub: "浴槽あり"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/constant/hotelAmenities/ja.js
var ja_hotelAmenities = {
  pool: "プールあり"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/constant/hotelCategories/ja.js
var ja_hotelCategories = {
  resort: "リゾート",
  allInclusive: "オールインクルーシブ",
  villa: "ヴィラタイプ",
  ryokan: "旅館"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/constant/hotelSpokenLanguages/ja.js
var ja_hotelSpokenLanguages = {
  ja: "日本語"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/constant/flightFreeBaggageType/ja.js
var flightFreeBaggageType_ja_flightFreeBaggageType = {
  all: "全ての経路で含む",
  partial: "一部の経路で含む"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/constant/flightArrangementType/ja.js
var ja_flightArrangementType = {
  amadeus: "アマデウス",
  travelfusion: "Travelfusion",
  infini_lcc: "インフィニLCC",
  gotogate: "Gotogate"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/constant/passengerType/ja.js
var passengerType_ja_passengerType = {
  adult: "大人",
  child: "子供",
  infant: "幼児(0 ~ 1歳)"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/constant/serviceType/ja.js
var ja_serviceType = {
  hotel: "ホテル",
  flight: "フライト",
  optionalTour: "現地ツアー",
  railway: "鉄道",
  additionalBaggage: "預け入れ手荷物"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/constant/flightOptionType/ja.js
var ja_flightOptionType = {
  baggage: "預け入れ手荷物",
  itinerary0Baggage: "預け入れ手荷物 (往路)",
  itinerary1Baggage: "預け入れ手荷物 (復路)",
  baggageWithText: "預け入れ手荷物の追加",
  seatSelectionWithText: "座席指定",
  mealWithText: "食事リクエスト",
  upgradeWithText: "アップグレード"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/constant/alllianceType/ja.js
var ja_allianceType = {
  skyteam: "スカイチーム",
  oneworld: "ワンワールド",
  value: "バリュー",
  star: "スター"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/constant/country/ja.js
var ja_country = {
  china: "中国",
  korea: "韓国",
  russia: "ロシア"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/constant/countryCode/ja.js
var ja_countryCode = {
  CN: "中国",
  KR: "韓国",
  RU: "ロシア"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/constant/contractTypes/ja.js
var ja_contractTypes = {
  arrangementTrip: "手配旅行"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/constant/airportCode/ja.js
var ja_airportCode = {
  PVG: "上海 (PVG-浦東空港)",
  PEK: "北京 (PEK-首都空港)",
  SZX: "深圳 (SZX-深圳空港)",
  HKG: "香港 (HKG-香港国際空港)",
  FOC: "福州 (FOC-福州長楽国際空港)",
  SHA: "上海 (SHA-紅橋空港)",
  CTU: "成都 (CTU-成都空港)",
  DLC: "大連 (DLC-大連空港)",
  XMN: "厦門 (XMN-厦門空港)",
  WUH: "武漢 (WUH-武漢国際空港)",
  CAN: "広州 (CAN-白雲空港)"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/constant/masterMessageGroupType/ja.js
var ja_masterMessageGroupType = {
  crm: "CRMメッセージ",
  template: "テンプレート"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/constant/crmMessageScheduleConditionType/ja.js
var ja_crmMessageScheduleConditionType = {
  lastReservationCreatedAt: "最後の予約申し込み日",
  lastReservationEndDate: "帰国日",
  lastQuestionConditionCreatedAt: "最後の旅行相談日",
  lastMessageCreatedAt: "最後にメッセージを送ってきた日",
  createdAt: "友だち追加日",
  lineType: "LINEタイプ"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/constant/seo/ja.js
var seo_ja_seo = {
  siteName: "たびチャット",
  titleChat: "チャット",
  titleChatUnit: "ユーザー登録",
  titleMasterMessage: "テンプレ登録",
  titleMasterMessageGroups: "メッセージグループ",
  titleCrmMessageSchedules: "CRMメッセージスケジュール",
  titleHotels: "ホテル",
  titleActivities: "アクティビティ",
  titleRestaurants: "レストラン",
  titleReservations: "予約",
  titleScenarios: "シナリオ",
  titleInHouseNotice: "社内通知",
  titleLpsIndex: "LPコンテンツ一覧",
  titleLpsNew: "LPコンテンツ作成",
  titleLpsEdit: "LPコンテンツ編集",
  titleEmailChatUnit: "メールユーザー登録"
};
// EXTERNAL MODULE: ./manager/javascripts/locales/constant/crmMessageScheduleStatus/ja.yml
var crmMessageScheduleStatus_ja = __webpack_require__(278);
// EXTERNAL MODULE: ./manager/javascripts/locales/constant/inHouseNoticeTaskType/ja.yml
var inHouseNoticeTaskType_ja = __webpack_require__(50704);
// EXTERNAL MODULE: ./manager/javascripts/locales/constant/inHouseNoticeTaskDescription/ja.yml
var inHouseNoticeTaskDescription_ja = __webpack_require__(35999);
// EXTERNAL MODULE: ./manager/javascripts/locales/constant/lpType/ja.yml
var lpType_ja = __webpack_require__(85483);
// EXTERNAL MODULE: ./manager/javascripts/locales/constant/lpLayoutType/ja.yml
var lpLayoutType_ja = __webpack_require__(73900);
// EXTERNAL MODULE: ./manager/javascripts/locales/constant/externalArrangementType/ja.yml
var externalArrangementType_ja = __webpack_require__(35675);
;// CONCATENATED MODULE: ./manager/javascripts/locales/constant/ja.js










































var ja_constantJa = {
  flightType: flightType_ja_flightType,
  flightClass: flightClass_ja_flightClass,
  priceDisplayType: ja_priceDisplayType,
  utilityType: ja_utilityType,
  chatTabTypes: ja_chatTabTypes,
  searchType: searchType_ja_searchType,
  masterMessageTabTypes: ja_masterMessageTabTypes,
  reservationTypes: ja_reservationTypes,
  searchColumnType: ja_searchColumnType,
  hotelTabTypes: ja_hotelTabTypes,
  hotelSortType: ja_hotelSortType,
  hotelMealType: hotelMealType_ja_hotelMealType,
  hotelBedSizeType: hotelBedSizeType_ja_hotelBedSizeType,
  flightSortType: ja_flightSortType,
  flightReservedSeatRequestType: flightReservedSeatRequestType_ja_flightReservedSeatRequestType,
  optionalTourCategories: ja_optionalTourCategories,
  searchMealType: searchMealType_ja_searchMealType,
  hotelViewType: hotelViewType_ja_hotelViewType,
  hotelSmokingTypes: ja_hotelSmokingTypes,
  hotelRoomAmenities: ja_hotelRoomAmenities,
  hotelAmenities: ja_hotelAmenities,
  hotelCategories: ja_hotelCategories,
  hotelSpokenLanguages: ja_hotelSpokenLanguages,
  flightFreeBaggageType: flightFreeBaggageType_ja_flightFreeBaggageType,
  flightArrangementType: ja_flightArrangementType,
  passengerType: passengerType_ja_passengerType,
  serviceType: ja_serviceType,
  flightOptionType: ja_flightOptionType,
  allianceType: ja_allianceType,
  country: ja_country,
  countryCode: ja_countryCode,
  contractTypes: ja_contractTypes,
  airportCode: ja_airportCode,
  masterMessageGroupType: ja_masterMessageGroupType,
  crmMessageScheduleConditionType: ja_crmMessageScheduleConditionType,
  seo: seo_ja_seo,
  crmMessageScheduleStatus: crmMessageScheduleStatus_ja.ja,
  inHouseNoticeTaskType: inHouseNoticeTaskType_ja.ja,
  inHouseNoticeTaskDescription: inHouseNoticeTaskDescription_ja.ja,
  lpType: lpType_ja.ja,
  lpLayoutType: lpLayoutType_ja.ja,
  externalArrangementType: externalArrangementType_ja.ja
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/component/chat/ja.js
var chat = {
  pleaseSelectUser: "ユーザーを選択してください",
  searchTotalNum: "合計{{totalNum}}件",
  flightConnecting: "乗り継ぎ",
  flightTicketPrice: "航空券代金",
  arrangeServiceCharge: "手数料",
  totalPrice: "合計料金",
  flightPriceDetail: "航空券代金内訳",
  hotelPriceDetail: "ホテル代金内訳",
  grade: "グレード：{{grade}}\n",
  rating: "口コミ評価：{{rating}} / 5.0\n{{ratingText}}\n",
  rating40Text: "（評価が高い✨）",
  rating45Text: "（評価最高ランク🌟）",
  rating50Text: "（評価最高ランク🎖）",
  arrangementCancelTitle: "キャンセル？",
  arrangementCancelDescription: "キャンセルを実行しますか？",
  searchExpirationTitle: "最新情報をチェック",
  searchExpirationDescription: "最新の情報を表示するため、検索結果を更新する必要があります。",
  searchRefresh: "更新する",
  reservationExpirationTitle: "セッションの有効期限切れ",
  reservationExpirationDescription: "この予約は有効期限切れになりました。再度検索してください。",
  reservationResearch: "再検索する",
  reservationOutOfStockTitle: "商品の在庫切れ",
  reservationOutOfStockDescription: "この商品は完売になりました。再度検索してください。",
  reservationPriceChangedTitle: "料金が変更になりました",
  reservationNewPriceConfirmationDescription: "この商品の料金が変更になりました。\n新しい料金は\n{{newPrice}}(差額: {{priceDifference}})\nです。予約を続行しますか？",
  reservationConfirmNewPriceButton: "続行",
  reservationPriceChangedDescription: "この商品の料金が変更になったため、ページを更新する必要があります。",
  reservationRefresh: "更新する",
  aboutCancellation: "キャンセルについて",
  cancellationPolicy: "キャンセル不可または情報がありませんでした。",
  memoTemplateUseAlertDescription: "テンプレートを使用しますか？",
  refundTitle: "返金を行います",
  refundDescription: "下記を入力してください",
  partialRefundTitle: "一部返金を行います",
  partialRefundDescription: "返金額を下記に入力してください",
  correctPriceTitle: "支払料金の入力",
  commissionBackTitle: "コミッションバック",
  textSelectionInstruction: "登録するテキストを\n下記より範囲選択してください",
  saveAsNewCondition: "追加で新規作成",
  annotationFormPlaceholder: "メッセージのテキストを範囲選択してください",
  messageForSearchData: "検索データ対象メッセージ",
  selectMessage: "メッセージを選択してください",
  consultationContent: "相談内容",
  hopeContent: "希望内容",
  reservationSummary: "予約概要",
  searchCondition: "フライト検索条件",
  hotelSearchCondition: "ホテル検索条件",
  section: "区間",
  date: "日付",
  traveler: "旅行者",
  origin: "出発地",
  destination: "到着地",
  restoreSearch: "この条件で再検索",
  numberOfAdults: "大人{{number}}名",
  numberOfChildren: "子供{{number}}名",
  agesOfChildren: "子供の年齢",
  originSummary: "出発地：{{origin}}",
  destinationSummary: "目的地：{{destination}}",
  departureDateSummary: "出発日: {{date}}",
  returnDateSummary: "現地出発日: {{date}}",
  unsent: "未送信",
  sentDate: "送信日時",
  noFlightData: "フライトデータ無し",
  noHotelData: "ホテルデータ無し",
  hotelPrice: "ホテル代金",
  questionSpecifiedMode: "相談指定中",
  setReminderTitle: "リマインダー設定",
  setReminderDescription: "日時とメモを入力してください",
  setScheduledSendingTitle: "時間指定送信設定",
  setScheduledSendingDescription: "日時を入力してください",
  departFrom: "{{name}}出発",
  fromTotalPrice: "合計料金から",
  selectRecommendedSentences: "おすすめ文を選択してください",
  autoSuggestionSuccessMessage: "提案を作成中です。後ほど更新してください。",
  saveReservationOnlyNotice: "予約情報のみDBに保存されます。手配は別途行ってください。",
  reservationpartiallyFailedTitle: "後続の手配に失敗しました",
  reservationpartiallyFailedDescription: "複数の手配の途中でエラーが発生しました。予約内容を確認してください。",
  goToReservation: "予約詳細ページへ移動する",
  unknownErrorTitle: "不明なエラー",
  unknownErrorDescription: "不明なエラーが発生しました",
  filterByThisHotel: "このホテルでフィルタ",
  filterByThisFlight: "このフライトでフィルタ",
  reserveThisFlight: "このフライトを予約する",
  reserveThisHotel: "このホテルを予約する",
  hasSelectedRegions: "選択された地域あり",
  refundableCancellationPolicy: "出発前まで一部返金可能。",
  noCancellation: "キャンセル不可",
  cancellable: "キャンセル可能",
  cancellationFee: "キャンセル料",
  totalRefundAmount: "合計返金額",
  totalCancellationPenalty: "合計キャンセル料",
  cannotReservation: "現在予約ができません(予約情報だけ作成は可能です)",
  displayAfterSave: "追加後に表示されます",
  autoCostCalculatedEditTitle: "自動料金計算を変更します",
  autoCostCalculatedEditDescription: "自動で料金計算をすると自動対応できることが増えます。\nやり方がわからない場合はSlackで相談してください。",
  autoCostCalculatedEditButton: "それでも編集する",
  flightPreReservation: "フライトの予約",
  hotelPreReservation: "ホテルの予約",
  adjustPriceTitle: "料金の変更",
  addPriceTitle: "料金の追加",
  addRefundTitle: "返金の登録",
  hotelSpecialRequestNotice: "※ 半角英数字(日本語不可) (Ex) Extra bed 1",
  confirmReservationTitle: "予約を確定します",
  confirmReservationDescription: "* 予約がファイナルされ、請求が発生します",
  confirmReservationWithNoCancellationDescription: "* 予約がファイナルされ、請求が発生します\n* キャンセル不可です",
  selectOptionalTourPlanDateTitle: "指定日のツアー用メッセージを作成します",
  selectOptionalTourPlanDateDescription: "日付と参加人数を選択してください",
  notAvailable: "利用可能ではありません",
  outOfRange: "指定可能な範囲外です",
  optionalTourFeeNotice: "※ たびチャット手配の場合は上記に+1,100円となります",
  optionalTourLinkText: "詳細はこちら",
  optionalTourIncludingPrice: "(合計料金に含まれます)\n",
  optionalTourExcludingPrice: "(合計料金に含まれません)\n",
  optionalTourTitle: "🚩オプショナルツアー\n",
  showInVeltra: "VELTRAで表示する",
  preReservationMemo: "予約メモについて",
  createCostMessage: "料金付きメッセージ作成",
  recommendedPlanSummary: "おすすめプランの概要",
  suggestionContents: "たびチャットご提案内容",
  imageCreationMessage: "画像を作成中です。数分で完了します。",
  itineraries: "旅程",
  splitItineraries: "分割旅程",
  showOriginalPrice: "元の料金を見る"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/component/common/ja.js
var component_common_ja_common = {
  flightArrangement: "フライト手配",
  flightArrangementNew: "フライト手配作成",
  hotelArrangement: "ホテル手配",
  hotelArrangementNew: "ホテル手配作成",
  optionalTourArrangement: "オプショナルツアー手配",
  optionalTourArrangementNew: "オプショナルツアー手配作成",
  rentalCarArrangement: "レンタカー手配",
  rentalCarArrangementNew: "レンタカー手配作成",
  wifiArrangement: "WiFi手配",
  wifiArrangementNew: "WiFi手配作成",
  railwayArrangement: "鉄道手配",
  railwayArrangementNew: "鉄道手配作成",
  cruiseArrangement: "クルーズ手配",
  cruiseArrangementNew: "クルーズ手配作成",
  insuranceArrangement: "保険手配",
  insuranceArrangementNew: "保険手配作成",
  otherArrangement: "その他手配",
  otherArrangementNew: "その他手配作成",
  discount: "割引",
  discountNew: "割引作成",
  deleteMemo: "メモの削除",
  deleteMemoDescription: "メモを削除します。よろしいですか？",
  sendAllMessages: "メッセージの一括送信",
  sendAllMessagesDescription: "全てのメッセージを送信します。よろしいですか？",
  refundBankTransferNotice: "手動で銀行返金を完了させてください。\n手数料も込みの返金額を入力してください。",
  calendarMaxDaysMessage: "最大日数を超えたため再選択してください",
  sendMessage: "メッセージの送信",
  sendMessageDescription: "通常は[全て送信]ボタンを使用するようにしてください。\nメッセージを送信しますか？",
  flightArrangementInvoiceTitle: "フライト手配を請求済みに変更",
  flightArrangementArrangeTitle: "フライト手配を仮予約中に変更",
  flightArrangementCancelTitle: "フライト手配のキャンセル",
  flightArrangementVoidTitle: "フライト手配の発券キャンセル",
  flightArrangementTicketingTitle: "フライト手配を発券依頼中に変更",
  flightArrangementWaitingForTicketedTitle: "フライト手配を発券待ちに変更",
  flightArrangementTicketedTitle: "フライト手配を発券済みに変更",
  flightArrangementRefundingTitle: "フライト手配を返金依頼中に変更",
  flightArrangementRefundedTitle: "フライト手配を返金済みに変更",
  changeStatus: "ステータス変更",
  defaultRefundedAmountToUserValue: "サプライヤーからの返金額から返金手数料を引いて返金します",
  deleteAllLabeledDataSets: "作成中メッセージの全削除",
  deleteAllLabeledDataSetsDescription: "全ての作成中メッセージを削除します。よろしいですか？",
  includeCodeshare: "コードシェア便あり",
  hotelArrangementInvoiceTitle: "ホテル手配を請求済みに変更",
  hotelArrangementArrangeTitle: "ホテル手配を仮予約中に変更",
  hotelArrangementCancelTitle: "ホテル手配のキャンセル",
  hotelArrangementCancelNotice: "外部サイトの予約がキャンセルされます。",
  hotelArrangementConfirmedTitle: "ホテル手配を確定済みに変更",
  hotelArrangementConfirmingTitle: "ホテル手配を確定予定に変更",
  hotelArrangementConfirmedNotice: "外部サイトも予約確定され、支払いが発生します。",
  hotelArrangementConfirmingNotice: "期限になったら自動的に外部サイトの予約が確定されます。",
  hotelArrangementRefundingTitle: "ホテル手配を返金依頼中に変更",
  hotelArrangementRefundedTitle: "ホテル手配を返金済みに変更",
  hotelArrangementRefundedNotice: "外部サイトの予約がキャンセル/返金されます。",
  selectAllTravelers: "全ての旅行者を選択",
  selectAllPlans: "全ての部屋を選択",
  optionalTourArrangementInvoiceTitle: "オプショナルツアー手配を請求済みに変更",
  optionalTourArrangementArrangeTitle: "オプショナルツアー手配を仮予約中に変更",
  optionalTourArrangementCancelTitle: "オプショナルツアー手配のキャンセル",
  optionalTourArrangementWaitingForConfirmationTitle: "オプショナルツアー手配を催行待ちに変更",
  optionalTourArrangementConfirmedTitle: "オプショナルツアー手配を確定済みに変更",
  optionalTourArrangementRefundingTitle: "オプショナルツアー手配を返金依頼中に変更",
  optionalTourArrangementRefundedTitle: "オプショナルツアー手配を返金済みに変更",
  railwayArrangementInvoiceTitle: "鉄道手配を請求済みに変更",
  railwayArrangementArrangeTitle: "鉄道手配を仮予約中に変更",
  railwayArrangementCancelTitle: "鉄道手配のキャンセル",
  railwayArrangementWaitingForArrangementTitle: "鉄道手配を手配待ちに変更",
  railwayArrangementConfirmedTitle: "鉄道手配を確定済みに変更",
  railwayArrangementRefundingTitle: "鉄道手配を返金依頼中に変更",
  railwayArrangementRefundedTitle: "鉄道手配を返金済みに変更",
  selectDate: "{{dateName}}を選択してください",
  customerTransferFeeNotice: "※ 振込手数料がお客様負担の場合に手数料を記入してください",
  sendConfirmation: "確認情報の送信",
  sendCharge: "請求情報の送信",
  submitFormError: "入力フォームでエラーが発生しました",
  submitError: "エラーが発生しました",
  regionGreat: "とてもおすすめ",
  regionGood: "おすすめ",
  regionOthers: "その他",
  total: "合計",
  questionCondition: "旅行相談",
  none: "なし",
  forOperator: "オペレーター向け",
  changeDeadlineTitle: "期限の変更",
  registerExternalPrice: "外部料金を登録",
  webLink: "{{text}}サイト",
  discountPrice: "{{price}}割引",
  discountPriceOn: "{{name}}で{{price}}割引",
  price: "料金",
  arrangeFee: "手数料",
  totalPrice: "合計料金"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/component/hotel/ja.js
var component_hotel_ja_hotel = {
  evaluation: "評価：{{num}}",
  perNightPerRoom: "{{price}} / 1泊1部屋",
  perNightPerPerson: "{{price}} / 1泊1名",
  room: "部屋：{{name}}"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/component/scenario/ja.js
var scenario_ja_scenario = {
  addScenario: "シナリオの追加",
  addMappingSuccess: "メッセージグループがマッピングされました",
  deleteMappingSuccess: "マッピングが削除されました"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/component/crmMessageSchedule/ja.js
var crmMessageSchedule_ja_crmMessageSchedule = {
  notSelected: "選択されていません",
  selectMessageGroup: "右のリストからメッセージグループを選択してください",
  selectMessageGroupToChange: "変更する場合は右のリストからメッセージグループを選択してください",
  testSend: "テスト送信"
};
// EXTERNAL MODULE: ./manager/javascripts/locales/component/inHouseNotice/ja.yml
var component_inHouseNotice_ja = __webpack_require__(16461);
// EXTERNAL MODULE: ./manager/javascripts/locales/component/lp/ja.yml
var component_lp_ja = __webpack_require__(7094);
// EXTERNAL MODULE: ./manager/javascripts/locales/component/emailChatUnit/ja.yml
var component_emailChatUnit_ja = __webpack_require__(5760);
// EXTERNAL MODULE: ./manager/javascripts/locales/component/notification/ja.yml
var notification_ja = __webpack_require__(56296);
;// CONCATENATED MODULE: ./manager/javascripts/locales/component/ja.js









var ja_componentJa = {
  chat: chat,
  common: component_common_ja_common,
  hotel: component_hotel_ja_hotel,
  scenario: scenario_ja_scenario,
  crmMessageSchedule: crmMessageSchedule_ja_crmMessageSchedule,
  inHouseNotice: component_inHouseNotice_ja.ja,
  lp: component_lp_ja.ja,
  emailChatUnit: component_emailChatUnit_ja.ja,
  notification: notification_ja.ja
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/component/chat/en.js
var en_chat = {
  pleaseSelectUser: "Please select any users",
  searchTotalNum: "Total Number: {{totalNum}}",
  flightConnecting: "Connect",
  flightTicketPrice: "Flight Ticket Price",
  arrangeServiceCharge: "Arrange Service Charge",
  totalPrice: "Total Price",
  flightPriceDetail: "Flight Ticke Price Detail",
  hotelPriceDetail: "Hotel Price Detail",
  grade: "Grade：{{grade}}\n",
  rating: "Rating：{{rating}} / 5.0\n{{ratingText}}\n",
  rating40Text: "(good)",
  rating45Text: "(great)",
  rating50Text: "(best)",
  arrangementCancelTitle: "Cancel?",
  arrangementCancelDescription: "Would you like to execute the canceled?",
  searchExpirationTitle: "Check the latest information",
  searchExpirationDescription: "In order to display the latest information, you need to update the search results.",
  searchRefresh: "Update",
  reservationExpirationTitle: "Session Expired",
  reservationExpirationDescription: "This reservation session has expired. Please search again.",
  reservationResearch: "Search again",
  reservationOutOfStockTitle: "Out of stock",
  reservationOutOfStockDescription: "This item is sold out. Please search again.",
  reservationPriceChangedTitle: "Price changed",
  reservationNewPriceConfirmationDescription: "The price of this flight changed ({{priceDifference}}). The new price is: {{newPrice}}.\n" + "Please confirm if you would like to proceed with this reservation.",
  reservationConfirmNewPriceButton: "Continue",
  reservationPriceChangedDescription: "The price of this item has changed. You need to update this page.",
  reservationRefresh: "Update",
  aboutCancellation: "Cancellation Policy",
  cancellationPolicy: "It can not be canceled or there was no information.",
  memoTemplateUseAlertDescription: "Would you like to use this template?",
  partialRefundTitle: "Partial refund",
  partialRefundDescription: "Enter the refund amount below.",
  correctPriceTitle: "Enter payment price",
  commissionBackTitle: "Comissionback",
  textSelectionInstruction: "Please select a range of text \nto be registered from the following",
  saveAsNewCondition: "Create Additional",
  annotationFormPlaceholder: "Please select range of message text.",
  messageForSearchData: "Message for search data",
  selectMessage: "Please select a message.",
  consultationContent: "Consultation",
  hopeContent: "Hope",
  reservationSummary: "Reservation Summary",
  searchCondition: "Flight Search Condition",
  hotelSearchCondition: "Hotel Search Condition",
  section: "Section",
  date: "Dates",
  traveler: "Travelers",
  origin: "Origin",
  destination: "Destination",
  restoreSearch: "Research",
  numberOfAdults: "{{number}} Adult(s)",
  numberOfChildren: "{{number}} Children",
  agesOfChildren: "Ages of children",
  originSummary: "Origin：{{origin}}",
  destinationSummary: "Destination：{{destination}}",
  departureDateSummary: "Departure: {{date}}",
  returnDateSummary: "Return: {{date}}",
  unsent: "Unsent",
  sentDate: "Sent date",
  noFlightData: "No flight data",
  noHotelData: "No hotel data",
  hotelPrice: "Hotel Price",
  questionSpecifiedMode: "QUESTION SPECIFIED",
  setReminderTitle: "Set Reminder",
  setReminderDescription: "Input date and memos.",
  setScheduledSendingTitle: "Set Scheduled　Sending",
  setScheduledSendingDescription: "Input date.",
  departFrom: "From {{name}}",
  fromTotalPrice: "From the total price",
  selectRecommendedSentences: "Select Recommended Sentences",
  autoSuggestionSuccessMessage: "Suggestion is being created. Please update page later.",
  saveReservationOnlyNotice: "Only the reservation information is saved in the DB. Please arrange separately.",
  reservationpartiallyFailedTitle: "Subsequent arrangements failed",
  reservationpartiallyFailedDescription: "An error occurred during multiple arrangements. Please check your reservation.",
  goToReservation: "Go to reservation details",
  unknownErrorTitle: "Unknown Error",
  unknownErrorDescription: "An unknown error has occurred",
  filterByThisHotel: "Filter by this hotel",
  filterByThisFlight: "Filter by this flight",
  hasSelectedRegions: "Region selected",
  refundableCancellationPolicy: "Partial refundable before departure.",
  noCancellation: "No Cancellations",
  cancellable: "Cancellable",
  cancellationFee: "Cancellation fee",
  totalRefundAmount: "Total refund amount",
  totalCancellationPenalty: "Total cancellation fee",
  cannotReservation: "Can not reservation now (reserve info creation is available)",
  displayAfterSave: "Display after save",
  autoCostCalculatedEditTitle: "Change automatic fee calculation",
  autoCostCalculatedEditDescription: "Many things can be handled automatically when the system calculates the charges automatically.\n" + "If you are unsure how to do it, please consult with Slack.",
  autoCostCalculatedEditButton: "Continue editing",
  flightPreReservation: "Flight reservation",
  hotelPreReservation: "Hotel reservation",
  adjustPriceTitle: "Adjust price",
  addPriceTitle: "Add price",
  addRefundTitle: "Add refund",
  hotelSpecialRequestNotice: "* Please fill in half-width alphanumeric characters. (Ex) Extra bed 1",
  confirmReservationDescription: "* Reservation is finalized and charged",
  confirmReservationWithNoCancellationDescription: "* Reservation is finalized and charged\n* No cancellation",
  selectOptionalTourPlanDateTitle: "Create a tour message for the specified date",
  selectOptionalTourPlanDateDescription: "Please select a date and number of participants",
  notAvailable: "Not available",
  outOfRange: "outOfRange",
  optionalTourFeeNotice: "* In the case of TabiChat arrangement, the above is +1,100 yen",
  optionalTourLinkText: "Here for details",
  optionalTourTitle: "🚩Optional tour\n━━━━━━━━━\n",
  showInVeltra: "Show in VELTRA",
  createCostMessage: "Create cost message",
  recommendedPlanSummary: "Summary of recommended plan",
  suggestionContents: "Suggestions by TabiChat",
  imageCreationMessage: "The images are being created. It will take a few minutes to complete.",
  itineraries: "Itineraries",
  splitItineraries: "Split Itineraries",
  showOriginalPrice: "Show Original Price"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/component/common/en.js
var component_common_en_common = {
  flightArrangement: "Flight arrangement",
  flightArrangementNew: "Create flight arrangement",
  hotelArrangement: "Hotel arrangement",
  hotelArrangementNew: "Create hotel arrangement",
  optionalTourArrangement: "Optional tour arrangement",
  optionalTourArrangementNew: "Create optional tour arrangement",
  rentalCarArrangement: "Rental car arrangement",
  rentalCarArrangementNew: "Create rental car arrangement",
  wifiArrangement: "WiFi arrangement",
  wifiArrangementNew: "Create WiFi arrangement",
  railwayArrangement: "Railway arrangement",
  railwayArrangementNew: "Create railway arrangement",
  cruiseArrangement: "Cruise arrangement",
  cruiseArrangementNew: "Create cruise arrangement",
  insuranceArrangement: "Insurance arrangement",
  insuranceArrangementNew: "Create insurance arrangement",
  otherArrangement: "Other arrangement",
  otherArrangementNew: "Create other arrangement",
  discount: "Discount",
  discountNew: "Create discount",
  deleteMemo: "Delete this memo",
  deleteMemoDescription: "Delete the memo. Is it OK?",
  sendAllMessages: "Batch sending",
  sendAllMessagesDescription: "All messages will be sent. Is it OK?",
  refundBankTransferNotice: "Manually complete the bank refund.\nEnter the refund amount including the fee.",
  calendarMaxDaysMessage: "Please select again because the maximum number of days has been exceeded.",
  sendMessage: "Send the message",
  sendMessageDescription: 'In general, use batch sending."Do you want to send a message?',
  flightArrangementInvoiceTitle: "Change flight arrangement to invoiced state",
  flightArrangementArrangeTitle: "Changed flight arrangements during temporary reservation",
  flightArrangementCancelTitle: "Cancel flight arrangement",
  flightArrangementVoidTitle: "Void flight arrangement",
  flightArrangementTicketingTitle: "Change flight arrangement during ticketing",
  flightArrangementWaitingForTicketedTitle: "Change flight arrangement to waiting for ticketed",
  flightArrangementTicketedTitle: "Change flight arrangement to ticketed",
  flightArrangementRefundingTitle: "Change flight arrangement during refund request",
  flightArrangementRefundedTitle: "Change flight arrangement to refunded",
  changeStatus: "Change status",
  defaultRefundedAmountToUserValue: "Refund by substracting the refund amount from refund fee amout",
  deleteAllLabeledDataSets: "Deleting all messages being created",
  deleteAllLabeledDataSetsDescription: "Delete all messages being created. Is it OK?",
  includeCodeshare: "Include code sharing",
  hotelArrangementInvoiceTitle: "Change hotel arrangement to invoiced state",
  hotelArrangementArrangeTitle: "Changed hotel arrangements during temporary reservation",
  hotelArrangementCancelTitle: "Cancel hotel arrangement",
  hotelArrangementCancelNotice: "The external site reservation will be cancelled.",
  hotelArrangementConfirmedTitle: "Change hotel arrangement to confirmed",
  hotelArrangementConfirmingTitle: "Change hotel arrangement to confirming",
  hotelArrangementConfirmedNotice: "Reservation is also confirmed for the external site, and payment occurs.",
  hotelArrangementRefundingTitle: "Change hotel arrangement during refund request",
  hotelArrangementRefundedTitle: "Change hotel arrangement to refunded",
  hotelArrangementRefundedNotice: "External site reservations will be canceled / refunded.",
  selectAllTravelers: "Select all travelers",
  selectAllPlans: "Select all plans",
  optionalTourArrangementInvoiceTitle: "Change optional tour arrangement to invoiced state",
  optionalTourArrangementArrangeTitle: "Changed optional tour arrangements during temporary reservation",
  optionalTourArrangementCancelTitle: "Cancel optional tour arrangement",
  optionalTourArrangementWaitingForConfirmationTitle: "Change optional tour arrangement to waiting for confirmation",
  optionalTourArrangementConfirmedTitle: "Change optional tour arrangement to confirmed",
  optionalTourArrangementRefundingTitle: "Change optional tour arrangement during refund request",
  optionalTourArrangementRefundedTitle: "Change optional tour arrangement to refunded",
  railwayArrangementInvoiceTitle: "Change railway arrangement to invoiced state",
  railwayArrangementArrangeTitle: "Changed railway arrangements during temporary reservation",
  railwayArrangementCancelTitle: "Cancel railway arrangement",
  railwayArrangementWaitingForArrangementTitle: "Change railway arrangement to waiting for arrangement",
  railwayArrangementConfirmedTitle: "Change railway arrangement to confirmed",
  railwayArrangementRefundingTitle: "Change railway arrangement during refund request",
  railwayArrangementRefundedTitle: "Change railway arrangement to refunded",
  selectDate: "Select {{dateName}}",
  customerTransferFeeNotice: "* If the transfer fee is paid by the customer, please fill in the transfer fee",
  sendConfirmation: "Send confirmation",
  sendCharge: "Send charge",
  submitFormError: "An error occurred in the input form",
  submitError: "An error occurred",
  regionGreat: "Great",
  regionGood: "Good",
  regionOthers: "Others",
  total: "Total",
  questionCondition: "Travel Consultation",
  none: "None",
  forOperator: "For Operator",
  changeDeadlineTitle: "Change Deadline",
  registerExternalPrice: "Register External Price",
  webLink: "{{text}} web",
  discountPrice: "{{price}} discount",
  discountPriceOn: "{{price}} discount on {{name}}",
  price: "Price",
  arrangeFee: "Arrangement Fee",
  totalPrice: "Total Price"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/component/hotel/en.js
var hotel_en_hotel = {
  evaluation: "Evaluation：{{num}}",
  perNightPerRoom: "{{price}} / Per night per room",
  perNightPerPerson: "{{price}} / Per night per toom",
  room: "Room：{{name}}"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/component/scenario/en.js
var en_scenario = {
  addScenario: "Add scenario",
  addMappingSuccess: "Message group mapped",
  deleteMappingSuccess: "Mapping deleted"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/component/crmMessageSchedule/en.js
var en_crmMessageSchedule = {
  notSelected: "Not selected",
  selectMessageGroup: "Select a message group from the list on the right",
  selectMessageGroupToChange: "To change it, select a message group from the list on the right",
  testSend: "Test Send"
};
// EXTERNAL MODULE: ./manager/javascripts/locales/component/inHouseNotice/en.yml
var component_inHouseNotice_en = __webpack_require__(20531);
// EXTERNAL MODULE: ./manager/javascripts/locales/component/lp/en.yml
var component_lp_en = __webpack_require__(97287);
// EXTERNAL MODULE: ./manager/javascripts/locales/component/emailChatUnit/en.yml
var component_emailChatUnit_en = __webpack_require__(35399);
// EXTERNAL MODULE: ./manager/javascripts/locales/component/notification/en.yml
var notification_en = __webpack_require__(64495);
;// CONCATENATED MODULE: ./manager/javascripts/locales/component/en.js









var en_componentEn = {
  chat: en_chat,
  common: component_common_en_common,
  hotel: hotel_en_hotel,
  scenario: en_scenario,
  crmMessageSchedule: en_crmMessageSchedule,
  inHouseNotice: component_inHouseNotice_en.en,
  lp: component_lp_en.en,
  emailChatUnit: component_emailChatUnit_en.en,
  notification: notification_en.en
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/message/en.js
var messageEn = {
  hotelText: "\u250F\u2501\u2513\n\u2503\u7530\u2523\u2501\u2513TabiChat\n\u2503\u7530\u2503\u7530\u2503recommended\n\u2503\u7530\u2503\u7530\u2503hotels\n\xAC\xAC\xAC\xAC\xAC\xAC\xAC\xAC\xAC\xAC\xAC\xAC\xAC\xAC\xAC\n\u25CF{{name}}\n\xAC\xAC\xAC\xAC\xAC\xAC\xAC\xAC\xAC\xAC\xAC\xAC\xAC\xAC\xAC\nAddress\uFF1A{{address}}\n\n{{value}}\n\n{{freeText}}",
  roomCountText: " x {{roomCount}} rooms",
  roomsLeftText: "\u3010Only {{roomsLeft}} rooms left\u3011\n",
  roomIndex: "Room {{index}}\uFF1A",
  numberOfAdultsText: "{{numberOfAdult}} adults,",
  numberOfChildrenText: " {{numberOfChildren}} children",
  hotelFreeText: "\u25C6\u25C6\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\n\u25C6 Hotel Plan Introduction\n\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\nDates\uFF1A{{checkinDate}}\u301C{{checkoutDate}}\nGuests\uFF1A{{generateGuestsText}}\nMeals\uFF1A{{meals}}\nRooms\uFF1A{{roomName}}{{roomCountText}}\n\nTotal Price\uFF1A{{inclusiveTotalPrice}}\n\uFF08{{inclusivePricePerDayPerRoom}}/ a day a room\uFF09\n---\n{{freeCancellationText}}\n{{planFeesText}}\n{{roomsLeftText}}",
  noCancellations: "No cancellations",
  cancellationFree: "There is no cancellation charge until {{costCancellationChargeDate}}",
  totalPrice: "\nTotalPrice：{{totalPrice}}",
  flightDetailText: "\uD83D\uDCCD{{departureAirportName}}\n{{departureDate}} {{departureTime}}\n\n\u2193 \u2708\uFE0F {{airlineName}}\n\n{{arrivalDate}} {{arrivalTime}}{{deltaDate}}\n\uD83D\uDCCD{{arrivalAirportName}}",
  stopover: "- - - - - - - - - - - - - - -\n  Transit\uFF1A{{layover}}\n- - - - - - - - - - - - - - -\n",
  deltaDate: "(+{{deltaDate}}day)",
  flightItineraryText: "\n\u25BC Itinerary{{index}}:\u3010{{duration}}\u3011\n{{flightDetailsText}}\n",
  flightText: "\u2708\uFE0F Flight details\n{{flightItinerariesText}}\n\n\uD83D\uDC5C \u3010Free\u3011Baggage provision\n\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\n{{handBaggageText}}\n{{additionalBaggageText}}\n\n{{priceText}}",
  quantityFreeBaggagePerPerson: "Free baggage allowance: up to {{quantity}} piece(s)/person",
  weightFreeBaggagePerPerson: "Free baggage allowance: up to {{weight}}kg(s)/person",
  quantityWeightFreeBaggagePerPerson: "Free baggage allowance: up to {{quantity}} ({{weight}}{{weightUnit}}(s)) piece(s)/person",
  noFreeBaggage: "No free baggage included",
  noFreeBaggageInformation: "Please Ask Because No information",
  additionalBaggage: "\n👜 【Paid】Baggage provision\n━━━━━━━━━\n{{additionalBaggageText}}",
  baggageWithItinerary: "Itinerary{{index}}: {{baggageText}}",
  hotelRecommendedSentenceMessage: "🏨 Recommended Hotel\n━━━━━━━━━\n{{freeText}}\n{{sentencesText}}\n\n▼▼ The details were written below. ▼▼",
  actionInitText: "👉 Look at in detail 👈",
  none: "none",
  messageButtonText: "<Reservation Flow>\n\u2474 Input reservation form\n\u2475 Reach confirmation message \n\u2476 To payment",
  clickHereForReservation: "👉 Click here for reservation 👈",
  hotelSearchConditionText: "\uD83D\uDCCD{{destination}}\n\uD83D\uDDD3{{checkinDate}}-{{checkoutDate}}\uFF08{{stayNum}} nights\uFF09\n{{guestNum}}"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/message/ja.js
var messageJa = {
  hotelText: "\u250F\u2501\u2513\n\u2503\u7530\u2523\u2501\u2513\u305F\u3073\u30C1\u30E3\u30C3\u30C8\n\u2503\u7530\u2503\u7530\u2503\u30AA\u30B9\u30B9\u30E1\u306E\n\u2503\u7530\u2503\u7530\u2503\u53B3\u9078\u5BBF\n\xAC\xAC\xAC\xAC\xAC\xAC\xAC\xAC\xAC\xAC\xAC\xAC\xAC\xAC\xAC\n\u25CF{{name}}\n\xAC\xAC\xAC\xAC\xAC\xAC\xAC\xAC\xAC\xAC\xAC\xAC\xAC\xAC\xAC\n\u4F4F\u6240\uFF1A{{address}}\n\n{{value}}\n\n{{freeText}}",
  roomCountText: " x {{roomCount}}部屋",
  roomsLeftText: "\u3010\u6B8B\u308A{{roomsLeft}}\u90E8\u5C4B\u306E\u307F\u3011\n",
  roomIndex: "\u90E8\u5C4B{{index}}\uFF1A",
  numberOfAdultsText: "\u5927\u4EBA{{numberOfAdult}}\u540D",
  numberOfChildrenText: " \u5B50\u4F9B{{numberOfChildren}}\u540D",
  hotelFreeText: "\u25C6\u25C6\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\n\u25C6 \u5BBF\u6CCA\u30D7\u30E9\u30F3\u6848\u5185\n\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\n\u65E5\u7A0B\uFF1A{{checkinDate}}\u301C{{checkoutDate}}\n\u4EBA\u6570\uFF1A{{generateGuestsText}}\n\u98DF\u4E8B\uFF1A{{meals}}\n\u90E8\u5C4B\uFF1A{{roomName}}{{roomCountText}}\n\n\u5408\u8A08\u6599\u91D1\uFF1A{{inclusiveTotalPrice}}\n\uFF08{{inclusivePricePerDayPerRoom}}/1\u6CCA1\u90E8\u5C4B\uFF09\n---\n{{freeCancellationText}}\n{{planFeesText}}\n{{roomsLeftText}}",
  noCancellations: "キャンセル不可",
  cancellationFree: "{{costCancellationChargeDate}}までホテルのキャンセル無料",
  totalPrice: "\n合計：{{totalPrice}}",
  flightDetailText: "\uD83D\uDCCD{{departureAirportName}}\n{{departureDate}} {{departureTime}}\n\n\u2193 \u2708\uFE0F {{airlineName}}\n\n{{arrivalDate}} {{arrivalTime}}{{deltaDate}}\n\uD83D\uDCCD{{arrivalAirportName}}",
  stopover: "- - - - - - - - - - - - - - -\n  \u4E57\u7D99\uFF1A{{layover}}\n- - - - - - - - - - - - - - -\n",
  deltaDate: "(+{{deltaDate}}日)",
  flightItineraryText: "\n\u25BC \u7D4C\u8DEF{{index}}:\u3010{{duration}}\u3011\n{{flightDetailsText}}\n",
  flightText: "\u2708\uFE0F \u30D5\u30E9\u30A4\u30C8\u306E\u8A73\u7D30\n{{flightItinerariesText}}\n\n\uD83D\uDC5C \u3010\u7121\u6599\u3011\u9810\u3051\u5165\u308C\u624B\u8377\u7269\n\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\n{{handBaggageText}}\n{{additionalBaggageText}}\n\n{{priceText}}",
  quantityFreeBaggagePerPerson: "預け入れ手荷物1名あたり{{quantity}}個まで無料",
  quantityWeightFreeBaggagePerPerson: "預け入れ手荷物1名あたり{{quantity}}個/{{weight}}{{weightUnit}}まで無料",
  weightFreeBaggagePerPerson: "預け入れ手荷物1名あたり{{weight}}{{weightUnit}}まで無料",
  noFreeBaggage: "預け入れ手荷物なし",
  noFreeBaggageInformation: "情報なしのためお問い合わせ",
  additionalBaggage: "\n👜 【有料】預け入れ手荷物\n━━━━━━━━━\n{{additionalBaggageText}}",
  baggageWithItinerary: "経路{{index}}：{{baggageText}}",
  hotelRecommendedSentenceMessage: "🏨 おすすめのホテル\n━━━━━━━━━\n{{freeText}}\n{{sentencesText}}\n\n▼▼ 詳細は下記に記載 ▼▼",
  actionInitText: "👉 詳しく見る 👈",
  none: "なし",
  messageButtonText: "\uFF1C\u4E88\u7D04\u306E\u6D41\u308C\uFF1E\n\u2474 \u4E88\u7D04\u30D5\u30A9\u30FC\u30E0\u3092\u5165\u529B\n\u2475 \u5185\u5BB9\u78BA\u8A8D\u9023\u7D61\u304C\u5C4A\u304F\n\u2476 \u6599\u91D1\u306E\u652F\u6255\u3044\u3078\u9032\u3080",
  clickHereForReservation: "👉予約フォームへ進む",
  trainCostDefaultText: "\uD83D\uDE84 \u9244\u9053\u79FB\u52D5\n\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\nx \u21D2 x\n\uD83D\uDCC5\u65E5\u7A0B\n1/1 \n00:00-00:00\nEurostar\n\n\u51FA\u767A\uFF1Ax\u99C5\n\u5230\u7740\uFF1Ax\u99C5\n\u6599\u91D1\uFF1A0\u5186\n\n\u203B \u6599\u91D1\u306F\u65E5\u4ED8\u30FB\u6642\u9593\u5E2F\u30FB\u7A7A\u5E2D\u72B6\u6CC1\u306A\u3069\u306B\u3088\u308A\u5909\u52D5\u3044\u305F\u3057\u307E\u3059\u3002\n\n\u203B \u305F\u3073\u30C1\u30E3\u30C3\u30C8\u624B\u914D\u6599\u8FBC\u3067\u3059",
  optionalTourCostDefaultText: "\uD83D\uDE97 \u30AA\u30D7\u30B7\u30E7\u30CA\u30EB\u30C4\u30A2\u30FC\n\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\ntitle\n\uD83D\uDCC5\u65E5\u7A0B\n0/0\n\n0\u5186\n(\u305F\u3073\u30C1\u30E3\u30C3\u30C8\u624B\u6570\u65991,100\u5186\u542B\u3080)",
  additionalBaggageCostDefaultText: "\uD83D\uDCBC \u9810\u3051\u5165\u308C\u624B\u8377\u7269\n\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\u2501\n1\u500B(~00kg)\n0\u5186x0\u540D\u69D8\n\n\u203B \u7121\u6599\u306E\u9810\u3051\u5165\u308C\u624B\u8377\u7269\u304C\u306A\u3044\u30D5\u30E9\u30A4\u30C8\u304C\u3054\u3056\u3044\u307E\u3059\u306E\u3067\u3001\u4E0A\u8A18\u306E\u9810\u3051\u5165\u308C\u624B\u8377\u7269\u3092\u8FFD\u52A0\u3057\u3066\u5408\u8A08\u6599\u91D1\u3092\u8A08\u7B97\u3044\u305F\u3057\u307E\u3059\u3002\n",
  hotelSearchConditionText: "\uD83D\uDCCD{{destination}}\n\uD83D\uDDD3{{checkinDate}}-{{checkoutDate}}\uFF08{{stayNum}}\u6CCA\uFF09\n{{guestNum}}"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/model/common/ja.js
var model_common_ja_common = {
  expired: "有効期限が切れました",
  sex: {
    female: "女性",
    male: "男性"
  }
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/model/payment/en.js
var payment = {
  status: {
    created: "created",
    authorized: "authorized",
    confirmed: "confirmed",
    refunded: "refunded",
    failed: "failed",
    cancelled: "cancelled"
  },
  paymentType: {
    on_site: "On Site",
    credit_card: "Credit Card",
    bank_transfer: "Bank Transfer",
    later_payment: "later Payment",
    advance_payment: "Advance Payment",
    deposit_payment: "Deposit Payment",
    government_benefit: "Government Benefit"
  },
  billerType: {
    unknown: "unknown",
    fness: "f-ness",
    oversease_travel: "OTA",
    travelfusion: "travelfusion",
    vueling: "Vueling",
    expedia: "expedia",
    his: "his",
    marinabay: "marina bay",
    veltra: "veltra",
    omio: "omio",
    tpi: "TPI",
    other: "Other"
  }
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/model/charge/en.js
var charge = {
  status: {
    applied: "applied",
    application_paid: "application paid",
    paid: "paid",
    refund_applied: "refund applied",
    refunded: "refunded"
  }
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/model/reservation/en.js
var model_reservation_en_reservation = {
  status: {
    applied: "applied",
    arranged: "arranged",
    cancel_applied: "cancel applied",
    cancelled: "cancelled"
  }
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/model/hotelArrangement/en.js
var en_hotelArrangement = {
  status: {
    created: "created",
    arranged: "arranged",
    cancelled: "cancelled"
  },
  arrangementType: {
    unknown: "unknown",
    taap: "TAAP",
    rikisha: "rikisha",
    expedia: "Expedia",
    hotel_site: "Hotel Site",
    rka: "Rikisha API"
  },
  stayNum: "{{stayNum}} Night"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/model/hotelArrangementPlan/en.js
var en_hotelArrangementPlan = {
  status: {
    created: "created",
    invoiced: "invoiced",
    arranged: "arranged",
    cancelled: "cancelled",
    unconfirmed: "unconfirmed",
    confirmed: "confirmed",
    confirming: "confirming",
    refund: "refund",
    refunded: "refunded"
  },
  mealType: {
    nothing: "meal nothing",
    breakfast: "breakfast",
    dinner: "dinner",
    both: "breakfast & dinner",
    all_meals: "three meals"
  },
  payType: {
    pre_payment: "pre payment",
    on_site: "on site"
  }
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/model/flightArrangement/en.js
var flightArrangement = {
  status: {
    created: "created",
    arranged: "arranged",
    cancelled: "cancelled",
    "void": "VOID",
    ticketing: "ticketing",
    ticketed: "ticketed",
    refunding: "refunding",
    refunded: "refunded"
  },
  arrangementType: {
    jetstar: "Jetstar",
    expedia: "Expedia",
    peach: "Peach",
    airline_site: "Airline Site",
    amadeus_by_phone: "amadeus by manual",
    apollo_by_phone: "apollo by manual",
    infini_by_phone: "infini by manual",
    amadeus: "Amadeus",
    infini_lcc: "Infini LCC",
    travelfusion: "Travelfusion"
  }
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/model/flightArrangementTraveler/en.js
var flightArrangementTraveler = {
  status: {
    created: "created",
    invoiced: "invoiced",
    arranged: "arranged",
    ticketing: "ticketing",
    unconfirmed: "unconfirmed",
    waitingForTicketed: "waiting for ticketed",
    ticketed: "ticketed",
    "void": "VOID",
    cancelled: "cancelled",
    refunding: "refunding",
    refunded: "refunded",
    failed: "failed"
  }
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/model/flightArrangementTravelerOption/en.js
var flightArrangementTravelerOption = {
  reservedBaggageDisplay: "Up to {{weight}} {{weightUnit}}, {{quantity}} pieces ({{price}})"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/model/flightArrangementOption/en.js
var flightArrangementOption = {
  reservedBaggageDisplay: "Up to {{weight}} {{weightUnit}}, {{quantity}} pieces ({{price}})"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/model/flightArrangementPrice/en.js
var en_flightArrangementPrice = {
  priceType: {
    taxes: "Taxes",
    bookingDistributionFee: "Booking distribution fee",
    distributionFee: "Distribution fee",
    roundingAdjustment: "Rounding adjustment",
    creditCardSurcharge: "Credit card surcharge",
    luggageSurcharge: "Luggage surcharge",
    comboServiceFee: "Combo service fee",
    bankConversionCharge: "Bank conversion charge",
    bankHandlingCharge: "Bank handling charge",
    reservedSeatsIncludedSurcharge: "Seat reservation surcharge",
    otherTaxes: "Other taxes",
    baseFare: "Flight",
    taxAndSurcharge: "Taxes / Fuel Surcharge",
    arrangeFee: "Handling Charge",
    baggage: "Baggage",
    itinerary0Baggage: "Outward baggage",
    itinerary1Baggage: "Return baggage"
  }
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/model/chatUnit/en.js
var chatUnit = {
  priority: {
    a: "A",
    b: "B",
    c: "C",
    d: "AUTO",
    all: "ALL",
    initial: "NOT SET"
  },
  dealingStep: {
    flight: "FLIGHT",
    hotelTour: "HOTEL TOUR",
    support: "SUPPORT",
    remind: "REMIND",
    all: "ALL",
    initial: "NOT SET"
  },
  dealingStatus: {
    initialWorkRequest: "INITIAL WORK REQUEST",
    initialWorking: "INITIAL WORKING",
    workRequest: "WORK REQUEST",
    regularMemberWorkRequest: "REGULAR MEMBER REQUEST",
    priorityWorkRequest: "PRIORITY REQUEST",
    working: "WORKING",
    autoWorkRequest: "AUTO REQUEST",
    autoWorking: "AUTO WORKING",
    checkRequest: "CHECK REQUEST",
    checking: "CHECKING",
    modifyRequest: "MODIFY REQUEST",
    modifying: "MODIFYING",
    initial: "NO ACTION NEEDED",
    request: "REQUEST",
    all: "ALL"
  },
  dealingStatusCategory: {
    all: "ALL",
    working: "WORKING",
    request: "REQUEST",
    initialWorkRequest: "INITIAL WORK REQUEST"
  },
  dealingStatusSubCategory: {
    all: "ALL",
    check: "CHECK",
    regularMember: "REGULAR MEMBER",
    priority: "PRIORITY",
    auto: "AUTO",
    multiCity: "MULTI CITY"
  },
  continent: {
    asia: "ASIA",
    north_and_south_america: "N&S AMERICA",
    europe: "EUROPE",
    other: "OTHER",
    all: "ALL"
  },
  dealingStepShorthand: {
    flight: "Flight",
    hotelTour: "Hotel&Tour",
    support: "Support",
    remind: "Remind"
  },
  dealingStatusShorthand: {
    initialWorkRequest: "Initial W.R",
    initialWorking: "Initial W",
    workRequest: "WR",
    regularMemberWorkRequest: "RM W.R",
    priorityWorkRequest: "Priority W.R",
    working: "W",
    autoWorkRequest: "Auto W.R",
    autoWorking: "Auto W",
    checkRequest: "Check R",
    checking: "Checking",
    modifyRequest: "Modify R",
    modifying: "Modifying"
  },
  reservationStatus: {
    reserved: "RESERVED",
    all: "ALL"
  },
  blocked: {
    blocked: "BLOCKED",
    none: "NONE"
  },
  reserved: "Reserved"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/model/optionalTourArrangement/en.js
var optionalTourArrangement = {
  status: {
    created: "created",
    invoiced: "invoiced",
    arranged: "arranged",
    cancelled: "cancelled",
    waiting_for_confirmation: "waiting for confirmation",
    ticketed: "ticketed",
    confirmed: "confirmed",
    refunding: "refunding",
    refunded: "refunded"
  },
  arrangementType: {
    veltra: "VELTRA",
    other: "other"
  },
  initialCancelPolicy: "▼ About policy ▼\n"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/model/rentalCarArrangement/en.js
var rentalCarArrangement = {
  status: {
    created: "created",
    arranged: "arranged",
    cancelled: "cancelled"
  },
  arrangementType: {
    expedia: "expedia",
    agent_car: "agent_car"
  }
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/model/wifiArrangement/en.js
var wifiArrangement = {
  status: {
    created: "created",
    arranged: "arranged",
    cancelled: "cancelled"
  },
  arrangementType: {
    global: "global"
  }
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/model/railwayArrangement/en.js
var railwayArrangement = {
  status: {
    created: "created",
    invoiced: "invoiced",
    arranged: "arranged",
    cancelled: "cancelled",
    waiting_for_arrangement: "waiting for arrangement",
    confirmed: "confirmed",
    refunding: "refunding",
    refunded: "refunded"
  },
  arrangementType: {
    tumlare: "tumlare",
    go_euro: "go_euro",
    omio: "omio"
  },
  initialCancelPolicy: "No changes or refunds after payment has been made."
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/model/cruiseArrangement/en.js
var cruiseArrangement = {
  status: {
    created: "created",
    arranged: "arranged",
    cancelled: "cancelled"
  },
  arrangementType: {
    tumlare: "tumlare"
  }
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/model/insuranceArrangement/en.js
var insuranceArrangement = {
  status: {
    created: "created",
    arranged: "arranged",
    cancelled: "cancelled"
  },
  arrangementType: {
    tabiho: "tabiho"
  }
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/model/searchInput/en.js
var searchInput = {
  stringOptions: {
    include_match: "Include match",
    match: "Complete match",
    forward_match: "Forward match",
    backward_match: "Backward match"
  }
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/model/masterMessage/en.js
var en_masterMessage = {
  platformType: {
    all_platform: "All Platform",
    line: "LINE",
    facebook: "Facebook"
  },
  groupType: {
    greeting: "Greeting",
    hearing: "Hearing",
    proposal_starting: "Proposal starting",
    closing: "Reservation",
    mine: "Mine",
    bot_initial_greeting: "Initial greeting",
    bot_remind_hearing: "Hearing reminder",
    bot_remind_initial_action: "Initial action reminder"
  }
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/model/hotelArrangementPlanPrice/en.js
var en_hotelArrangementPlanPrice = {
  priceType: {
    baseRate: "Room Price",
    taxAndServiceFee: "Taxes & Fees",
    extraPersonFee: "Extra Person Fee",
    compensation: "Compensation",
    propertyFee: "Property Fee",
    arrangementFee: "Handling Charge"
  }
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/model/hotelArrangementPlanFee/en.js
var en_hotelArrangementPlanFee = {
  feeType: {
    mandatoryFee: "Mandatory Fee",
    mandatoryTax: "Mandatory Tax",
    resortFee: "Resort Fee"
  }
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/model/otherArrangement/en.js
var otherArrangement = {
  arrangementType: {
    etas: "ETAS",
    restaurant_reservation_fee: "Restaurant Reservation Fee"
  }
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/model/discount/en.js
var discount = {
  discountType: {
    campaign: "Campaign",
    loss: "Financial Loss"
  }
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/model/delayBatchEvent/en.js
var delayBatchEvent = {
  eventType: {
    auto_reply: "auto_reply",
    reminder: "reminder",
    scheduled_sending: "scheduled_sending"
  }
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/model/scenario/en.js
var scenario_en_scenario = {
  status: {
    published: "publish",
    close: "close"
  },
  chatUnitStatus: {
    hearingDestination: "【Hearing】Destination",
    hearingOrigin: "【Hearing】Origin",
    hearingSchedule: "【Hearing】Schedule",
    hearingPeople: "【Hearing】Number of people",
    hearingPricePerPerson: "【Hearing】Price per person",
    hearing_hope: "【Hearing】Hope"
  }
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/model/crmMessageSchedule/en.js
var crmMessageSchedule_en_crmMessageSchedule = {
  status: {
    scheduled: "schedules",
    processing: "processing",
    done: "done"
  }
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/model/masterMessageGroup/en.js
var en_masterMessageGroup = {
  groupType: {
    crm: "CRM Message",
    template: "Template"
  }
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/model/en.js




























var en_modelEn = {
  common: model_common_ja_common,
  payment: payment,
  charge: charge,
  reservation: model_reservation_en_reservation,
  hotelArrangement: en_hotelArrangement,
  hotelArrangementPlan: en_hotelArrangementPlan,
  flightArrangement: flightArrangement,
  flightArrangementTraveler: flightArrangementTraveler,
  flightArrangementTravelerOption: flightArrangementTravelerOption,
  flightArrangementOption: flightArrangementOption,
  flightArrangementPrice: en_flightArrangementPrice,
  optionalTourArrangement: optionalTourArrangement,
  rentalCarArrangement: rentalCarArrangement,
  wifiArrangement: wifiArrangement,
  railwayArrangement: railwayArrangement,
  cruiseArrangement: cruiseArrangement,
  insuranceArrangement: insuranceArrangement,
  chatUnit: chatUnit,
  searchInput: searchInput,
  masterMessage: en_masterMessage,
  hotelArrangementPlanPrice: en_hotelArrangementPlanPrice,
  hotelArrangementPlanFee: en_hotelArrangementPlanFee,
  otherArrangement: otherArrangement,
  discount: discount,
  delayBatchEvent: delayBatchEvent,
  scenario: scenario_en_scenario,
  crmMessageSchedule: crmMessageSchedule_en_crmMessageSchedule,
  masterMessageGroup: en_masterMessageGroup
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/model/payment/ja.js
var ja_payment = {
  status: {
    created: "作成済み",
    authorized: "仮売上",
    confirmed: "確定",
    refunded: "返金済",
    failed: "失敗",
    cancelled: "キャンセル済み"
  },
  paymentType: {
    on_site: "現地払い",
    credit_card: "クレジット払い",
    bank_transfer: "銀行振込",
    later_payment: "あと払い",
    advance_payment: "先払い",
    deposit_payment: "デポジットからの引き落とし",
    government_benefit: "政府給付金"
  },
  billerType: {
    unknown: "不明",
    fness: "エフネス",
    oversease_travel: "OTA",
    travelfusion: "travelfusion",
    vueling: "Vueling",
    expedia: "expedia",
    his: "his",
    marinabay: "marina bay",
    veltra: "veltra",
    omio: "omio",
    tpi: "TPI",
    other: "その他"
  }
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/model/charge/ja.js
var ja_charge = {
  status: {
    applied: "申込中",
    application_paid: "申込金支払い済",
    paid: "支払い済",
    refund_applied: "返金依頼中",
    refunded: "返金済"
  }
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/model/reservation/ja.js
var model_reservation_ja_reservation = {
  status: {
    applied: "申込中",
    arranged: "手配済",
    cancel_applied: "キャンセル依頼中",
    cancelled: "キャンセル済"
  }
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/model/hotelArrangement/ja.js
var hotelArrangement_ja_hotelArrangement = {
  status: {
    created: "作成済",
    arranged: "手配済",
    cancelled: "キャンセル済"
  },
  arrangementType: {
    unknown: "不明",
    taap: "TAAP",
    expedia: "Expedia",
    rikisha: "Rikisha",
    hotel_site: "ホテルサイト",
    rka: "Rikisha API"
  },
  stayNum: "{{stayNum}}泊"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/model/hotelArrangementPlan/ja.js
var hotelArrangementPlan_ja_hotelArrangementPlan = {
  status: {
    created: "作成済",
    invoiced: "請求済み",
    arranged: "仮予約",
    cancelled: "キャンセル済",
    unconfirmed: "不明",
    confirmed: "確定済み",
    confirming: "確定予定",
    refunding: "返金依頼",
    refunded: "返金済み"
  },
  mealType: {
    nothing: "食事なし",
    breakfast: "朝食付き",
    dinner: "夕食付き",
    both: "朝・夕付き",
    breakfast_and_dinner: "朝・夕付き",
    all_meals: "朝・昼・夕付き"
  },
  payType: {
    pre_payment: "サイト払い",
    on_site: "ホテル支払い"
  }
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/model/flightArrangement/ja.js
var ja_flightArrangement = {
  status: {
    created: "作成済",
    arranged: "手配済",
    cancelled: "キャンセル済",
    "void": "発券キャンセル済",
    ticketing: "発券依頼中",
    ticketed: "発券済",
    refunding: "返金依頼中",
    refunded: "返金済"
  },
  arrangementType: {
    jetstar: "Jetstar",
    expedia: "Expedia",
    peach: "Peach",
    airline_site: "航空会社サイト",
    amadeus_by_phone: "アマデウス手動手配",
    apollo_by_phone: "アポロ手動手配",
    infini_by_phone: "インフィニ手動手配",
    amadeus: "アマデウス",
    infini_lcc: "Infini LCC",
    travelfusion: "Travelfusion"
  }
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/model/flightArrangementTraveler/ja.js
var ja_flightArrangementTraveler = {
  status: {
    created: "作成済み",
    invoiced: "請求済み",
    arranged: "仮予約中",
    ticketing: "発券中",
    unconfirmed: "予約処理中・未確認",
    waitingForTicketed: "発券待ち",
    ticketed: "発券済み",
    "void": "発券キャンセル済み",
    cancelled: "キャンセル済み",
    refunding: "返金依頼中",
    refunded: "返金済み",
    failed: "失敗"
  }
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/model/flightArrangementTravelerOption/ja.js
var ja_flightArrangementTravelerOption = {
  reservedBaggageDisplay: "{{weight}} {{weightUnit}}まで ({{quantity}}個)： {{price}}"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/model/flightArrangementOption/ja.js
var ja_flightArrangementOption = {
  reservedBaggageDisplay: "{{weight}} {{weightUnit}}まで ({{quantity}}個)： {{price}}"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/model/flightArrangementPrice/ja.js
var flightArrangementPrice_ja_flightArrangementPrice = {
  priceType: {
    taxes: "税金",
    bookingDistributionFee: "予約販売手数料",
    distributionFee: "販売手数料",
    roundingAdjustment: "調整金額",
    creditCardSurcharge: "クレジットカードサーチャージ",
    luggageSurcharge: "手荷物サーチャージ",
    comboServiceFee: "コンボサービスフィー",
    bankConversionCharge: "通貨換算手数料",
    bankHandlingCharge: "銀行手数料",
    reservedSeatsIncludedSurcharge: "座席予約サーチャージ",
    otherTaxes: "その他",
    baseFare: "航空券",
    taxAndSurcharge: "税 / 燃油サーチャージなど",
    arrangeFee: "取扱料金",
    baggage: "預け入れ手荷物",
    itinerary0Baggage: "預け入れ手荷物(往路)",
    itinerary1Baggage: "預け入れ手荷物(復路)"
  }
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/model/chatUnit/ja.js
var ja_chatUnit = {
  priority: {
    a: "高",
    b: "中",
    c: "低",
    d: "自動",
    all: "全て",
    initial: "未設定"
  },
  dealingStep: {
    flight: "フライト",
    hotelTour: "ホテル + 観光",
    support: "質問対応",
    remind: "リマインド",
    all: "全て",
    initial: "未設定"
  },
  dealingStatus: {
    initialWorkRequest: "初期依頼",
    initialWorking: "初期対応",
    workRequest: "依頼",
    regularMemberWorkRequest: "社員依頼",
    priorityWorkRequest: "優先依頼",
    multiCityRequest: "周遊依頼",
    working: "対応中",
    autoWorkRequest: "自動依頼",
    autoWorking: "自動対応中",
    checkRequest: "確認依頼",
    checking: "確認対応中",
    modifyRequest: "修正依頼",
    modifying: "修正対応中",
    waiting: "回答待ち",
    initial: "対応不要",
    request: "依頼",
    all: "全て"
  },
  dealingStatusCategory: {
    all: "全て",
    working: "対応中",
    request: "依頼",
    initialWorkRequest: "初期依頼"
  },
  dealingStatusSubCategory: {
    all: "全て",
    check: "確認",
    regularMember: "社員",
    priority: "優先",
    auto: "自動",
    multiCity: "周遊"
  },
  continent: {
    asia: "アジア",
    north_and_south_america: "北南米",
    europe: "欧州",
    other: "その他",
    all: "全て"
  },
  dealingStepShorthand: {
    flight: "フラ",
    hotelTour: "ホ観",
    support: "質問",
    remind: "追客"
  },
  dealingStatusShorthand: {
    initialWorkRequest: "初期依頼",
    initialWorking: "初対",
    workRequest: "依頼",
    regularMemberWorkRequest: "社員依頼",
    priorityWorkRequest: "優先依頼",
    multiCityRequest: "周遊依頼",
    working: "対中",
    autoWorkRequest: "自動依頼",
    autoWorking: "自動対中",
    checkRequest: "確頼",
    checking: "確中",
    modifyRequest: "修頼",
    modifying: "修中",
    waiting: "回待"
  },
  reservationStatus: {
    reserved: "予約済",
    all: "全て"
  },
  blocked: {
    blocked: "ブロック済",
    none: "なし"
  },
  reserved: "予約済"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/model/optionalTourArrangement/ja.js
var ja_optionalTourArrangement = {
  status: {
    created: "作成済",
    invoiced: "請求済み",
    arranged: "手配済",
    cancelled: "キャンセル済",
    waiting_for_confirmation: "催行待ち",
    ticketed: "発券済み",
    confirmed: "予約確定",
    refunding: "返金依頼中",
    refunded: "返金済み"
  },
  arrangementType: {
    veltra: "VELTRA",
    other: "その他"
  },
  initialCancelPolicy: "▼ 規定について ▼\n"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/model/rentalCarArrangement/ja.js
var ja_rentalCarArrangement = {
  status: {
    created: "作成済",
    arranged: "手配済",
    cancelled: "キャンセル済"
  },
  arrangementType: {
    expedia: "expedia",
    agent_car: "agent_car"
  }
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/model/wifiArrangement/ja.js
var ja_wifiArrangement = {
  status: {
    created: "作成済",
    arranged: "手配済",
    cancelled: "キャンセル済"
  },
  arrangementType: {
    global: "global"
  }
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/model/railwayArrangement/ja.js
var ja_railwayArrangement = {
  status: {
    created: "作成済",
    invoiced: "請求済み",
    arranged: "手配済",
    cancelled: "キャンセル済",
    waiting_for_arrangement: "手配待ち",
    confirmed: "予約確定",
    refunding: "返金依頼中",
    refunded: "返金済"
  },
  arrangementType: {
    tumlare: "tumlare",
    go_euro: "go_euro",
    omio: "omio"
  },
  initialCancelPolicy: "入金後の変更・返金不可です"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/model/cruiseArrangement/ja.js
var ja_cruiseArrangement = {
  status: {
    created: "作成済",
    arranged: "手配済",
    cancelled: "キャンセル済"
  },
  arrangementType: {
    tumlare: "tumlare"
  }
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/model/insuranceArrangement/ja.js
var ja_insuranceArrangement = {
  status: {
    created: "作成済",
    arranged: "手配済",
    cancelled: "キャンセル済"
  },
  arrangementType: {
    tabiho: "tabiho"
  }
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/model/searchInput/ja.js
var ja_searchInput = {
  stringOptions: {
    include_match: "部分一致",
    match: "完全一致",
    forward_match: "前方一致",
    backward_match: "後方一致"
  }
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/model/masterMessage/ja.js
var masterMessage_ja_masterMessage = {
  platformType: {
    all_platform: "全プラットフォーム",
    line: "LINE",
    facebook: "Facebook"
  },
  groupType: {
    greeting: "挨拶",
    hearing: "ヒアリング",
    proposal_starting: "提案開始",
    closing: "予約",
    mine: "自作のみ",
    bot_initial_greeting: "最初のあいさつ",
    bot_remind_hearing: "ヒアリングのリマインド",
    bot_remind_initial_action: "初回アクションのリマインド"
  }
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/model/hotelArrangementPlanPrice/ja.js
var hotelArrangementPlanPrice_ja_hotelArrangementPlanPrice = {
  priceType: {
    baseRate: "客室料金",
    taxAndServiceFee: "税及びサービス料",
    extraPersonFee: "エキストラ料金",
    compensation: "補償",
    propertyFee: "施設料金",
    arrangementFee: "取扱料金"
  }
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/model/hotelArrangementPlanFee/ja.js
var hotelArrangementPlanFee_ja_hotelArrangementPlanFee = {
  feeType: {
    mandatoryFee: "フィー",
    mandatoryTax: "税",
    resortFee: "リゾートフィー"
  }
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/model/otherArrangement/ja.js
var ja_otherArrangement = {
  arrangementType: {
    etas: "ETAS",
    restaurant_reservation_fee: "レストラン予約フィー"
  }
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/model/discount/ja.js
var ja_discount = {
  discountType: {
    campaign: "キャンペーン",
    loss: "損金"
  }
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/model/delayBatchEvent/ja.js
var ja_delayBatchEvent = {
  eventType: {
    auto_reply: "自動返信",
    reminder: "リマインダー",
    scheduled_sending: "時間指定送信"
  }
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/model/scenario/ja.js
var model_scenario_ja_scenario = {
  status: {
    published: "公開",
    close: "非公開"
  },
  chatUnitStatus: {
    hearingDestination: "【ヒアリング】行き先",
    hearingOrigin: "【ヒアリング】出発地",
    hearingSchedule: "【ヒアリング】日程",
    hearingPeople: "【ヒアリング】人数",
    hearingPricePerPerson: "【ヒアリング】予算",
    hearingHope: "【ヒアリング】希望"
  }
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/model/crmMessageSchedule/ja.js
var model_crmMessageSchedule_ja_crmMessageSchedule = {
  status: {
    scheduled: "配信予定",
    processing: "処理中",
    done: "完了"
  }
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/model/masterMessageGroup/ja.js
var ja_masterMessageGroup = {
  groupType: {
    crm: "CRMメッセージ",
    template: "テンプレート"
  }
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/model/ja.js




























var ja_modelJa = {
  common: model_common_ja_common,
  payment: ja_payment,
  charge: ja_charge,
  reservation: model_reservation_ja_reservation,
  hotelArrangement: hotelArrangement_ja_hotelArrangement,
  hotelArrangementPlan: hotelArrangementPlan_ja_hotelArrangementPlan,
  flightArrangement: ja_flightArrangement,
  flightArrangementTraveler: ja_flightArrangementTraveler,
  flightArrangementTravelerOption: ja_flightArrangementTravelerOption,
  flightArrangementOption: ja_flightArrangementOption,
  flightArrangementPrice: flightArrangementPrice_ja_flightArrangementPrice,
  optionalTourArrangement: ja_optionalTourArrangement,
  rentalCarArrangement: ja_rentalCarArrangement,
  wifiArrangement: ja_wifiArrangement,
  railwayArrangement: ja_railwayArrangement,
  cruiseArrangement: ja_cruiseArrangement,
  insuranceArrangement: ja_insuranceArrangement,
  chatUnit: ja_chatUnit,
  searchInput: ja_searchInput,
  masterMessage: masterMessage_ja_masterMessage,
  hotelArrangementPlanPrice: hotelArrangementPlanPrice_ja_hotelArrangementPlanPrice,
  hotelArrangementPlanFee: hotelArrangementPlanFee_ja_hotelArrangementPlanFee,
  otherArrangement: ja_otherArrangement,
  discount: ja_discount,
  delayBatchEvent: ja_delayBatchEvent,
  scenario: model_scenario_ja_scenario,
  crmMessageSchedule: model_crmMessageSchedule_ja_crmMessageSchedule,
  masterMessageGroup: ja_masterMessageGroup
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/unit/en.js
var en_unitEn = {
  piece: "{{quantity}} piece(s)",
  durationOver1Hour: "{{hour}}:{{minute}}",
  durationUnder1Hour: "{{minute}}minutes",
  numberOfConnections_zero: "Direct",
  numberOfConnections_one: "{{count}} Transfer",
  numberOfConnections_other: "{{count}} Transfers",
  days: "{{count}}day",
  grade1: "one star",
  grade2: "two stars",
  grade3: "three stars",
  grade4: "four stars",
  grade5: "five stars",
  people: "{{num}} people",
  person_one: "{{count}} person",
  person_other: "{{count}} people",
  yearsOld: "{{num}} years old",
  rooms: "{{num}} rooms",
  bed_one: "{{count}} {{type}} bed",
  bed_other: "{{count}} {{type}} beds",
  sofaBed_one: "{{count}} {{type}} sofa bed",
  sofaBed_other: "{{count}} {{type}} sofa beds",
  futon_one: "{{count}} {{type}} futon",
  futon_other: "{{count}} {{type}} futons",
  price: "¥{{price}}"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/unit/ja.js
var ja_unitJa = {
  piece: "{{quantity}}個",
  durationOver1Hour: "{{hour}}時間{{minute}}分",
  durationUnder1Hour: "{{minute}}分",
  numberOfConnections_zero: "直行便",
  numberOfConnections_one: "乗換{{count}}回",
  numberOfConnections_other: "乗換{{count}}回",
  days: "{{count}}日",
  grade1: "一ツ星",
  grade2: "二ツ星",
  grade3: "三ツ星",
  grade4: "四ツ星",
  grade5: "五ツ星",
  people: "{{num}}人",
  person_one: "{{count}}名",
  person_other: "{{count}}名",
  yearsOld: "{{num}}歳",
  rooms: "{{num}}室",
  bed_one: "{{type}}ベッド {{count}}台",
  bed_other: "{{type}}ベッド {{count}}台",
  sofaBed_one: "{{type}}ソファベッド {{count}}台",
  sofaBed_other: "{{type}}ソファベッド {{count}}台",
  futon_one: "{{type}}布団 {{count}}組",
  futon_other: "{{type}}布団 {{count}}組",
  price: "{{price}}円"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/button/en.js
var en_buttonEn = {
  add: "ADD",
  save: "SAVE",
  create: "CREATE",
  select: "SELECT",
  edit: "EDIT",
  send: "SEND",
  sendLong: "SEND",
  sendAll: "SEND ALL",
  update: "UPDATE",
  remove: "REMOVE",
  removeAll: "REMOVE ALL",
  close: "CLOSE",
  execute: "EXECUTE",
  executeLong: "EXECUTE",
  register: "REGISTER",
  cease: "CEASE",
  cancel: "CANCEL",
  recreate: "RECREATE",
  search: "SEARCH",
  searchLong: "SEARCH",
  filterBy: "Filter by",
  displayMap: "Display Map",
  done: "DONE",
  createReservationRecord: "Create Record",
  establishTheSale: "Establish The Sale",
  returnThis: "RETURN",
  backToList: "◁ Back to list",
  addMessages: "◁ add messages",
  reserve: "RESERVE",
  reserveInfoOnly: "Reserve info only",
  reserveFlight: "Reserve a flight",
  reserveHotel: "Reserve a hotel",
  changeSearchMode: "Change search mode",
  refundPartial: "Refund partial",
  setAutoReply: "Set auto reply",
  showDetails: "Show Details",
  hideDetails: "Hide Details",
  origin: "DEP",
  destination: "DEST",
  schedule: "SCHED",
  people: "GUEST",
  itineraries: "MULTI",
  hideMemo: "HIDE MEMO",
  showMemo: "SHOW MEMO",
  searchHotel: "SEARCH HOTEL",
  searchNextHotel: "SEARCH NEXT HOTEL",
  createConsultation: "CREATE",
  updateConsultationCondition: "UPDATE",
  addConsultationCondition: "CREATE ADDITIONAL",
  removeLong: "REMOVE",
  detail: "DETAILS",
  researchHotel: "RESEARCH HOTEL",
  researchFlight: "RESEARCH FLIGHT",
  correctPrice: "CORRECT PRICE",
  commissionBack: "COMMISSION BACK",
  restoreReservationForm: "RESTORE RESERVATION FORM",
  displayLeft: "DISPLAY LEFT",
  displayCenter: "DISPLAY CENTER",
  displayRight: "DISPLAY RIGHT",
  addFirst: "ADD FIRST",
  addFirstShort: "ADD FIRST",
  setReminder: "SET REMINDER",
  setScheduledSending: "SET SCHEDULED SENDING",
  disableHearingMode: "DISABLE",
  carousel: "CAROUSEL",
  text: "TEXT",
  createMessage: "CREATE MESSAGE",
  createChargeInfoMessage: "CREATE CHARGE INFO MESSAGE",
  createTicketMessage: "CREATE TICKET MESSAGE",
  createPlanSummary: "CREATE SUMMARY",
  getAutoSuggestion: "AUTO SUGGESTION",
  abortReservation: "ABORT RESERVATION",
  creationOfReservationInfo: "Reservation Information",
  addQuickReplyItem: "Add Quick Reply Item",
  createPreReservationMessage: "CREATE RESERVATION MESSAGE",
  searchByDate: "Search by date",
  searchByPeriod: "Search by period",
  switchNormalLabeledDataSet: "Switch for sending",
  switchMemoLabeledDataSet: "Switch for memo",
  recreateCarousels: "Auto selection of same plan",
  "void": "VOID",
  ticketing: "Ticketing",
  waitingForTicketed: "Waiting TKD",
  ticketed: "Ticketed",
  confirmed: "Confirmed",
  confirming: "Confirming",
  refunding: "Refunding",
  refunded: "Refunded",
  invoiced: "Invoiced",
  arranged: "Arranged",
  waitingForArrangement: "Waiting ARR",
  waitingForConfirmation: "Waiting CFM",
  bulkAction: "BULK ACTION",
  adjustPrice: "ADJUST PRICE",
  addPrice: "ADD PRICE",
  addRefund: "ADD REFUND",
  changeDeadline: "CHANGE D/L",
  addTraveler: "+ ADD TRAVELER",
  removeTraveler: "- REMOVE TRAVELER",
  preReserve: "PRE-BOOK",
  confirmReservation: "CONFIRM THE BOOKING",
  sendEmail: "SEND EMAIL",
  recreateByOneArrangement: "Recreate by one Arrangement",
  selectWithDate: "SELECT WITH DATE",
  addAction: "ADD ACTION",
  removeAction: "REMOVE ACTION",
  addCarousel: "ADD CAROUSEL",
  removeCarousel: "REMOVE CAROUSEL",
  removeThisMessageGroup: "REMOVE THIS MESSAGE GROUP",
  updateThisMessageGroup: "UPDATE THIS MESSAGE GROUP",
  addMessageGroup: "ADD MESSAGE GROUP",
  removeMessageGroup: "REMOVE MESSAGE GROUP",
  updateMessageGroup: "UPDATE MESSAGE GROUP",
  createNew: "CREATE NEW",
  addReply: "ADD REPLY",
  removeReply: "REMOVE REPLY",
  addKeyword: "ADD KEYWORD",
  removeMessage: "REMOVE MESSAGE",
  publishScenario: "PUBLISH SCENARIO",
  closeScenario: "CLOSE SCENARIO",
  inputActionData: "ADD ACTION DATA",
  searchOptionalTour: "SEARCH TOUR",
  reset: "RESET",
  duplicate: "DUPLICATE",
  addCondition: "ADD CONDITION",
  removeCondition: "REMOVE CONDITION",
  addCrmMessageSchedule: "ADD CRM MESSAGE SCHEDULE",
  updateCrmMessageSchedule: "UPDATE CRM MESSAGE SCHEDULE",
  moreActions: "More Actions",
  sendTestMessages: "Send Test Messages",
  registerPassport: "Register Passport",
  addBasicInfo: "Add Basic Info",
  addTour: "Add Tour",
  registerNew: "REGISTER NEW",
  change: "CHANGE",
  "delete": "DELETE"
};
;// CONCATENATED MODULE: ./manager/javascripts/locales/button/ja.js
var ja_buttonJa = {
  add: "追加",
  save: "保存",
  create: "作成",
  select: "選択",
  edit: "編集",
  send: "送信",
  sendLong: "送信する",
  sendAll: "全て送信",
  update: "更新",
  remove: "削除",
  removeAll: "全て削除",
  close: "閉じる",
  execute: "実行",
  executeLong: "実行する",
  register: "登録",
  cease: "中止",
  cancel: "キャンセル",
  recreate: "再作成",
  search: "検索",
  searchLong: "検索する",
  filterBy: "絞り込み",
  displayMap: "地図表示",
  done: "手配完了",
  createReservationRecord: "予約記録作成",
  establishTheSale: "売り上げ確定する",
  returnThis: "返品する",
  backToList: "◁ 一覧に戻る",
  addMessages: "◁ メッセージを追加",
  reserve: "予約する",
  reserveInfoOnly: "予約情報だけ作成",
  reserveFlight: "フライトを予約する",
  reserveHotel: "ホテルを予約する",
  changeSearchMode: "検索モード切替",
  refundPartial: "一部返金",
  setAutoReply: "自動応答にする",
  showDetails: "詳細を表示する",
  hideDetails: "詳細を閉じる",
  origin: "出発地",
  destination: "目的地",
  schedule: "日程",
  people: "人数",
  itineraries: "周遊",
  hideMemo: "メモを隠す",
  showMemo: "メモを表示",
  searchHotel: "ホテルを検索",
  searchNextHotel: "次のホテルを検索",
  createConsultation: "新規作成",
  updateConsultationCondition: "更新",
  addConsultationCondition: "追加で新規作成",
  removeLong: "削除する",
  detail: "詳細",
  researchHotel: "ホテル再検索",
  researchFlight: "フライト再検索",
  correctPrice: "支払登録",
  commissionBack: "コミッションバック",
  restoreReservationForm: "予約フォームを復元",
  displayLeft: "左に表示",
  displayCenter: "中央に表示",
  displayRight: "右に表示",
  addFirst: "先頭に追加する",
  addFirstShort: "先頭に追加",
  setReminder: "リマインダー設定",
  setScheduledSending: "時間指定送信設定",
  disableHearingMode: "解除する",
  carousel: "カルーセル",
  text: "テキスト",
  createMessage: "メッセージを作成する",
  createChargeInfoMessage: "請求メッセージ作成",
  createTicketMessage: "チケットメッセージ作成",
  createPlanSummary: "プラン概要を作成する",
  getAutoSuggestion: "自動で選択",
  abortReservation: "予約を中止する",
  creationOfReservationInfo: "予約情報作成機能",
  addQuickReplyItem: "クイック返信アイテムを追加する",
  createPreReservationMessage: "予約詳細メッセージを作成",
  searchByDate: "日付指定検索",
  searchByPeriod: "期間内最安検索",
  switchNormalLabeledDataSet: "送信用に切り替え",
  switchMemoLabeledDataSet: "メモ用に切り替え",
  recreateCarousels: "同一プランの自動選択",
  "void": "発券キャンセル",
  ticketing: "発券依頼中",
  waitingForTicketed: "発券待ち",
  ticketed: "発券済み",
  confirmed: "予約確定済み",
  confirming: "予約確定予定",
  refunding: "返金依頼中",
  refunded: "返金済み",
  arranged: "仮予約中",
  invoiced: "請求済み",
  waitingForArrangement: "手配待ち",
  waitingForConfirmation: "催行待ち",
  bulkAction: "一括処理",
  adjustPrice: "料金変更",
  addPrice: "料金追加",
  addRefund: "返金登録",
  changeDeadline: "期限変更",
  addTraveler: "+ 旅行者追加",
  removeTraveler: "- 旅行者削除",
  preReserve: "仮予約する",
  confirmReservation: "予約確定する",
  sendEmail: "メールを送信する",
  recreateByOneArrangement: "手配を一つだけ選んで再作成",
  selectWithDate: "日付を指定して選択",
  addAction: "アクションを追加",
  removeAction: "アクションを削除",
  addCarousel: "カルーセルを追加",
  removeCarousel: "カルーセルを削除",
  removeThisMessageGroup: "このメッセージグループを削除",
  updateThisMessageGroup: "このメッセージグループを更新",
  addMessageGroup: "メッセージグループを追加",
  removeMessageGroup: "メッセージグループを削除",
  updateMessageGroup: "メッセージグループを更新",
  createNew: "新規作成",
  addReply: "返信を追加",
  removeReply: "返信を削除",
  addKeyword: "キーワードを追加",
  removeMessage: "メッセージを削除",
  publishScenario: "シナリオを公開する",
  closeScenario: "シナリオを非公開にする",
  inputActionData: "アクションデータを手動入力",
  searchOptionalTour: "現地ツアー検索",
  reset: "リセット",
  duplicate: "複製",
  addCondition: "条件を追加",
  removeCondition: "条件を削除",
  addCrmMessageSchedule: "CRMメッセージスケジュールを追加",
  updateCrmMessageSchedule: "CRMメッセージスケジュールを更新",
  moreActions: "その他の操作",
  sendTestMessages: "テストメッセージを送信",
  registerPassport: "パスポート登録",
  addBasicInfo: "基本情報を追加",
  addTour: "ツアーを追加",
  registerNew: "新規追加",
  change: "変更する",
  "delete": "削除する"
};
;// CONCATENATED MODULE: ./i18n.ts
































void i18next/* default.use */.ZP.use(context/* initReactI18next */.Db).init({
  resources: {
    en: {
      component: componentEn,
      model: modelEn,
      payment: paymentEn,
      constant: constantEn,
      label: labelEn,
      unit: unitEn,
      validation: validationEn,
      button: buttonEn,
      managerLabel: en_labelEn,
      managerConstant: en_constantEn,
      managerComponent: en_componentEn,
      managerMessage: messageEn,
      managerModel: en_modelEn,
      managerUnit: en_unitEn,
      managerButton: en_buttonEn
    },
    ja: {
      component: componentJa,
      model: modelJa,
      payment: paymentJa,
      constant: constantJa,
      label: labelJa,
      unit: unitJa,
      validation: validationJa,
      button: buttonJa,
      managerLabel: ja_labelJa,
      managerConstant: ja_constantJa,
      managerComponent: ja_componentJa,
      managerMessage: messageJa,
      managerModel: ja_modelJa,
      managerUnit: ja_unitJa,
      managerButton: ja_buttonJa
    }
  },
  fallbackLng: "ja",
  lng: "ja",
  interpolation: {
    escapeValue: false // not needed for react

  },
  ns: ["component", "model", "payment", "label", "unit", "validation", "managerLabel", "managerConstant", "managerComponent", "managerMessage", "managerModel", "managerUnit", "managerButton"]
});
/* harmony default export */ var i18n = (i18next/* default */.ZP);

/***/ })

}]);